import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { apiServices } from "../../../services/apiServices";
import moment from "moment";
import swal from "sweetalert";
import Loader from "react-loader-spinner";
import PropTypes from "prop-types";
import QrReader from "react-qr-reader";
import Html5QrcodePlugin from "../../html5qrbarcodescanner/Html5QrBarcodeScanner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ListItem from "@material-ui/core/ListItem";
import List from "@material-ui/core/List";
import {
  faGripLinesVertical,
  faQrcode,
  faTimes,
} from "@fortawesome/free-solid-svg-icons";
import { makeStyles } from "@material-ui/core/styles";
import { useTheme } from "@material-ui/core/styles";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import _, { conforms } from "lodash";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import Customcasescard from "../../../pages/cases/Customcasescard";
import IndividualCasescard from "../../../pages/individualCases/Customcasescard.js";
import IconButton from "@material-ui/core/IconButton";
import CardHeader from "@material-ui/core/CardHeader";

import CloseIcon from "@material-ui/icons/Close";

import Image from "@material-ui/icons/Image";

import CreateField from "../../fields/CreateField";
import CreateSearchField from "../../fields/CreateSearchField";
import CreateStageField from "../../fields/CreateStageField";
//import SeeIndividualRecordAccordian from '../../../pages/seeIndividualRecord/SeeIndividualRecordAccordian'
import RecordHistory from "../../../pages/seeIndividualRecord/RecordHistory";
import { useTranslation, Trans } from "react-i18next";
import "../../../assets/css/customstyles.css";
import OfflineDb from "../../../db";
import { useGlobalSpinnerActionsContext } from "../../../context/GlobalSpinnerContext";
import {
  formValues,
  setPostResgistrationResponse,
  setSelectedTabs,
  setTabHideValues,
} from "../../../redux/actions/action";
import imgUrlArr from '../../../assets/images/imageUrl.js';

import {
  ButtonStrip,
  InputFieldFF,
  SingleSelectFieldFF,
  ReactFinalForm,
  hasValue,
  AlertBar,
  CircularLoader,
  CenteredContent,
} from "@dhis2/ui";
import { useHistory } from "react-router-dom";
import { Configuration as UIConfig } from "../../../assets/data/config";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction"; // needed for dayClick
import TaskList from "../../taskList/TaskList";
import { useSelector, useDispatch } from "react-redux";
import AddIcon from "@material-ui/icons/Add";
import EventNoteIcon from "@material-ui/icons/EventNote";
import VisibilityIcon from "@material-ui/icons/Visibility";
import EditIcon from "@material-ui/icons/Edit";
import GroupIcon from "@material-ui/icons/Group";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import Avatar from "@material-ui/core/Avatar";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import clsx from "clsx";
import Customcaseslist from "../../../pages/cases/Customcaseslist.js";
import PersonIcon from "@material-ui/icons/Person";
import DeleteIcon from "@material-ui/icons/Delete";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import { CheckboxFieldFF } from "@dhis2/ui";
import { QRCodeSVG } from "qrcode.react";
import QRCode from "qrcode.react";
//import SeeIndividualRecordAccordian from '../../../pages/seeIndividualRecord/SeeIndividualRecordAccordian';
import { TextField } from "mui-rff";
//custom radio button
//import Formradio from './formradio.js'

import axios from "axios";
import ImageDatahandle from "../../ocr/ImageDataHandle";

import Camera, { FACING_MODES, IMAGE_TYPES } from "react-html5-camera-photo";
import "react-html5-camera-photo/build/css/index.css";

import ControlCameraIcon from "@material-ui/icons/ControlCamera";

import { downloadSurveyPDF } from "../../pdfUtils.js";

import { useLocation } from "react-router-dom";
import SearchBar from "../../searchbar/SearchBar"; 
//last
const { Form, Field, FormSpy } = ReactFinalForm;

const getTranslatedLabels = (stage) => {
  if (localStorage.getItem("locale") == "en") {
    return stage.displayName;
  } else if (stage.translations && stage.translations.length > 0) {
    //debugger;
    let label = stage.translations.filter(
      (tanslation) =>
        tanslation.property == "NAME" &&
        tanslation.locale == localStorage.getItem("locale")
    );
    if (label.length > 0) {
      return label[0].value;
    } else {
      return stage.displayName;
    }
  }
  return stage.displayName;
};

const getTranslatedDataElementLabels = (dataElement) => {
  if (localStorage.getItem("locale") == "en") {
    return dataElement.formName
      ? dataElement.formName
      : dataElement.displayName
      ? dataElement.displayName
      : dataElement.description;
  } else if (dataElement.translations && dataElement.translations.length > 0) {
    let label = dataElement.translations.filter(
      (tanslation) =>
        tanslation.property == "NAME" &&
        tanslation.locale == localStorage.getItem("locale")
    );
    if (label.length > 0) {
      return label[0].value;
    } else {
      return dataElement.formName
        ? dataElement.formName
        : dataElement.displayName
        ? dataElement.displayName
        : dataElement.description;
    }
  }
  return dataElement.formName
    ? dataElement.formName
    : dataElement.displayName
    ? dataElement.displayName
    : dataElement.description;
};

const getTranslatedDataAttributeLabels = (itemAttributeID,attrData) => {
  let tranlatedAttr;
  attrData.forEach((arr) => {
    if(arr.trackedEntityAttribute.id == itemAttributeID) {
      tranlatedAttr = arr.trackedEntityAttribute;
    }
  })

  if (localStorage.getItem("locale") == "en") {
      return tranlatedAttr.formName ? tranlatedAttr.formName : tranlatedAttr.displayName ? tranlatedAttr.displayName : tranlatedAttr.description;
  } else if (tranlatedAttr.translations && tranlatedAttr.translations.length > 0) {
      //debugger;
      let label = tranlatedAttr.translations.filter(tanslation => tanslation.property == "NAME" && tanslation.locale == localStorage.getItem("locale"))
      if (label.length > 0) {
          return label[0].value;
      } else {
          return  tranlatedAttr.formName ? tranlatedAttr.formName : tranlatedAttr.displayName ? tranlatedAttr.displayName : tranlatedAttr.description;
      }
  }
  return  tranlatedAttr.formName ? tranlatedAttr.formName : tranlatedAttr.displayName ? tranlatedAttr.displayName : tranlatedAttr.description;
  // return item.displayName;
}

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    // backgroundColor: theme.palette.background.paper,
  },
  table: {
    minWidth: 650,
  },
}));

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      className="reginnertabcontainer"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box p={3}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

function SimpleTabs(props) {
  const location = useLocation();
  const theme = useTheme();
  let activeTabs = [];
  let activeTabsOnSubmit = [];
  let updatedStages = [];
  let userData = props.userData;
  let programData = props.programData;
  let programRules = props.programRules.programRules;
  let programRulesVariables = props.programRulesVariables.programRuleVariables;
  let dedupEnabled = props.dedupEnabled;
  let searchEnabled = props.searchEnabled;
  let relationShipId = props.relationShipId;
  let dataElementGroup = props.dataElementGroup.dataElementGroups;
  let geolocation = props.geolocation;
  let currentGeolocation = props.currentGeolocation;
  let OUJSON = props.OUJSON;
  let addindexoffline = false;
  let showStagesIds = props.showStagesId;
  let showCasesInRegistration = props.showCasesInRegistration;
  //let workFlow = programData.programs[0].attributeValues.length > 0 ? programData.programs[0].attributeValues[0].attribute.name == "Is workflow" ? true : false : false
  let workFlow = false;
  try {
    workFlow =
      programData.programs[0].attributeValues.length > 0
        ? _.filter(programData.programs[0].attributeValues, [
            "attribute.name",
            "Is workflow",
          ]) &&
          _.filter(programData.programs[0].attributeValues, [
            "attribute.name",
            "Is workflow",
          ]).length > 0 &&
          _.filter(programData.programs[0].attributeValues, [
            "attribute.name",
            "Is workflow",
          ])[0].value == "true"
          ? true
          : false
        : false;
  } catch (e) {
    console.log(e);
  }
  const history = useHistory();
  const classes = useStyles();
  const [value, setValue] = React.useState(0);
  const [searchTabvalue, setSearchTabValue] = React.useState(0);
  const [activeCaseDetails, setActiveCaseDetails] = useState(null);
  const [activeCaseFormData, setActiveCaseFormData] = useState(null);
  const [linkContactFlag, setLinkContactFlag] = useState(null);
  const [trackentityInstanceDetails, setTrackentityInstanceDetails] =
    useState(null);
  const [newServiceStartFlag, setServiceStartFlag] = useState(false);
  const [searchResponse, setSearchResponse] = React.useState(null);
  const [searchHeader, setSearchHeader] = React.useState(null);
  const [formValuePostDeDup, setFormValuePostDeDup] = React.useState(null);
  const [dataUri, setDataUri] = useState("");
  const [Configuration, setConfiguration] = React.useState(null);
  const [programBoDetails, setProgramBoDetails] = React.useState(null);
  const [openCamera, setCameraStatus] = React.useState(false);
  const [profileimageDataUrl, setProfileimageDataUrl] = React.useState(false);
  const [profileimageUID, setProfileimageUID] = React.useState(false);
  const [showOCRDataPopUp, SetShowOCRDataPopUp] = useState([]);

  //this is for full calender
  const [fullCalendarEvents, setFullCalendarEvents] = useState([]);
  const [isFullCalenderPresentInStage, setIsFullCalenderPresentInStage] =
    useState(false);
  const [fullCalenderSelectedDate, setFullCalenderSelectedDate] =
    useState(null);
  const [dateMedicineTakenId, setDateMedicineTakenId] = useState(null);
  const [medicineTakenId, setMedicineTakenId] = useState(null);
  const [medicineColorCodeId, setMedicineColorCodeId] = useState(null);
  //calendarComponentRef = React.createRef();
  //code for regimen
  const [regimenStageId, setregimenStageId] = useState(null);
  const [adherenceStageId, setAdherenceStageId] = useState(null);
  const [adherenceTBStageId, setAdherenceTBStageId] = useState(null);
  const [adherenceTPTStageId, setAdherenceTPTStageId] = useState(null);
  const [medicineTable, setMedicineTable] = useState([]);
  const [treatmentRegimenId, setTreatmentRegimenId] = useState(null);
  const [treatmentPhaseId, setTreatmentPhaseId] = useState(null);
  const [fixedDoseAdult, setFixedDoseAdult] = useState(null);
  const [fixedDoseChildren, setFixedDoseChildren] = useState(null);
  const [singleDoseAdult, setSingleDoseAdult] = useState(null);
  const [singleDoseChildren, setSingleDoseChildren] = useState(null);
  const [treatmentStartDateId, setTreatmentStartDateId] = useState(null);
  const [treatmentEndDateId, setTreatmentEndDateId] = useState(null);
  const [treatmentDoseId, setTreatmentDoseId] = useState(null);
  const [treatmentAdherenceId, setTreatmentAdherenceId] = useState(null);
  const [medicineRadioId, setMedicineRadioId] = useState(null);

  const [medicineListForCalender, setMedicineListForCalender] = useState([]);
  //custom
  const [rhzRadio, setRhzRadio] = React.useState("yes");
  const [ethambutolRadio, setEthambutolRadio] = React.useState("yes");

  const [radioValue, setRadioValue] = React.useState({});

  // Code for Search start
  const [sessionUserBoValue, setSessionUserBoValue] = useState(null);
  const [metaData, setMetaData] = useState(null);
  const [searchResult, setSearchResult] = useState([]);
  let stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
  // code for link Tab
  const [linkIndexList, setLinkIndexList] = useState([]);
  const [linkContactList, setLinkContactList] = useState([]);
  const [showScanner, setshowScanner] = useState(false);
  const [qrCodeId, setQrCode] = useState(null);

  // Event Data to show Table
  const [eventsData, setEventsData] = useState(null);
  const [editEventsId, setEditEventsId] = useState(null);
  const [stageImageValue, setStageImageValue] = useState(null);
  const [firstNameId, setFirstNameId] = useState(null);
  const [patientNameId, setpatientNameId] = useState(null);
  const [addIndex, setAddIndex] = useState(null);
  const [indexClientList, setIndexClientList] = useState(null);
  const [indexClientOriginalList, setIndexOriginalClientList] = useState(null);
  const [indexClientInstanceId, setIndexClientInstanceId] = useState(null);
  const [childFormValues, setChildFormValues] = useState(null);
  const [parentName, setParentName] = useState(null);
  const [givenName, setGivenName] = useState(null);
  const [regAddressId, setRegAddressId] = useState(false);
  const [dobID, setDobID] = useState(null);
  const [dateOfEnrollmentID, setDateOfEnrollmentID] = useState(null);
  const [registrationID, setregistrationID] = useState(null);
  const [addContactFlag, setAddContactFlag] = useState(false);
  const [ageUID, setAgeUID] = useState(false);
  const [genderUID, setGenderUID] = useState(false);
  const [userrolename, setuserrolename] = React.useState(null);
  const patientRole = "Patient Role";
  const superAdmin = "superuser";
  const [tbTestingStageId, setTbTestingStageId] = useState(null);
  const [tbInfectionTestingStageId, setTbInfectionTestingStageId] =
    useState(null);
  const [tptIntiationStageId, setTptIntiationStageId] = useState(null);
  const [tbTretmentInitiationStageId, setTBTretmentInitiationStageId] =
    useState(false);
  const [mWRDresultId, setmWRDresultId] = useState(null);
  const [CXRresultId, setCXRresultId] = useState(null);
  const [CRPresultId, setCRPresultId] = useState(null);
  const [refertolabfortestingId, setRefertolabfortestingId] = useState(null);
  const [eligibleforTPTId, setEligibleforTPTId] = useState(null);
  const [
    eligibilityforTBinfectiontestingId,
    setEligibilityforTBinfectiontestingId,
  ] = useState(false);
  const [tbTestRusultId, setTBTestRusultId] = useState(false);
  const [noneOptionID, setNoneOptionID] = useState(false);
  const [testingforTBinfectionID, setTestingforTBinfectionID] = useState(false);
  const [symptomsID, setSymptomsID] = useState(false);
  const [CXRreportavailableID, setCXRreportavailableID] = useState(false);
  const [mWRDreportavailableID, setmWRDreportavailableID] = useState(false);
  const [CRPreportavailableID, setCRPreportavailableID] = useState(false);
  const [symptomsDisplayName, setSymptomsDisplayName] = useState(false);
  const [hivStatusId, setHivStatusId] = useState(false);
  const [searchInput, setSearchInput] = useState("");
  // To show image modal
  const [imageResponse, setImageResponse] = React.useState(null);
  const [riskAssementStageId, setRiskAssementStageId] = useState(false);
  const [referralServiceStageId, setReferralServiceStageId] = useState(false);
  const [sampleCollectionStageId, setSampleCollectionStageId] = useState(false);
  const [tptOutcometageId, setTptOutcometageId] = useState(null);
  const [IspatienteligibleforTPTId, setIspatienteligibleforTPTId] =
    useState(null);
  const [IspatienteligibleforTBIId, setIspatienteligibleforTBIId] =
    useState(null);
  const [testresultTBId, setTestresultTBId] = useState(null);
  const [
    HaveyouhadanycontactwithTBdiseasepatientID,
    sethaveyouhadanycontactwithTBdiseasepatientIDID,
  ] = useState(null);
  const [
    Haveyoucomecontactwithsomeonepast5yearsID,
    setHaveyoucomecontactwithsomeonepast5yearsID,
  ] = useState(null);

  //adherence
  const [medicineTakenDateBO, setMedicineTakenDateBO] = useState(null);
  const [calendarStartDate, setcalendarStartDate] = useState(null);
  const [calendarEndDate, setcalendarEndDate] = useState(null);
  const [CalendarSelectedDate, setCalendarSelectedDate] = useState(null);
  const [calendarEventPopup, setCalendarEventPopup] = useState(null);
  const [openEventPopup, setOpenEventPopup] = useState(null);
  const [openMedicineListEventPopup, setOpenMedicineListEventPopup] =
    useState(null);
  const [eventRecordedon, setEventRecordedon] = useState(null);
  const [doseEventStatus, setDoseEventStatus] = useState(null);
  const [reasonForMissedDose, setReasonForMissedDose] = useState(null);
  //Reason for missed dose
  const [reasonForMissedDoseID, setReasonForMissedDoseID] = useState(null);
  const [reasonForMissedDoseBO, setReasonForMissedDoseBO] = useState(null);
  //setMissedDoseInputValue
  const [missedDoseInputValue, setMissedDoseInputValue] = React.useState("");
  const [missedAdherenceActionId, setMissedAdherenceActionId] = useState(null);
  const [treatmentstartedId, setTreatmentstartedId] = useState(null);
  const [missedDoseActionId, setMissedDoseActionId] = useState(null);
  const [dateforinpersonmeetingId, setDateforinpersonmeetingId] =
    useState(null);
  const [adherenceRemarkId, setAdherenceRemarkId] = useState(null);
  const [tptStartRegimenId, setTptStartRegimenId] = useState("");
  const [tptStartRegimen, setTptStartRegimen] = useState("");
  const [anyOther, setanyOther] = useState(null);
  const [plsSpecify, setplsSpecify] = useState(null);
  const [DateoftreatmentinitiatedID, setDateoftreatmentinitiatedID] = useState(null);
  const [DateoftreatmentcompletionID, setDateoftreatmentcompletionID] =
    useState(null);
  const [adverseDrugReaction, setAdverseDrugReaction] = useState(null);
  const [tempMedicineTakenEvent, setTempMedicineTakenEvent] = useState([]);
  const [TreatmentstartdateId, setTreatmentstartdateId] = useState(null);
  const [TreatmentcompletiondateId, setTreatmentcompletiondateId] =
    useState(null);
  const [doseTakenMedicines, setDoseTakenMedicines] = useState(null);
  const [missedDoseMedicines, setMissedDoseMedicines] = useState(null);
  const [referToFacilityCenter, setReferToFacilityCenter] = useState(false);
  const [imageValue, setImageValue] = React.useState(null);
  const [redirectedFromFollowup, setRedirectedFromFollowup] = useState(false)
  useEffect(() => {
    console.log("props.userData;", props.userData)
    if (value == programData.programs[0].programStages.length + stepIncrement) {
      createIndexContactList();
    }
  }, [value]);
  // const [stepIncrement,setStepIncrement] =  useState(1)
  async function getMetaData() {
    let metadata = await OfflineDb.getDataFromPouchDB("metaData");
    setMetaData(metadata.data);

    let loginDetails = await OfflineDb.getDataFromPouchDB("loginDetails");
    setSessionUserBoValue(loginDetails.data);

    let configurations = await OfflineDb.getDataFromPouchDB("configurations");
    console.log("configg", configurations.data.configuration);
    setConfiguration(configurations.data.configuration);

    let programBoDetails = await OfflineDb.getDataFromPouchDB(
      "programBoDetails"
    );
    setProgramBoDetails(programBoDetails.data);

    let redirectedFromFollowUp = await OfflineDb.getDataFromPouchDB(
      "redirectedFromFollowUp"
    );
    setRedirectedFromFollowup(redirectedFromFollowUp)
  }
  useEffect(() => {
    getMetaData();

    return () => {
      OfflineDb.removeDataFromPouchDB("activeCaseDetails");
      OfflineDb.removeDataFromPouchDB("activeCaseFormData");
      OfflineDb.removeDataFromPouchDB("linkContactFlag");
      OfflineDb.removeDataFromPouchDB("redirectedFromFollowUp");
      OfflineDb.setDataIntoPouchDB("transferFlag", { type: null });
    };
  }, []);

  useEffect(() => {
    if (sessionUserBoValue != null) {
      /**SET USER ROLE */
      setuserrolename(
        sessionUserBoValue.userRoles[0].name ||
          sessionUserBoValue.userRoles[0].displayName
      );
    }
  }, [sessionUserBoValue]);

  useEffect(() => {
    console.log(metaData, "metaData");
    //FOR SAMPLE COLLECTION
    getSampleCollectionStageDetail();
    // if(metaData != null)
    // getDetails();
  }, [metaData, Configuration]);
  // Code for Search END
  // New code for table data show

  function getDetails() {
    if (activeCaseDetails && activeCaseDetails.data) {
      setGlobalSpinner(true);
      const programId = metaData.programs[0].id;
      const getURL =
        "trackedEntityInstances/" +
        activeCaseDetails.data.trackedEntityInstance +
        ".json?program=" +
        programId +
        "&fields=*?";
      apiServices
        .getAPI(getURL)
        .then((res) => {
          setGlobalSpinner(false);
          let allEvents = res.data.enrollments[0].events;
          setEventsData(allEvents);
          if (allEvents.length == 0 || allEvents.length < 1) {
            swal({
              title: t("Success"),
              text: t("No records found"),
              icon: "success",
              button: t("Close"),
            }).then((res) => {
              if (res) {
                history.goBack();
                //   history.push('layout/cases')
              }
            });
          }
        })
        .catch((error) => {
          setGlobalSpinner(false);
          swal({
            title: "Error",
            text: error,
            icon: "error",
            button: "Close",
          });
        });
    }
  }

  const setGlobalSpinner = useGlobalSpinnerActionsContext();

  const { t, i18n } = useTranslation();

  //=========for Search UNDP==================
  const [searchFilter, setsearchFilter] = useState({});
  const [stageDetail, setStageDetail] = useState(null);
  const [dataElementDetail, setdataElementDetail] = useState(null);
  const [qrDataElementDetail, setqrDataElementDetail] = useState(null);

  //=========custom logic for UNDP==================
  const [PresentlyOnAntiTBMedicationId, setPresentlyOnAntiTBMedicationId] =
    useState(null);
  const [clientTypeID, setClientTypeID] = useState(null);
  const [verifiedFieldId, setVerifiedFieldId] = useState(null);

  const [specimenStageId, setspecimenStageId] = useState(null);
  const [specimenType, setspecimenType] = useState(null);
  const [dateOfSampleCollection, setdateOfSampleCollection] = useState(null);
  const [specimenid, setspecimenid] = useState(null);
  const [noOfSputumCollected, setnoOfSputumCollected] = useState(null);
  const [sputumQRCode, setsputumQRCode] = useState(null);
  const [sampleCollectionAt, setsampleCollectionAt] = useState(null);
  const [sputumTable, setsputumTable] = useState([]);
  const [searchdata, setsearchdata] = useState(null);
  const [offlineFieldId, setOfflineFieldId] = useState(null);
  const [customfieldobj, setcustomfieldobj] = useState(null);
  const [addressLocationId, setAaddressLocationId] = useState(null);
  const [
    reduxSelectTrackedEntityInstanceId,
    setReduxSelectTrackedEntityInstanceId,
  ] = useState(null);
  const [tbtreatmentinitiatedId, setTbtreatmentinitiatedId] = useState(null);
  const [uicId, setUicId] = useState(null);
  const [lastNameId, setlastNameId] = useState(null);
  const patientroleid =
    Configuration != null ? Configuration.patientroleid : null;
  const patienttrackedInstanceId =
    Configuration != null ? Configuration.patientTrackedInstanceId : null;
  const mainAccountId =
    Configuration != null ? Configuration.mainAccountId : null;
  const userGroupId = Configuration != null ? Configuration.userGroupId : null;
  const [regPhoneNumberId, setRegPhoneNumberId] = useState(false);
  const [regPhoneNumberCodeId, setRegPhoneNumberCodeId] = useState(false);
  const [regRegisteredById, setRegRegisteredById] = useState(false);
  const [referToId, setReferToId] = useState(false);
  const [selectReferralServiceId, setSelectReferralServiceId] = useState(false);
  const [screeningNoneOptionID, setScreeningNoneOptionID] = useState(false);
  const [regPhoneNumberSecondaryId, setRegPhoneNumberSecondaryId] =
    useState(false);
  const [medicineTakenoptions, setMedicineTakenoptions] = useState(null);
  const [medicineTakenBO, setMedicineTakenBO] = useState(null);
  const [MedicineTakenRadioValue, setMedicineTakenRadioValue] = useState(null);
  const [transferInStageId, settransferInStageId] = useState(null);
  const [historyscreeningStageId, sethistoryscreeningStageId] = useState(null);
  const [
    refertonextlevelsecondarytertiarycarecentregeneralcancers,
    setrefertonextlevelsecondarytertiarycarecentregeneralcancers,
  ] = useState(null);
  const [
    refertonextlevelsecondarytertiarycarecentrechildhoodcancer,
    setrefertonextlevelsecondarytertiarycarecentrechildhoodcancer,
  ] = useState(null);
  const [
    refertonextlevelsecondarytertiarycarecentrebreastcancer,
    setrefertonextlevelsecondarytertiarycarecentrebreastcancer,
  ] = useState(null);
  const [
    referforfurtherinvestigationscervicalcancer,
    setreferforfurtherinvestigationscervicalcancer,
  ] = useState(null);
  const [
    referforfurtherinvestigationsortreatment,
    setreferforfurtherinvestigationsortreatment,
  ] = useState(null);
  const [
    referforfurtherinvestigationsdiabetes,
    setreferforfurtherinvestigationsdiabetes,
  ] = useState(null);
  const [
    referforfurtherinvestigationshypertensioncardiovasculardiseases,
    setreferforfurtherinvestigationshypertensioncardiovasculardiseases,
  ] = useState(null);
  const [
    referraltohospitalstertiarycentersStageId,
    setreferraltohospitalstertiarycentersStageId,
  ] = useState(null);

  const [treatmentadherenceStageId, settreatmentadherenceStageId] =
    useState(null);
  const [treatmentinitiationformStageId, settreatmentinitiationformStageId] =
    useState(null);
  const [diagnosisStageId, setdiagnosisStageId] = useState(null);
  const [advancedinvestigationsStageId, setadvancedinvestigationsStageId] =
    useState(null);
  const [initialassessmentStageId, setinitialassessmentStageId] =
    useState(null);

  const [followupStageId, setfollowupStageId] = useState(null);
  const [outcomeStageId, setoutcomeStageId] = useState(null);
  const [summaryStageId, summarycomeStageId] = useState(null);
  //setdateofbirthyearID
  const [dateofbirthyearID, setdateofbirthyearID] = useState(null);
  const [dateofbirthmonthID, setdateofbirthmonthID] = useState(null);
  const [dateofbirthknownID, setdateofbirthknownID] = useState(null);
  const [weinghtID, setweightID] = useState(null);
  const [heightID, setheightID] = useState(null);
  const [heightMostRecent, setheightMostRecent] = useState(null);
  const [heightAtCdicEntry, setheightAtCdicEntry] = useState(null);
  const [weightMostRecent, setweightMostRecent] = useState(null);
  const [weightAtCdicEntry, setweightAtCdicEntry] = useState(null);
  const [BMIMostRecent, setBMIMostRecent] = useState(null);
  const [bmiAtCdicEntry, setbmiAtCdicEntry] = useState(null);
  const [bmiID, setbmiID] = useState(null);
  const [complicationsDataId, setcomplicationsDataId] = useState(null)
  const [addNewServiceFlag,setAddNewServiceFlag] = useState(false)
  const [multiServicesOfflineData,setMultiServicesOfflineData] = useState([])
  function getCustomVariableIds() {
    let tempobj = {};
    programData.programs[0].programTrackedEntityAttributes.map((regField) => {
      let regFieldName = regField.trackedEntityAttribute.description
        ? regField.trackedEntityAttribute.description
        : regField.trackedEntityAttribute.displayName;
      // if (regField.trackedEntityAttribute.displayName.trim().toLocaleLowerCase() == "client type") {
      //     setClientTypeID(regField.trackedEntityAttribute.id)
      // }
      if (
        regField.trackedEntityAttribute.displayName
          .trim()
          .toLocaleLowerCase() == "presently on anti-tb medication?"
      ) {
        setPresentlyOnAntiTBMedicationId(regField.trackedEntityAttribute.id);
      }
      if (
        regField.trackedEntityAttribute.displayName
          .trim()
          .toLocaleLowerCase() == "documents verified"
      ) {
        setVerifiedFieldId(regField.trackedEntityAttribute.id);
      }
      if (
        regField.trackedEntityAttribute.displayName
          .trim()
          .toLocaleLowerCase() == "offlineid"
      ) {
        setOfflineFieldId(regField.trackedEntityAttribute.id);
      }
      if (regFieldName.trim().toLocaleLowerCase() == "client type") {
        setClientTypeID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["clientTypeID"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "uic") {
        setUicId(regField.trackedEntityAttribute.id);
        tempobj = { ...tempobj, ["uicId"]: regField.trackedEntityAttribute.id };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "first name") {
        setFirstNameId(regField.trackedEntityAttribute.id);
        setGivenName(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["firstNameId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName == "Patient Name") {
        setFirstNameId(regField.trackedEntityAttribute.id);
        setpatientNameId(regField.trackedEntityAttribute.id);
        setGivenName(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["patientNameId"]: regField.trackedEntityAttribute.id,
          ["firstNameId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "surname") {
        setlastNameId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["lastNameId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (
        regFieldName.trim().toLocaleLowerCase() == "phone number (permanent)"
      ) {
        setRegPhoneNumberId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regPhoneNumberId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (
        regFieldName.trim().toLocaleLowerCase() == "phone number (secondary)"
      ) {
        setRegPhoneNumberSecondaryId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regPhoneNumberSecondaryId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "code") {
        setRegPhoneNumberCodeId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regPhoneNumberCodeId"]: regField.trackedEntityAttribute.id,
          ["regPhoneNumberCodeBO"]: regField.trackedEntityAttribute,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "registered by") {
        setRegRegisteredById(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regRegisteredById"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "addresslocation") {
        setAaddressLocationId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["addressLocationId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim() == "QR code") {
        setQrCode(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["qrCodeId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "age") {
        setAgeUID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["ageUID"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "gender") {
        setGenderUID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["genderUID"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "date of enrollment") {
        setDateOfEnrollmentID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["dateOfEnrollmentID"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLocaleLowerCase() == "hiv status") {
        setHivStatusId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["hivStatusId"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLocaleLowerCase() == "patient address") {
        setRegAddressId(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["regAddressId"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "date of registration") {
        setregistrationID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["registrationID"]: regField.trackedEntityAttribute.id,
        };
      }

      if (regFieldName.trim().toLowerCase() == "date of birth") {
        setDobID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["dobID"]: regField.trackedEntityAttribute.id,
        };
      }
      //Date of Birth- Year
      if (regFieldName.trim().toLowerCase() == "date of birth- year") {
        setdateofbirthyearID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["dateofbirthyearID"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "date of birth- month") {
        setdateofbirthmonthID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["dateofbirthmonthID"]: regField.trackedEntityAttribute.id,
        };
      }
      if (regFieldName.trim().toLowerCase() == "Date of birth knowh") {
        setdateofbirthknownID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["dateofbirthknownID"]: regField.trackedEntityAttribute.id,
        };
      }
      //setProfileimageUID
      if (regFieldName.trim().toLowerCase() == "profileimage") {
        setProfileimageUID(regField.trackedEntityAttribute.id);
        tempobj = {
          ...tempobj,
          ["profileimageUID"]: regField.trackedEntityAttribute.id,
        };
      }
    });

    programData.programs[0].programStages.map((stage) => {
      let stageName = stage.description ? stage.description : stage.displayName;
      if (stageName.trim() == "TB Infection Testing") {
        setTbInfectionTestingStageId(stage.id);
        tempobj = { ...tempobj, ["tbInfectionTestingStageId"]: stage.id };
      }
      if (stageName.trim() == "Testing Form") {
        setTbTestingStageId(stage.id);
        tempobj = { ...tempobj, ["tbTestingStageId"]: stage.id };
      }
      if (stageName.trim() == "TPT  Initiation Form") {
        setTptIntiationStageId(stage.id);
        tempobj = { ...tempobj, ["tptIntiationStageId"]: stage.id };
      }
      if (stageName.trim() == "TB Treatment Initiation") {
        setTBTretmentInitiationStageId(stage.id);
        tempobj = { ...tempobj, ["tbTretmentInitiationStageId"]: stage.id };
      }
      if (stageName.trim() == "Transfer In") {
        settransferInStageId(stage.id);
        tempobj = { ...tempobj, ["transferInStageId"]: stage.id };
      }
      if (stageName.trim() == "History & Screening") {
        sethistoryscreeningStageId(stage.id);
        tempobj = { ...tempobj, ["historyscreeningStageId"]: stage.id };
      }
      if (stageName.trim() == "Referral to Hospitals/ Tertiary centers") {
        setreferraltohospitalstertiarycentersStageId(stage.id);
        tempobj = {
          ...tempobj,
          ["referraltohospitalstertiarycentersStageId"]: stage.id,
        };
      }

      if (stageName.trim() == "TB Treatment Adherence") {
        setAdherenceTBStageId(stage.id);
        tempobj = {
          ...tempobj,
          adherenceTBStageId: stage.id,
        };
      }
      if (stageName.trim() == "TPT Adherence") {
        setAdherenceTPTStageId(stage.id);
        tempobj = {
          ...tempobj,
          adherenceTPTStageId: stage.id,
        };
      }
      if (stageName.trim() == "Risk Assessment") {
        setRiskAssementStageId(stage.id);
        tempobj = { ...tempobj, ["riskAssementStageId"]: stage.id };
      }
      if (stageName.trim() == "Referral Services") {
        setReferralServiceStageId(stage.id);
        tempobj = { ...tempobj, ["referralServiceStageId"]: stage.id };
      }
      if (stageName.trim() == "Specimen Collection") {
        setSampleCollectionStageId(stage.id);
        tempobj = { ...tempobj, ["sampleCollectionStageId"]: stage.id };
      }
      if (stageName.trim() == "LTBI Outcome") {
        setTptOutcometageId(stage.id);
        tempobj = { ...tempobj, ["tptOutcometageId"]: stage.id };
      }
      if (stageName.trim() == "Advanced Investigations") {
        setadvancedinvestigationsStageId(stage.id);
        tempobj = { ...tempobj, ["advancedinvestigationsStageId"]: stage.id };
      }
      if (stageName.trim() == "Diagnosis") {
        setdiagnosisStageId(stage.id);
        tempobj = { ...tempobj, ["diagnosisStageId"]: stage.id };
      }
      if (stageName.trim() == "Treatment initiation form") {
        settreatmentinitiationformStageId(stage.id);
        tempobj = { ...tempobj, ["treatmentinitiationformStageId"]: stage.id };
      }
      if (stageName.trim() == "Treatment Adherence") {
        settreatmentadherenceStageId(stage.id);
        tempobj = { ...tempobj, ["treatmentadherenceStageId"]: stage.id };
      }
      if (stageName.trim() == "Initial Assessment") {
        setinitialassessmentStageId(stage.id);
        tempobj = { ...tempobj, ["initialassessmentStageId"]: stage.id };
      }
      if (stageName.trim() == "Follow up") {
        setfollowupStageId(stage.id);
        tempobj = { ...tempobj, ["followupStageId"]: stage.id };
      }
      if (stageName.trim() == "Outcome") {
        setoutcomeStageId(stage.id);
        tempobj = { ...tempobj, ["outcomeStageId"]: stage.id };
      }

      if (stageName.trim() == "Complications Data") {
        setcomplicationsDataId(stage.id);
        console.log("vvv", stage)
        tempobj = { ...tempobj, ["complicationsDataId"]: stage.id };
      }

      if (stageName.trim() == "Summary") {
        summarycomeStageId(stage.id);
        tempobj = { ...tempobj, ["summaryStageId"]: stage.id };
      }

      stage.programStageDataElements.map((de) => {
        let fieldname = de.dataElement.description
          ? de.dataElement.description
          : de.dataElement.formName
          ? de.dataElement.formName
          : de.dataElement.displayName;
        if (fieldname) {
          if (fieldname.trim() == "Weight at CDiC entry (Kg)") {
            setweightAtCdicEntry(de.dataElement.id); 
            tempobj = { ...tempobj, ["weightAtCdicEntry"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Height at CDiC entry (m)") {
            setheightAtCdicEntry(de.dataElement.id); 
            tempobj = { ...tempobj, ["heightAtCdicEntry"]: de.dataElement.id };
          }
          if (fieldname.trim() == "BMI at CDiC entry (kg/m2)") {
            setbmiAtCdicEntry(de.dataElement.id);  
            tempobj = { ...tempobj, ["bmiAtCdicEntry"]: de.dataElement.id };
          }

          if (fieldname.trim() == "Weight most recent (Kg)") {
            setweightMostRecent(de.dataElement.id);
            tempobj = { ...tempobj, ["weightMostRecent"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Height most recent (m)") {
            setheightMostRecent(de.dataElement.id);
            tempobj = { ...tempobj, ["heightMostRecent"]: de.dataElement.id };
          }
          if (fieldname.trim() == "BMI most recent (kg/m2)") {
            setBMIMostRecent(de.dataElement.id);
            tempobj = { ...tempobj, ["BMIMostRecent"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Height (in meters)"|| fieldname.trim() == "Height (cm)") {
            setheightID(de.dataElement.id);
            tempobj = { ...tempobj, ["heightID"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Weight (in kg)") {
            setweightID(de.dataElement.id);
            tempobj = { ...tempobj, ["weightID"]: de.dataElement.id };
          }
          if (fieldname.trim() == "BMI") {
            setbmiID(de.dataElement.id);
            tempobj = { ...tempobj, ["bmiID"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Test result (TB)") {
            setTestresultTBId(de.dataElement.id);
            tempobj = { ...tempobj, ["testresultTBId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "TB treatment initiated") {
            setTbtreatmentinitiatedId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["tbtreatmentinitiatedId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Refer to") {
            setReferToId(de.dataElement.id);
            tempobj = { ...tempobj, ["referToId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Select Referral Service") {
            setSelectReferralServiceId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["selectReferralServiceId"]: de.dataElement.id,
            };
          }

          //referral start
          if (fieldname.trim() == "mWRD Result") {
            setmWRDresultId(de.dataElement.id);
            tempobj = { ...tempobj, ["mWRDresultId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "CXR outcome") {
            setCXRresultId(de.dataElement.id);
            tempobj = { ...tempobj, ["CXRresultId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "CRP Result") {
            setCRPresultId(de.dataElement.id);
            tempobj = { ...tempobj, ["CRPresultId"]: de.dataElement.id };
          }

          // if (fieldname.trim() == "Refer to lab for testing") {
          //     setRefertolabfortestingId(de.dataElement.id);
          //     tempobj = { ...tempobj, ['refertolabfortestingId']: de.dataElement.id };
          // }
          //Eligible for TPT
          if (fieldname.trim() == "Eligible for TPT") {
            setEligibleforTPTId(de.dataElement.id);
            tempobj = { ...tempobj, ["eligibleforTPTId"]: de.dataElement.id };
          }
          if (
            fieldname.trim() ==
            "Is the patient directly eligible for LTBI treatment"
          ) {
            setIspatienteligibleforTPTId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["IspatienteligibleforTPTId"]: de.dataElement.id,
            };
          }
          //Eligibility for TB infection testing
          if (fieldname.trim() == "Eligibility for TB infection testing") {
            setIspatienteligibleforTBIId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["IspatienteligibleforTBIId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Lab Test result") {
            //TB Test result
            setTBTestRusultId(de.dataElement.id);
            tempobj = { ...tempobj, ["tbTestRusultId"]: de.dataElement.id };
          }
          //setNoneOptionID
          if (fieldname.trim() == "None") {
            //TB Test result
            setNoneOptionID(de.dataElement.id);
            tempobj = { ...tempobj, ["noneOptionID"]: de.dataElement.id };
            // if(stageName.trim() == "Screening"){
            //     setScreeningNoneOptionID(de.dataElement.id);
            //     tempobj = { ...tempobj, ['screeningNoneOptionID']: de.dataElement.id };
            // }else if(stageName.trim() == "Referral Services"){
            //     setNoneOptionID(de.dataElement.id);
            //     tempobj = { ...tempobj, ['noneOptionID']: de.dataElement.id };
            // }
          }
          //Is testing for TB infection required as per national guidelines?
          if (
            fieldname.trim() ==
            "Is testing for TB infection required as per national guidelines?"
          ) {
            //TB Test result
            setTestingforTBinfectionID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["testingforTBinfectionID"]: de.dataElement.id,
            };
          }

          //setSymptomsID
          if (
            fieldname.trim() ==
            "Currently are you experiencing any of the following symptoms"
          ) {
            //TB Test result
            setSymptomsID(de.dataElement.id);
            tempobj = { ...tempobj, ["symptomsID"]: de.dataElement.id };
            setSymptomsDisplayName(de.dataElement.displayName);
            tempobj = {
              ...tempobj,
              ["symptomsDisplayName"]: de.dataElement.displayName,
            };
          }
          if (fieldname.trim() == "Is CXR report available ?") {
            //Is CXR report available
            setCXRreportavailableID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["CXRreportavailableID"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Is mWRD report available?") {
            //TB Test result
            setmWRDreportavailableID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["mWRDreportavailableID"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Is CRP report available?") {
            //TB Test result
            setCRPreportavailableID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["CRPreportavailableID"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Referral facility") {
            //TB Test result
            setReferToFacilityCenter(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["referToFacilityCenter"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim() ==
            "Have you come in contact with someone who died because of respiratory illness in past 5 years?"
          ) {
            //TB Test result
            setHaveyoucomecontactwithsomeonepast5yearsID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["Haveyoucomecontactwithsomeonepast5yearsID"]: de.dataElement.id,
            };
          }

          if (
            fieldname.trim() ==
            "Have you had any contact with active TB patient?"
          ) {
            //TB Test result
            sethaveyouhadanycontactwithTBdiseasepatientIDID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["HaveyouhadanycontactwithTBdiseasepatientID"]: de.dataElement.id,
            };
          }
          if(fieldname.trim() == "Any other")
          {
            //Checkbox Any other
            setanyOther(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["anyOther"]: de.dataElement.id,
            };
          }
          if(fieldname.trim() == "Pls Specify")
          {
            setplsSpecify(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["plsSpecify"]: de.dataElement.id
            }
          }
          if (fieldname.trim() == "Date of treatment initiated") {
            //Date of treatment completion
            setDateoftreatmentinitiatedID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["DateoftreatmentinitiatedID"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Date of treatment completion") {
            //Date of treatment completion
            setDateoftreatmentcompletionID(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["DateoftreatmentcompletionID"]: de.dataElement.id,
            };
          }
          //setAdverseDrugReaction
          if (fieldname.trim() == "Adverse drug reactions") {
            //Date of treatment completion
            setAdverseDrugReaction(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["adverseDrugReaction"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Reason for missed dose") {
            //Date of treatment completion
            setReasonForMissedDoseID(de.dataElement.id);
            setReasonForMissedDoseBO(de.dataElement);
            tempobj = {
              ...tempobj,
              ["reasonForMissedDoseID"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Regimen") {
            //Date of treatment completion
            setTptStartRegimenId(de.dataElement.id);
            tempobj = { ...tempobj, ["tptStartRegimenId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Missed dose_Action") {
            //Date of treatment completion
            setMissedAdherenceActionId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["missedAdherenceActionId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "LTBI treatment initiated") {
            //Date of treatment completion
            setTreatmentstartedId(de.dataElement.id);
            tempobj = { ...tempobj, ["treatmentstartedId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "TPTAdherence_Remarks") {
            //Date of treatment completion
            setAdherenceRemarkId(de.dataElement.id);
            tempobj = { ...tempobj, ["adherenceRemarkId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "Misseddose_Action") {
            //Date of treatment completion
            setMissedDoseActionId(de.dataElement.id);
            tempobj = { ...tempobj, ["missedDoseActionId"]: de.dataElement.id };
          }
          if (fieldname.trim() == "TPTAdherence_Date for in-person meeting") {
            //Date of treatment completion
            setDateforinpersonmeetingId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["dateforinpersonmeetingId"]: de.dataElement.id,
            };
          }

          if (fieldname.trim() == "Treatment start date") {
            //Date of treatment completion
            setTreatmentstartdateId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["TreatmentstartdateId"]: de.dataElement.id,
            };
          }
          if (fieldname.trim() == "Treatment end date") {
            //Date of treatment completion
            setTreatmentcompletiondateId(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["TreatmentcompletiondateId"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Refer for further investigations - Hypertension & Cardiovascular Diseases"
          ) {
            //Date of treatment completion
            setreferforfurtherinvestigationshypertensioncardiovasculardiseases(
              de.dataElement.id
            );
            tempobj = {
              ...tempobj,
              ["referforfurtherinvestigationshypertensioncardiovasculardiseases"]:
                de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Refer for further investigations - Diabetes"
          ) {
            //Date of treatment completion
            setreferforfurtherinvestigationsdiabetes(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["referforfurtherinvestigationsdiabetes"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() == "Refer for further investigations or Treatment"
          ) {
            //Date of treatment completion
            setreferforfurtherinvestigationsortreatment(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["referforfurtherinvestigationsortreatment"]: de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Refer for further investigations - Cervical Cancer"
          ) {
            //Date of treatment completion
            setreferforfurtherinvestigationscervicalcancer(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["referforfurtherinvestigationscervicalcancer"]:
                de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Refer for further investigations - Cervical Cancer"
          ) {
            //Date of treatment completion
            setreferforfurtherinvestigationscervicalcancer(de.dataElement.id);
            tempobj = {
              ...tempobj,
              ["referforfurtherinvestigationscervicalcancer"]:
                de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Refer To Next Level (SECONDARY/TERTIARY CARE CENTRE) - Breast Cancer"
          ) {
            //Date of treatment completion
            setrefertonextlevelsecondarytertiarycarecentrebreastcancer(
              de.dataElement.id
            );
            tempobj = {
              ...tempobj,
              ["refertonextlevelsecondarytertiarycarecentrebreastcancer"]:
                de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Refer To Next Level (SECONDARY/TERTIARY CARE CENTRE) - Childhood Cancer"
          ) {
            //Date of treatment completion
            setrefertonextlevelsecondarytertiarycarecentrechildhoodcancer(
              de.dataElement.id
            );
            tempobj = {
              ...tempobj,
              ["refertonextlevelsecondarytertiarycarecentrechildhoodcancer"]:
                de.dataElement.id,
            };
          }
          if (
            fieldname.trim() ==
            "Refer To Next Level (SECONDARY/TERTIARY CARE CENTRE) - General Cancers"
          ) {
            //Date of treatment completion
            setrefertonextlevelsecondarytertiarycarecentregeneralcancers(
              de.dataElement.id
            );
            tempobj = {
              ...tempobj,
              ["refertonextlevelsecondarytertiarycarecentregeneralcancers"]:
                de.dataElement.id,
            };
          }

          //end
        }
      });
      stage.attributeValues.map((val) => {
        if (
          val.attribute.displayName === "SpecimenTable" &&
          val.value == "true"
        ) {
          stage.programStageDataElements.map((de) => {
            de.dataElement.attributeValues.map((attr) => {
              if (attr.attribute.displayName === "ShowInTable") {
                if (
                  de.dataElement.displayName.trim().toLocaleLowerCase() ==
                  "specimen type"
                ) {
                  setspecimenType(de.dataElement.id);
                }
                if (
                  de.dataElement.displayName.trim().toLocaleLowerCase() ==
                  "date of sample collection"
                ) {
                  setdateOfSampleCollection(de.dataElement.id);
                }
                if (
                  de.dataElement.displayName.trim().toLocaleLowerCase() ==
                  "specimen id"
                ) {
                  setspecimenid(de.dataElement.id);
                }
                if (
                  de.dataElement.displayName.trim().toLocaleLowerCase() ==
                  "collection interval"
                ) {
                  setnoOfSputumCollected(de.dataElement.id);
                }
                if (
                  de.dataElement.displayName.trim().toLocaleLowerCase() ==
                  "qr code/sample id scan"
                ) {
                  setsputumQRCode(de.dataElement.id);
                }
              }
            });
            if (
              de.dataElement.displayName.trim().toLocaleLowerCase() ==
              "sample collection at"
            ) {
              setsampleCollectionAt(de.dataElement.id);
            }
          });
        }
      });
    });

    setcustomfieldobj(tempobj);
  }

  async function fetchCaseDetailsFromDatabase() {
    let CaseDetails = await OfflineDb.getDataFromPouchDB("activeCaseDetails");
    setActiveCaseDetails(CaseDetails);

    let CaseFormData = await OfflineDb.getDataFromPouchDB("activeCaseFormData");
    setActiveCaseFormData(CaseFormData);

    let ContactFlag = await OfflineDb.getDataFromPouchDB("linkContactFlag");
    setLinkContactFlag(ContactFlag);
  }
  function setRegimenStageDataElements() {
    if (programData.programs[0].programStages.length > 0) {
      programData.programs[0].programStages.map((stage) => {
        if (stage.attributeValues && stage.attributeValues.length > 0) {
          stage.attributeValues.map((val) => {
            if (val.attribute.displayName === "showFullCalender") {
              setAdherenceStageId(stage.id);
              stage.programStageDataElements.map((field) => {
                let fieldname = field.dataElement.description
                  ? field.dataElement.description
                  : field.dataElement.formName
                  ? field.dataElement.formName
                  : field.dataElement.displayName;
                if (
                  fieldname.trim().toLocaleLowerCase() == "date medicine taken"
                ) {
                  setDateMedicineTakenId(field.dataElement.id);
                  setMedicineTakenDateBO(field.dataElement);
                } else if (
                  fieldname.trim().toLocaleLowerCase() == "medicine taken"
                ) {
                  setMedicineTakenId(field.dataElement.id);
                  setMedicineTakenBO(field.dataElement);
                  try {
                    if (
                      field.dataElement.optionSet &&
                      field.dataElement.optionSet.options
                    ) {
                      setMedicineTakenoptions(
                        field.dataElement.optionSet.options
                      );
                    }
                  } catch (e) {
                    console.log(e);
                  }
                } else if (
                  fieldname.trim().toLocaleLowerCase() == "colour code"
                ) {
                  setMedicineColorCodeId(field.dataElement.id);
                }
              });
            } else if (
              val.attribute.displayName === "Regimen" &&
              val.value == "true"
            ) {
              setregimenStageId(stage.id);
              setRegimenStageDEIds(stage);
            } else if (
              val.attribute.displayName === "SpecimenTable" &&
              val.value == "true"
            ) {
              //FOR SPECIMEN COLLECTION STAGE
              setspecimenStageId(stage.id);
            }
          });
        }
      });
    }
  }

  useEffect(() => {
    fetchCaseDetailsFromDatabase();

    return () => {
      localStorage.removeItem("childDropDown");
      // localStorage.removeItem("specimen");
      // localStorage.removeItem("searchtype");
    };
  }, []);

  useEffect(() => {
    if (props.selectTrackedEnityInstanceId) {
      setAddContactFlag(false);
      fetchCaseDetailsFromDatabase();
      setReduxSelectTrackedEntityInstanceId(null);
    }
  }, [props.selectTrackedEnityInstanceId]);

  //this is for UNDP
  useEffect(() => {
    getCustomVariableIds();
    setRegimenStageDataElements();
  }, []);

  useEffect(() => {
    if (
      trackentityInstanceDetails != null &&
      !_.isEmpty(trackentityInstanceDetails) &&
      navigator.onLine
    ) {
      let InitialValueData = {};
      let promises = [];
      const DataElementGroup = dataElementGroup;
      const stageList = programData.programs[0].programStages;
      let registrationData = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.attributes;
      let stageData1 = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.enrollments[0].events;
      let stageData = [];
      let ObjecteHolder = {};
      if (stageList != null) {
        stageList.map((stages) => {
          const filterEvent = stageData1.filter(
            (obj) => obj.programStage == stages.id
          );
          if (filterEvent.length > 1) {
            let sortedEvents = filterEvent.filter(
              (obj) => obj.status != "SCHEDULE"
            );
            if (sortedEvents.length > 0) {
              sortedEvents = _.sortBy(sortedEvents, "created");
              stageData.push(sortedEvents[sortedEvents.length - 1]);
            } else {
            }
          } else if (filterEvent.length == 1) {
            stageData.push(filterEvent[0]);
          }
          // set stage id regimen
          if (stages.attributeValues && stages.attributeValues.length > 0) {
            stages.attributeValues.map((val) => {
              if (
                val.attribute.displayName === "Regimen" &&
                val.value == "true"
              ) {
                if (!_.isEmpty(stageData1)) {
                  getMedicinesListFromEvents(stages);
                } else {
                  setMedicineTable([]);
                }
              } else if (val.attribute.displayName === "showFullCalender") {
                //handleMedicineRadioChange(event,value,name)
                let sortedEvents = _.filter(stageData1, {
                  programStage: stages.id,
                });
                if (sortedEvents.length > 0) {
                  //const grouped = _.groupBy(sortedEvents, { dataValues: ['value']});
                  //console.log("grouped",grouped,dateMedicineTakenId)
                  let finalEvents = _.filter(sortedEvents, {
                    dataValues: [{ dataElement: dateMedicineTakenId }],
                  });
                  //console.log("grouped",sortedEvents,finalEvents,dateMedicineTakenId)
                  let events = [];
                  finalEvents.map((event) => {
                    let mediDateObj = _.filter(event.dataValues, {
                      dataElement: dateMedicineTakenId,
                    });
                    let mediColorCodeObj = _.filter(event.dataValues, {
                      dataElement: medicineColorCodeId,
                    });
                    if (mediDateObj.length > 0 && mediColorCodeObj.length > 0) {
                      let obj = {};
                      obj["start"] = mediDateObj[0].value;
                      obj["end"] = mediDateObj[0].value;
                      obj["allDay"] = true;
                      obj["backgroundColor"] = mediColorCodeObj[0].value;
                      obj["display"] = "background";
                      obj["overlap"] = false;
                      obj["editmode"] = true;
                      events.push(obj);
                    }
                  });
                  events = _.uniqBy(events, "start");
                  //console.log("events ",events);
                  setFullCalendarEvents(events);
                  //console.log("groupedevents",events)
                } else {
                  setFullCalendarEvents([]);
                }
              } else if (
                val.attribute.displayName === "SpecimenTable" &&
                val.value == "true"
              ) {
                if (!_.isEmpty(stageData1)) {
                  // console.log('getdatasputuntable>>>', stages, stageData1, trackentityInstanceDetails)
                  getSputumTableDetail(stages);
                }
              }
            });
          }
        });
      }

      registrationData.map((fields) => {
        const filterField =
          programData.programs[0].programTrackedEntityAttributes.find(
            (obj) => obj.trackedEntityAttribute.id == fields.attribute
          );

        InitialValueData[fields.attribute] = fields.value;

        if (
          filterField &&
          filterField.trackedEntityAttribute &&
          (filterField.trackedEntityAttribute.valueType == "IMAGE" ||
            filterField.trackedEntityAttribute.valueType == "FILE_RESOURCE")
        ) {
          if (fields.value && _.isString(fields.value) && (!fields.value.includes("res.cloudinary.com"))) {
            const resourceGetApi = "fileResources/" + fields.value;
            setImageValue(fields.value);
            promises.push(
              apiServices.getAPI(resourceGetApi).then((resources) => {
                return { dataElement: fields.attribute, value: resources.data };
              })
            );
          }
        }

        try {
          if (
            filterField.trackedEntityAttribute.id == clientTypeID &&
            fields.value == Configuration.ltbiLinkVariables.index
          ) {
            setAddIndex(true);
          }
        } catch (e) {
          console.log(e);
        }
        // multicheckbox edit logic
        programData.programs[0].programSections.map((programSection) => {
          //if (programSection.renderType['DESKTOP'].type == "SEQUENTIAL") {
          programSection.trackedEntityAttributes.map((elements) => {
            if (
              programSection.trackedEntityAttributes.find(
                (array) => array.id == fields.attribute
              )
            ) {
              if (InitialValueData[programSection.id] == undefined) {
                InitialValueData[programSection.id] = [fields.attribute];
              } else {
                if (
                  !InitialValueData[programSection.id].includes(
                    fields.attribute
                  )
                ) {
                  InitialValueData[programSection.id].push(fields.attribute);
                }
              }
            }
          });
          //}
        });
      });

      stageData.map((events) => {
        events.dataValues.map((fields) => {
          if (stageList != null) {
            stageList.map((stages) => {
              const filter = stages.programStageDataElements.filter(
                (obj) => obj.dataElement.id == fields.dataElement
              );

              if (filter.length > 0) {
                if (filter[0].dataElement.fieldMask == "Facility Referral") {
                  try {
                    InitialValueData[fields.dataElement] =
                      fields.value.split(",");
                  } catch (e) {
                    console.log(e);
                  }
                } else if (
                  filter[0].dataElement.valueType == "IMAGE" ||
                  filter[0].dataElement.valueType == "FILE_RESOURCE"
                ) {
                  if (fields.value) {
                    const resourceGetApi = "fileResources/" + fields.value;
                    ObjecteHolder[fields.dataElement] = fields.value;
                    promises.push(
                      apiServices.getAPI(resourceGetApi).then((resources) => {
                        return {
                          dataElement: fields.dataElement,
                          value: resources.data,
                        };
                      })
                    );
                  }
                } else {
                  DataElementGroup.map((DEG) => {
                    // if(DEG.id == "oeixcGpUz9N"){
                    //     return;
                    // }
                    DEG.dataElements.map((dataElements) => {
                      if (
                        DEG.dataElements.find(
                          (array) =>
                            array.id == fields.dataElement &&
                            fields.value == "true"
                        )
                      ) {
                        if (InitialValueData[DEG.id] == undefined) {
                          InitialValueData[DEG.id] = [fields.dataElement];
                        } else {
                          if (
                            !InitialValueData[DEG.id].includes(
                              fields.dataElement
                            )
                          ) {
                            InitialValueData[DEG.id].push(fields.dataElement);
                          }
                        }
                      }
                    });
                  });
                  InitialValueData[fields.dataElement] =
                    fields.value == "false"
                      ? false
                      : fields.value == "true"
                      ? true
                      : fields.value;
                }
              }
            });
          }

          // InitialValueData[fields.dataElement] = fields.value
        });
      });

      setStageImageValue(ObjecteHolder);
      if (promises.length == 0) {
        const activeCaseFormData = {
          data: {
            formFormat: InitialValueData, //valueForFormInput,
            dhisFormat: null, //
          },
        };

        OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
        setActiveCaseFormData(activeCaseFormData);

        if (props.stageTabValue) {
          setValue(props.stageTabValue);
        } else {
          if (
            props.selectTrackedEnityInstanceId &&
            activeCaseDetails &&
            activeCaseDetails.data &&
            props.selectTrackedEnityInstanceId ==
              activeCaseDetails.data.trackedEntityInstance
          ) {
            if (!reduxSelectTrackedEntityInstanceId) {
              setValue(0);
              setReduxSelectTrackedEntityInstanceId(true);
            }
          } else if (value == 0) {
            if(searchEnabled){
                setValue(1)
            }else{
                setValue(0)
            }
          }

          if (userrolename && userrolename == patientRole) {
            const indexOfNextTab =
              programData.programs[0].programStages.findIndex(
                (obj) => obj.id == adherenceStageId
              );
            //console.log("setvalue",value,searchEnabled,indexOfNextTab,adherenceStageId,programData.programs[0].programStages)
            if (searchEnabled) {
              setValue(indexOfNextTab + 2);
            } else {
              setValue(indexOfNextTab + 1);
            }

            if (showStagesIds && showStagesIds.length > 0) {
              let stageIndexId =
                programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == showStagesIds[0]
                );
              if (searchEnabled) {
                setValue(stageIndexId + 2);
              } else {
                setValue(stageIndexId + 1);
              }
            }
          }
          if (userrolename && userrolename.toLowerCase() == superAdmin) {
            setValue(0);
          }
        }
      } else {
        Promise.all(promises).then((responses) => {
          responses.map((response) => {
            InitialValueData[response.dataElement] = [
              new File([""], response.value.displayName, {
                size: response.value.contentLength,
                type: response.value.contentType,
                webkitRelativePath: "",
              }),
            ];
          });
          const activeCaseFormData = {
            data: {
              formFormat: InitialValueData, //valueForFormInput,
              dhisFormat: null, //
            },
          };

          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          setActiveCaseFormData(activeCaseFormData);

          if (props.stageTabValue) {
            setValue(props.stageTabValue);
          } else {
            if (
              props.selectTrackedEnityInstanceId &&
              activeCaseDetails &&
              activeCaseDetails.data &&
              props.selectTrackedEnityInstanceId ==
                activeCaseDetails.data.trackedEntityInstance
            ) {
              if (!reduxSelectTrackedEntityInstanceId) {
                setValue(0);
                setReduxSelectTrackedEntityInstanceId(true);
              }
            } else if (value == 0) {
                if(searchEnabled){
                    setValue(1)
                }else{
                    setValue(0)
                }
            }
          }
          if (userrolename && userrolename.toLowerCase() == superAdmin) {
            setValue(0);
          }
        });
      }

      //FOR SPECIMEN COLLECTION

      //GET SPECIMEN ID
    } /*else{
            // if user is offline 
            const activeCaseFormData = {
                "data": {
                    'formFormat': InitialValueData, //valueForFormInput,
                    'dhisFormat': null //
                }

            }

            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
            setActiveCaseFormData(activeCaseFormData)
        }*/
  }, [trackentityInstanceDetails]);

  useEffect(() => {
    // console.log('activeCaseFormData>>>', activeCaseFormData)
    resetSpecimen();
  }, [activeCaseFormData]);

  useEffect(() => {
    if (activeCaseDetails != null) {
      //DownLoad trackentity instace data using api
      if (activeCaseDetails.data != undefined && navigator.onLine) {
        const getURL =
          "trackedEntityInstances/" +
          activeCaseDetails.data.trackedEntityInstance +
          ".json?program=" +
          programData.programs[0].id +
          "&fields=*?";
        setGlobalSpinner(true);
        apiServices
          .getAPI(getURL)
          .then((trackentityInstanceData) => {
            setGlobalSpinner(false);
            if (trackentityInstanceData.data) {
              setTrackentityInstanceDetails(trackentityInstanceData.data);
            } else {
              setTrackentityInstanceDetails({});
            }
          })
          .catch((err) => {
            setGlobalSpinner(false);
          });
      } else {
        setTrackentityInstanceDetails({});
      }
    }
  }, [activeCaseDetails]);

  useEffect(() => {
    if (activeCaseDetails != null && Configuration != null && programData != null) {
        if(!navigator.onLine){
            console.log("activeCaseDetails ",activeCaseDetails);
            if (activeCaseDetails.data != undefined){
                const stageList = programData.programs[0].programStages
                if (stageList != null) {
                    stageList.map(stages => {
                        if (stages.attributeValues && stages.attributeValues.length > 0) {
                            stages.attributeValues.map((val) => {
                                if (val.attribute.displayName === "Regimen" && val.value == "true") {
                                    OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance).then(res=>{
                                        let offlineEvents = [];
                                        res.services.map(ele => {
                                            ele.events.map(evt => {
                                                offlineEvents.push(evt)
                                            })
                                        })
                                        getMedicinesListFromEvents(stages,offlineEvents)
                                    })
                                }
                            })
                        }
                    })
                }
            }
        }
    }
}, [activeCaseDetails,Configuration,programData])

  useEffect(() => {
    if (
      activeCaseFormData &&
      activeCaseFormData.status != 404 &&
      activeCaseFormData != null &&
      trackentityInstanceDetails != null &&
      localStorage.getItem("searchtype") &&
      localStorage.getItem("specimen")
    ) {
      getSpecimenId();
    }

    if (
      activeCaseFormData &&
      activeCaseFormData.status != 404 &&
      activeCaseFormData != null &&
      searchdata != null &&
      localStorage.getItem("searchtype")
    ) {
      configSpecimenInFormData(searchdata, activeCaseFormData);
    }
  }, [
    activeCaseFormData,
    trackentityInstanceDetails,
    searchdata,
    localStorage.getItem("searchtype"),
    localStorage.getItem("specimen"),
  ]);

  // configSpecimenInFormData({[dv.dataElement]: dv.value})
  // setsearchdata({[dv.dataElement]: dv.value})

  /*useEffect(()=>{
        if(dateMedicineTakenId != null){
            let initialValues = activeCaseFormData.data ? activeCaseFormData.data.formFormat != null ? activeCaseFormData.data.formFormat : {} : {}
            
            if(!_.isEmpty(initialValues)){
                if(initialValues[dateMedicineTakenId]){
                    let events =[{
                        start  : initialValues[dateMedicineTakenId],
                        end    : initialValues[dateMedicineTakenId],
                        allDay : true,
                        backgroundColor: (initialValues[medicineTakenId] && initialValues[medicineTakenId] == 'Yes') ? 
                                        '#4caf50': 
                                        (initialValues[medicineTakenId] && initialValues[medicineTakenId] == 'No') ? 
                                        "#f44336" :
                                        (initialValues[medicineTakenId] && initialValues[medicineTakenId] == 'Partially Taken') ? 
                                        "#ff5722":
                                        "#00bcd4",
                        display: 'background',
                        overlap: false
                    }]
                    setFullCalendarEvents(events)
                }
            }
        }
    },[dateMedicineTakenId])*/

  const getSampleCollectionStageDetail = () => {
    if (metaData != null && Configuration != null) {
      const searchPageMeta = Configuration.searchpage;
      metaData.programs[0].programStages.map((stage) => {
        if (
          stage.description &&
          stage.description === searchPageMeta.searchby.stagename
        ) {
          setStageDetail(stage);
          stage.programStageDataElements.map((field) => {
            if (
              field.dataElement.description ===
              searchPageMeta.searchby.dataelement
            ) {
              setdataElementDetail(field.dataElement);
            }
            if (
              field.renderType &&
              field.renderType["DESKTOP"].type == "QR_CODE"
            ) {
              setqrDataElementDetail(field.dataElement);
            }
          });
        }
      });
    }
  };

  const getSpecimenId = () => {
    if (
      !localStorage.getItem("specimen") &&
      !localStorage.getItem("searchtype")
    ) {
      return;
    }
    let selectedSpecimen = JSON.parse(localStorage.getItem("specimen"));
    let searchType = localStorage.getItem("searchtype");

    let sortedEvents = _.filter(
      trackentityInstanceDetails.enrollments[0].events,
      { programStage: specimenStageId }
    );
    if (sortedEvents.length > 0) {
      // console.log('getSpecimenIdsortedEvents>>>11', selectedSpecimen, sortedEvents)

      sortedEvents.map((event) => {
        let sputumTableObj = {};
        sputumTableObj["eventdetails"] = Object.assign({}, event);
        event.dataValues.map((dv) => {
          // console.log('getSpecimenIdsortedEvents>>>00', dv.dataElement, selectedSpecimen[dv.dataElement])

          if (
            selectedSpecimen.hasOwnProperty(dv.dataElement) &&
            dv.value == selectedSpecimen[dv.dataElement] &&
            searchType == "id"
          ) {
            // console.log('getSpecimenIdsortedEvents>>>22', dv.value)
            setsearchdata({ [dv.dataElement]: dv.value });
          }

          if (
            selectedSpecimen.hasOwnProperty(dv.dataElement) &&
            dv.value == selectedSpecimen[dv.dataElement] &&
            searchType == "qr"
          ) {
            let spid = _.find(event.dataValues, { dataElement: specimenid });
            setsearchdata({ [spid.dataElement]: spid.value });
          }
        });
      });
    }
  };

  const configSpecimenInFormData = (obj, formData) => {
    if (!formData) {
      return;
    }
    if (formData == null) {
      return;
    }
    let formvalues = _.cloneDeep(formData);
    formvalues.data.formFormat[Object.keys(obj)[0]] = Object.values(obj)[0];
    const activeCaseFormData = {
      data: {
        formFormat: formvalues.data.formFormat, //valueForFormInput,
        dhisFormat: null, //
      },
    };
    let tempobj = _.cloneDeep(activeCaseFormData);
    setActiveCaseFormData(tempobj);
    setsearchdata(null);
    localStorage.removeItem("specimen");
    localStorage.removeItem("searchtype");
  };

  const handleChange = (event, newValue) => {
    setValue(newValue);
    if(navigator.onLine){
        checkAndGetAdherenceDetails(newValue, trackentityInstanceDetails);
    }else{
        try{
            OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance).then(res=>{
                checkAndGetAdherenceDetails(newValue,res)
            })
        }catch(e){

        }
    }
  };

  function checkAndGetAdherenceDetails(newValue, eventsData) {
    //multiple adherence handling
    try {
      let stageIndex =
        newValue > 0 ? (searchEnabled ? newValue - 2 : newValue - 1) : null;
        if(!navigator.onLine){
            stageIndex = newValue > 0 ? (newValue - 1) : null
        }
      let isCalendarAttrExist = false;
      if (stageIndex != null) {
        let currentStage = programData.programs[0].programStages[stageIndex];
        //let calendarStage = null
        if (
          currentStage.attributeValues &&
          currentStage.attributeValues.length > 0
        ) {
          currentStage.attributeValues.map((val, i) => {
            if (
              val.attribute.displayName == "showFullCalender" &&
              val.value == "true"
            ) {
              isCalendarAttrExist = true
              setAdherenceStageId(currentStage.id);
              setRadioValue({});
              let dateMedicineTakenID = null;
              let medicineColorCodeID = null;
              let medicineTakenID = null;
              currentStage.programStageDataElements.map((field) => {
                let fieldname = field.dataElement.description
                  ? field.dataElement.description
                  : field.dataElement.formName
                  ? field.dataElement.formName
                  : field.dataElement.displayName;
                if (
                  fieldname.trim().toLocaleLowerCase() ==
                    "date medicine taken" ||
                  fieldname.trim().toLocaleLowerCase() ==
                    "tb_date medicine taken"
                ) {
                  setDateMedicineTakenId(field.dataElement.id);
                  setMedicineTakenDateBO(field.dataElement);
                  dateMedicineTakenID = field.dataElement.id;
                } else if (
                  fieldname.trim().toLocaleLowerCase() == "medicine taken" ||
                  fieldname.trim().toLocaleLowerCase() == "tb_medicine taken"
                ) {
                  setMedicineTakenId(field.dataElement.id);
                  setMedicineTakenBO(field.dataElement);
                  medicineTakenID = field.dataElement.id;
                  try {
                    if (
                      field.dataElement.optionSet &&
                      field.dataElement.optionSet.options
                    ) {
                      setMedicineTakenoptions(
                        field.dataElement.optionSet.options
                      );
                    }
                  } catch (e) {
                    console.log(e);
                  }
                } else if (
                  fieldname.trim().toLocaleLowerCase() == "colour code"
                ) {
                  setMedicineColorCodeId(field.dataElement.id);
                  medicineColorCodeID = field.dataElement.id;
                }
                if (
                  fieldname.trim() == "Reason for missed dose" ||
                  fieldname.trim() == "TBAdherence_Reason for missed dose"
                ) {
                  //Date of treatment completion
                  setReasonForMissedDoseID(field.dataElement.id);
                  setReasonForMissedDoseBO(field.dataElement);
                }
                if (
                  fieldname.trim() == "TPTAdherence_Remarks" ||
                  fieldname.trim() == "TBAdherence_Remarks"
                ) {
                  //Date of treatment completion
                  setAdherenceRemarkId(field.dataElement.id);
                }
                if (
                  fieldname.trim() ==
                    "TPTAdherence_Date for in-person meeting" ||
                  fieldname.trim() == "TBAdherence_Date of in-person meeting"
                ) {
                  //Date of treatment completion
                  setDateforinpersonmeetingId(field.dataElement.id);
                }
                if (
                  fieldname.trim() == "Misseddose_Action" ||
                  fieldname.trim() == "TBAdherence_Missed dose action"
                ) {
                  //Date of treatment completion
                  setMissedDoseActionId(field.dataElement.id);
                }
              });
              let stageData =
                eventsData &&
                eventsData.enrollments &&
                eventsData.enrollments[0]
                  ? eventsData.enrollments[0].events
                  : _.isEmpty(trackentityInstanceDetails)
                  ? []
                  : trackentityInstanceDetails.enrollments[0].events;
                if(!navigator.onLine){
                    let offlineEvents = [];
                    eventsData.services.map(ele => {
                        ele.events.map(evt => {
                            offlineEvents.push(evt)
                        })
                    })
                    stageData = offlineEvents
                }
              let sortedEvents = _.filter(stageData, {
                programStage: currentStage.id,
              });
              //set tpt regimen data
              //console.log("DateoftreatmentinitiatedID ",DateoftreatmentinitiatedID,stageData)
              if (
                DateoftreatmentinitiatedID &&
                currentStage.id == adherenceTPTStageId &&
                tptIntiationStageId
              ) {
                let tptInitiationStageEvent = stageData.filter(
                  (obj) =>
                    obj.programStage == tptIntiationStageId &&
                    obj.status != "SCHEDULE"
                );
                if (tptInitiationStageEvent.length > 0) {
                  tptInitiationStageEvent = _.sortBy(
                    tptInitiationStageEvent,
                    "created"
                  );
                  let finalEvent =
                    tptInitiationStageEvent[tptInitiationStageEvent.length - 1];
                  let treatmentStartDate = _.find(finalEvent.dataValues, {
                    dataElement: DateoftreatmentinitiatedID,
                  });
                  //let treatmentEndDate = _.find(finalEvent.dataValues,{ dataElement: DateoftreatmentcompletionID });
                  let regimen = _.find(finalEvent.dataValues, {
                    dataElement: tptStartRegimenId,
                  });
                  //console.log("tptInitiationStageEvent ",tptInitiationStageEvent,finalEvent,treatmentStartDate)
                  if (treatmentStartDate) {
                    setcalendarStartDate(treatmentStartDate.value);
                  }
                  if (regimen) {
                    setTptStartRegimen(regimen.value);
                  }
                  setcalendarEndDate(null);
                } else {
                  setcalendarStartDate(null);
                  setTptStartRegimen(null);
                  setcalendarEndDate(null);
                }
              } else if (
                TreatmentstartdateId &&
                currentStage.id == adherenceTBStageId &&
                tbTretmentInitiationStageId
              ) {
                let tbInitiationStageEvent = stageData.filter(
                  (obj) =>
                    obj.programStage == tbTretmentInitiationStageId &&
                    obj.status != "SCHEDULE"
                );
                if (tbInitiationStageEvent.length > 0) {
                  tbInitiationStageEvent = _.sortBy(
                    tbInitiationStageEvent,
                    "created"
                  );
                  let finalEvent =
                    tbInitiationStageEvent[tbInitiationStageEvent.length - 1];
                  let treatmentStartDate = _.find(finalEvent.dataValues, {
                    dataElement: TreatmentstartdateId,
                  });
                  let treatmentEndDate = _.find(finalEvent.dataValues, {
                    dataElement: TreatmentcompletiondateId,
                  });
                  if (treatmentStartDate) {
                    setcalendarStartDate(treatmentStartDate.value);
                  } else {
                    setcalendarStartDate(null);
                  }
                  if (treatmentEndDate) {
                    setcalendarEndDate(treatmentEndDate.value);
                  } else {
                    setcalendarEndDate(null);
                  }
                  setTptStartRegimen(null);
                } else {
                  setcalendarStartDate(null);
                  setTptStartRegimen(null);
                }
              } else {
                setcalendarStartDate(null);
                setcalendarEndDate(null);
                setTptStartRegimen(null);
              }
              if (sortedEvents.length > 0) {
                let finalEvents = _.filter(sortedEvents, {
                  dataValues: [{ dataElement: dateMedicineTakenID }],
                });
                let events = [];
                finalEvents.map((event) => {
                  let mediDateObj = _.filter(event.dataValues, {
                    dataElement: dateMedicineTakenID,
                  });
                  let mediColorCodeObj = _.filter(event.dataValues, {
                    dataElement: medicineColorCodeID,
                  });
                  let mediTakenFieldObj = _.filter(event.dataValues, {
                    dataElement: medicineTakenID,
                  });
                  let reasonForMissedDose = reasonForMissedDoseID
                    ? _.find(event.dataValues, {
                        dataElement: reasonForMissedDoseID,
                      })
                    : "";
                  if (mediDateObj.length > 0 && mediColorCodeObj.length > 0) {
                    let obj = {};
                    obj["start"] = mediDateObj[0].value;
                    obj["end"] = mediDateObj[0].value;
                    obj["allDay"] = true;
                    obj["backgroundColor"] = mediColorCodeObj[0].value;
                    obj["display"] = "background";
                    obj["overlap"] = false;
                    obj["editmode"] = true;
                    obj["medicineTaken"] =
                      mediTakenFieldObj && mediTakenFieldObj[0]
                        ? mediTakenFieldObj[0].value
                        : "";
                    if (reasonForMissedDose && reasonForMissedDoseID) {
                      obj["reasonForMissedDose"] = reasonForMissedDose
                        ? reasonForMissedDose.value
                        : false;
                    }
                    events.push(obj);
                  }
                });
                events = _.uniqBy(events, "start");
                setFullCalendarEvents(events);
              } else {
                setFullCalendarEvents([]);
              }
            }
          });
        }
        if((Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]) || !isCalendarAttrExist){
            let allEvents = eventsData && eventsData.enrollments && eventsData.enrollments[0] ? eventsData.enrollments[0].events : _.isEmpty(trackentityInstanceDetails) ? [] : trackentityInstanceDetails.enrollments[0].events
            if(!navigator.onLine){
                let offlineEvents = [];
                eventsData.services.map(ele => {
                    ele.events.map(evt => {
                        offlineEvents.push(evt)
                    })
                })
                allEvents = offlineEvents
            }
            let sortedEvents = allEvents ? _.filter(allEvents, { 'programStage': currentStage.id })  : []
            setMultiServicesOfflineData(sortedEvents)
        }
        //console.log("newValue ",newValue,programData.programs[0].programStages,searchEnabled,stageIndex,currentStage);
      }
    } catch (e) {}
  }

  function fetchActiveTabs(currentStage, formValues) {
    // console.log('currentStageformValues', formValues)
    let Flag = true;
    const values = formValues; //activeCaseFormData.data ? activeCaseFormData.data.formFormat : {}
    // console.log('tabschecking', values)
    let prevStageId = "";
    let workFlowHideFlag = true;
    let submittedEventsList = _.isEmpty(trackentityInstanceDetails)
      ? []
      : trackentityInstanceDetails.enrollments[0].events;
    if (programRules != null && programRulesVariables != null) {
      programRules.map((rules) => {
        const filteredRule = rules.programRuleActions.filter(
          (obj) => obj.programRuleActionType == "HIDEPROGRAMSTAGE"
        );

        if (filteredRule.length > 0) {
          const getStageRule = filteredRule.find(
            (obj) => obj.programStage.id == currentStage.id
          );
          if (getStageRule != undefined) {
            const operators = ["==", "!="];
            const condition = rules.condition;
            const splitConditions = condition.split("&&");

            let val = null;
            let conditionArray = [];
            splitConditions.map((splitCondition) => {
              const variableName = splitCondition.match(/\{(.*?)\}/)[1];
              const parentRaw = programRulesVariables.filter(
                (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
              ); //[0] .dataElement.id
              const parentNameFromFilter =
                parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
              const parentId =
                parentRaw.length > 0
                  ? parentRaw[0].dataElement
                    ? parentRaw[0].dataElement.id
                    : undefined
                  : undefined;

              const parentNameFromFilterStart =
                splitCondition.search(parentNameFromFilter);
              const parentNameLength = parentNameFromFilter
                ? parentNameFromFilter.length
                : undefined;

              const operatorInitLength =
                parentNameFromFilterStart + parentNameLength + 2;

              const operator = splitCondition.substring(
                operatorInitLength,
                operatorInitLength + 2
              );

              const alternateOperatorFinding = operators.map((ops) => {
                if (splitCondition.search(ops) > -1) {
                  const a = {
                    operator: ops,
                    operatorLength: splitCondition.search(ops),
                  };
                  return a;
                }
              });

              const stringLength = splitCondition.length;
              if (parentNameFromFilter) {
                const filteredOperator = alternateOperatorFinding.filter(
                  (obj) => obj != undefined
                );

                const conditionValueRaw =
                  filteredOperator.length > 0
                    ? splitCondition.substring(
                        filteredOperator[0].operatorLength + 3,
                        splitCondition.length
                      )
                    : undefined;

                const removeEmptySpace =
                  conditionValueRaw != undefined
                    ? conditionValueRaw.substring(
                        conditionValueRaw.length - 1,
                        conditionValueRaw.length
                      ) == " "
                      ? conditionValueRaw.substring(
                          0,
                          conditionValueRaw.length - 1
                        )
                      : conditionValueRaw
                    : undefined;

                const conditionValue =
                  removeEmptySpace != undefined
                    ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                    : undefined;
                const conditionalOperator =
                  filteredOperator.length > 0
                    ? filteredOperator[0].operator
                    : undefined;
                let conditionForValidation = null;
                if (conditionalOperator != undefined) {
                  val = conditionValue;
                  switch (conditionalOperator) {
                    case "==":
                      if (values != undefined) {
                        if (
                          values[parentId] != undefined &&
                          String(values[parentId]) == String(conditionValue)
                        ) {
                          Flag = false;
                        } else {
                          Flag = true;
                        }
                      }

                      break;
                  }
                }
              }
            });
          }
        }
      });
    }

    if (Flag == true) {
      if (activeTabsOnSubmit[activeTabsOnSubmit.length - 1]) {
        // console.log('submittedEventsList', submittedEventsList, activeTabsOnSubmit)
        prevStageId = activeTabsOnSubmit[activeTabsOnSubmit.length - 1];
        let filterPrevStageEvents = submittedEventsList.filter(
          (obj) => obj.programStage == prevStageId
        );
        // console.log('filterPrevStageEvents', filterPrevStageEvents)
        if (filterPrevStageEvents.length > 0) {
          const prevStageLatestData = filterPrevStageEvents[0]; //filterPrevStageEvents[filterPrevStageEvents.length - 1]
          const prevStageLatestDataEventId = prevStageLatestData.event;
          const findIndexOfPrevStageLatestDataEventId =
            submittedEventsList.findIndex(
              (obj) => obj.event == prevStageLatestDataEventId
            );
          const findNextIndexOfIndexOfPrevStageLatestDataEventId =
            submittedEventsList[findIndexOfPrevStageLatestDataEventId + 1];

          if (findNextIndexOfIndexOfPrevStageLatestDataEventId == undefined) {
            workFlowHideFlag = false;
          } else {
            workFlowHideFlag = true;
          }
        } else {
          workFlowHideFlag = false;
        }
      } else {
        workFlowHideFlag = true;
      }

      activeTabsOnSubmit.push(currentStage.id);
    } else {
    }
    // console.log('activeTabsOnSubmit', activeTabsOnSubmit)
    return activeTabsOnSubmit;
  }

  function checkTabs(currentStage) {
    // console.log('currentStage', currentStage, trackentityInstanceDetails, activeCaseFormData, programRules, programRulesVariables)
    let Flag = true;
    const values = activeCaseFormData.data
      ? activeCaseFormData.data.formFormat
      : {};
    // console.log('tabschecking', values)
    let prevStageId = "";
    let workFlowHideFlag = true;
    let submittedEventsList = _.isEmpty(trackentityInstanceDetails)
      ? []
      : trackentityInstanceDetails.enrollments[0].events;
    if (programRules != null && programRulesVariables != null) {
      programRules.map((rules) => {
        const filteredRule = rules.programRuleActions.filter(
          (obj) => obj.programRuleActionType == "HIDEPROGRAMSTAGE"
        );

        if (filteredRule.length > 0) {
          const getStageRule = filteredRule.find(
            (obj) => obj.programStage.id == currentStage.id
          );
          if (getStageRule != undefined) {
            const operators = ["==", "!="];
            const condition = rules.condition;
            const splitConditions = condition.split("&&");

            let val = null;
            let conditionArray = [];
            splitConditions.map((splitCondition) => {
              const variableName = splitCondition.match(/\{(.*?)\}/)[1];
              const parentRaw = programRulesVariables.filter(
                (obj) => obj.displayName == splitCondition.match(/\{(.*?)\}/)[1]
              ); //[0] .dataElement.id
              const parentNameFromFilter =
                parentRaw.length > 0 ? parentRaw[0].displayName : undefined;
              const parentId =
                parentRaw.length > 0
                  ? parentRaw[0].dataElement
                    ? parentRaw[0].dataElement.id
                    : undefined
                  : undefined;

              const parentNameFromFilterStart =
                splitCondition.search(parentNameFromFilter);
              const parentNameLength = parentNameFromFilter
                ? parentNameFromFilter.length
                : undefined;

              const operatorInitLength =
                parentNameFromFilterStart + parentNameLength + 2;

              const operator = splitCondition.substring(
                operatorInitLength,
                operatorInitLength + 2
              );

              const alternateOperatorFinding = operators.map((ops) => {
                if (splitCondition.search(ops) > -1) {
                  const a = {
                    operator: ops,
                    operatorLength: splitCondition.search(ops),
                  };
                  return a;
                }
              });

              const stringLength = splitCondition.length;
              if (parentNameFromFilter) {
                const filteredOperator = alternateOperatorFinding.filter(
                  (obj) => obj != undefined
                );

                const conditionValueRaw =
                  filteredOperator.length > 0
                    ? splitCondition.substring(
                        filteredOperator[0].operatorLength + 3,
                        splitCondition.length
                      )
                    : undefined;

                const removeEmptySpace =
                  conditionValueRaw != undefined
                    ? conditionValueRaw.substring(
                        conditionValueRaw.length - 1,
                        conditionValueRaw.length
                      ) == " "
                      ? conditionValueRaw.substring(
                          0,
                          conditionValueRaw.length - 1
                        )
                      : conditionValueRaw
                    : undefined;

                const conditionValue =
                  removeEmptySpace != undefined
                    ? removeEmptySpace.substring(1, removeEmptySpace.length - 1)
                    : undefined;
                const conditionalOperator =
                  filteredOperator.length > 0
                    ? filteredOperator[0].operator
                    : undefined;
                let conditionForValidation = null;
                if (conditionalOperator != undefined) {
                  val = conditionValue;
                  switch (conditionalOperator) {
                    case "==":
                      if (values != undefined) {
                        if (
                          values[parentId] != undefined &&
                          String(values[parentId]) == String(conditionValue)
                        ) {
                          Flag = false;
                        } else {
                          Flag = true;
                        }
                      }

                      break;
                  }
                }
              }
            });
          }
        }
      });
    }

    if (Flag == true) {
      if (activeTabs[activeTabs.length - 1]) {
        // console.log('submittedEventsList', submittedEventsList, activeTabs)
        prevStageId = activeTabs[activeTabs.length - 1];
        let filterPrevStageEvents = submittedEventsList.filter(
          (obj) => obj.programStage == prevStageId
        );
        // console.log('filterPrevStageEvents', filterPrevStageEvents)
        if (filterPrevStageEvents.length > 0) {
          const prevStageLatestData = filterPrevStageEvents[0]; //filterPrevStageEvents[filterPrevStageEvents.length - 1]
          const prevStageLatestDataEventId = prevStageLatestData.event;
          const findIndexOfPrevStageLatestDataEventId =
            submittedEventsList.findIndex(
              (obj) => obj.event == prevStageLatestDataEventId
            );
          const findNextIndexOfIndexOfPrevStageLatestDataEventId =
            submittedEventsList[findIndexOfPrevStageLatestDataEventId + 1];

          if (findNextIndexOfIndexOfPrevStageLatestDataEventId == undefined) {
            workFlowHideFlag = false;
          } else {
            workFlowHideFlag = true;
          }
        } else {
          workFlowHideFlag = false;
        }
      } else {
        workFlowHideFlag = true;
      }

      activeTabs.push(currentStage.id);
    } else {
    }
    //console.log('activeTabs', activeTabs)
    if (workFlow) {
      if (Flag && workFlowHideFlag) {
        return true;
      } else {
        return false;
      }
    } else {
      return Flag;
    }
  }
  // function stageAccessCheck(stages) {
  //     const userList = stages.userAccesses
  //     let stageAcsess = false
  //     const getUSerBo = userData
  //     const filterUserIdInMeta = userList.filter(obj => obj.id == getUSerBo.id)
  //     if (filterUserIdInMeta.length > 0) {
  //         const filteredUserList = filterUserIdInMeta[0].access
  //         if (filteredUserList == 'rw------' || filteredUserList == 'rwrw----') {
  //             stageAcsess = true
  //         }
  //     }
  //     return stageAcsess
  // }

  function stageAccessCheck(stages) {
    const userList = stages.userAccesses;
    const userGroups = stages.userGroupAccesses;
    let stageAcsess = false;
    const getUSerBo = userData;
    const userGroupID =
      getUSerBo.userGroups && getUSerBo.userGroups.length > 0
        ? getUSerBo.userGroups[0].id
        : getUSerBo.id;
    const filterUserIdInMeta =
      userList && userList.length > 0
        ? userList.filter((obj) => obj.id == getUSerBo.id)
        : [];
    const filterUserGroupInMeta =
      userGroups && userGroups.length > 0
        ? userGroups.filter((obj) => obj.id == userGroupID)
        : [];
    if (filterUserIdInMeta.length > 0) {
      const filteredUserList = filterUserIdInMeta[0].access;
      if (filteredUserList == "rw------" || filteredUserList == "rwrw----") {
        stageAcsess = true;
      }
    } else if (filterUserGroupInMeta.length > 0) {
      const filteredUserList = filterUserGroupInMeta[0].access;
      if (filteredUserList == "rw------" || filteredUserList == "rwrw----") {
        stageAcsess = true;
      }
    }
    return stageAcsess;
  }

  function renderRegistrationSections(
    registrationFieldsObj,
    values,
    form,
    programRules,
    icons
  ) {
    // console.log('registrationFieldsObj>>',registrationFieldsObj)
    let sectionWiseDE = [];

    registrationFieldsObj.programSections.map((section,j) => {
      let updateafterapproved = false;

      if (section.renderType.DESKTOP.type == "SEQUENTIAL") {
      } else {
        sectionWiseDE.push(
          <Grid
            container
            spacing={3}
            className="tasklistcontainer sectiondivmaincontainer"
          >
            <Grid item xs={12} sm={12} md={12} className={""}>
              {/* <Grid item xs={12} sm={12} md={12}> */}
              <Accordion defaultExpanded>
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>
                    {t(section.displayName)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography className={""}>
                    {/* <div>
                              <p className="sectionquestiontitle">1.Food Safety</p>
                          </div> */}
                    <div>
                      <Grid container spacing={3} className="">
                        {/* <Grid item xs={12} sm={6} md={6} lg={3}> */}
                        {section.trackedEntityAttributes.map((de,i) => {
                          return registrationFieldsObj.programTrackedEntityAttributes.map(
                            (fields) => {
                              if (de.id == fields.trackedEntityAttribute.id || (j == 0 && i == (section.trackedEntityAttributes.length - 1 ) && fields && fields.trackedEntityAttribute && fields.trackedEntityAttribute.description && fields.trackedEntityAttribute.description == 'ProfileImage')) {
                                ////console.log(de.id, fields.dataElement.id);

                                return renderRegistrationField(
                                  fields,
                                  values,
                                  form,
                                  programRules,
                                  icons,
                                  registrationFieldsObj
                                );
                              }
                            }
                          );
                        })}
                        {/* </Grid> */}
                      </Grid>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        );
      }
    });

    return sectionWiseDE;
  }

  function registerNewUSer(
    saveCaseInput,
    valuesToSave,
    valueForFormInput,
    whatsAppFieldId,
    orgUnit
  ) {
    apiServices
      .postAPI("trackedEntityInstances", saveCaseInput)
      .then((response) => {
        if (
          valueForFormInput["whatsApp"] &&
          valueForFormInput[whatsAppFieldId]
        ) {
          let phoneCode =
            regPhoneNumberCodeId && valueForFormInput[regPhoneNumberCodeId]
              ? valueForFormInput[regPhoneNumberCodeId]
              : "91";
          apiServices
            .getAPI(
              `whatsapp/send/custommessage?phonenumbers=${phoneCode}${valueForFormInput[whatsAppFieldId]}&name=${valueForFormInput[firstNameId]}&uic=${valueForFormInput[uicId]}&msgtype=registration`
            )
            .then((response) => {});
        }

        const trackedEntityInstance =
          response.data.response.importSummaries[0].reference;
        const programId = programData.programs[0].id;
        const enrollmentInputJson = {
          trackedEntityInstance: trackedEntityInstance,
          program: programId,
          status: "ACTIVE",
          orgUnit: orgUnit,
          enrollmentDate: moment().format("YYYY-MM-DD"),
          incidentDate: moment().format("YYYY-MM-DD"),
        };
        //setGlobalSpinner(false)
        const userCreationInput = {
          userCredentials: {
            cogsDimensionConstraints: [],
            catDimensionConstraints: [],
            username: valueForFormInput[uicId],
            password: "Test@123",
            userRoles: [{ id: patientroleid }],
          },
          // "surname": valueForFormInput[lastNameId],
          surname: lastNameId && valueForFormInput[lastNameId] ? valueForFormInput[lastNameId] : "testsurname",
          firstName: valueForFormInput[firstNameId],
          phoneNumber: valueForFormInput[regPhoneNumberId],
          organisationUnits: [{ id: orgUnit }],
          dataViewOrganisationUnits: [{ id: orgUnit }],
          teiSearchOrganisationUnits: [{ id: orgUnit }],
          //"userGroups": [{"id": userGroupId}],
          attributeValues: [
            {
              value: trackedEntityInstance,
              attribute: { id: patienttrackedInstanceId },
            },
            { value: true, attribute: { id: mainAccountId } },
          ],
        };
        //setGlobalSpinner(false)

        apiServices
          .postAPI("users", userCreationInput)
          .then((userResponse) => {
            registartionSuccess();
            setGlobalSpinner(false);
          })
          .catch((err) => {
            setGlobalSpinner(false);
            registartionSuccess();
            // swal({
            //     title: t("Patient registered successfully, but patient has not created as user"),
            //     text: "",
            //     icon: "warning",
            //     button: t("Close"),
            // }).then(userResponse => {
            //     registartionSuccess()
            // });
          });
        //apiServices.postAPI('enrollments', enrollmentInputJson)
        //.then(enrollmentResponse => {
        function registartionSuccess() {
          const enroll = ""; //enrollmentResponse.data.response.importSummaries[0].reference
          if (
            addIndex &&
            programData.programs &&
            programData.programs[0] &&
            programData.programs[0].code != "UNDP"
          ) {
            setParentName(valueForFormInput[givenName]);
            swal({
              title: t("Registered"),
              text: t("Index registered successfully"),
              icon: "success",
              buttons: t("Ok"),
            }).then((AlertRes) => {
              //console.log("AlertRes ",AlertRes);
              if (AlertRes) {
                //console.log("here",AlertRes,childFormValues);
                setAddIndex(null);
                const linkContact = {
                  enabled: true,
                  linkTrackedEntityInstance: trackedEntityInstance,
                };
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
                setLinkContactFlag({
                  data: linkContact,
                });
                let activeCaseDataObj = childFormValues;
                if (regAddressId && valueForFormInput[regAddressId]) {
                  activeCaseDataObj[regAddressId] =
                    valueForFormInput[regAddressId];
                }
                if (addressLocationId && valueForFormInput[addressLocationId]) {
                  activeCaseDataObj[addressLocationId] =
                    valueForFormInput[addressLocationId];
                }
                setActiveCaseFormData({
                  data: {
                    formFormat: activeCaseDataObj, //valueForFormInput,
                    dhisFormat: null, //
                  },
                });
              }
            });
          } else if (
            programData.programs[0].useFirstStageDuringRegistration == false &&
            relationShipId != "" &&
            Configuration.registrationForm.linkContactInAlert
          ) {
            // Not in use
            if (
              valueForFormInput[PresentlyOnAntiTBMedicationId] &&
              valueForFormInput[PresentlyOnAntiTBMedicationId] == "YES" &&
              programData.programs[0].code == "UNDP"
            ) {
              swal({
                title: t("Individual Registered"),
                text: t("Do you want to initiate the individual registration?"),
                icon: "success",
                buttons: [t("No"), t("Yes")],
              }).then((AlertRes) => {
                if (AlertRes) {
                  //save data
                  const activeCaseDetails = {
                    trackedEntityInstance: trackedEntityInstance,
                    enrollmentId: enroll,
                  };
                  const linkContact = {
                    enabled: true,
                    linkTrackedEntityInstance: trackedEntityInstance,
                  };
                  const activeCaseFormData = {
                    formFormat: null, //valueForFormInput,
                    dhisFormat: null, //
                  };
                  // setActiveCaseDetails({
                  //     'data': {

                  //         'trackedEntityInstance': trackedEntityInstance,
                  //         'enrollmentId': enroll,

                  //     }
                  // })

                  OfflineDb.setDataIntoPouchDB(
                    "activeCaseDetails",
                    activeCaseDetails
                  );
                  OfflineDb.setDataIntoPouchDB(
                    "activeCaseFormData",
                    activeCaseFormData
                  );
                  OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                  // setActiveCaseDetails({
                  //     'data': {

                  //         'trackedEntityInstance': trackedEntityInstance,
                  //         'enrollmentId': enroll,

                  //     }
                  // })
                  setLinkContactFlag({
                    data: linkContact,
                  });
                  OfflineDb.setDataIntoPouchDB(
                    "activeCaseDetails",
                    activeCaseDetails
                  );
                  OfflineDb.setDataIntoPouchDB(
                    "activeCaseFormData",
                    activeCaseFormData
                  );
                  OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                  setActiveCaseFormData({
                    data: {
                      formFormat: null, //valueForFormInput,
                      dhisFormat: null, //
                    },
                  });
                  setValue(0);

                  //empty form
                } else {
                  history.push("layout/home");
                }
              });
            } else {
              //save data
              const activeCaseDetails = {
                trackedEntityInstance: trackedEntityInstance,
                enrollmentId: enroll,
              };

              const activeCaseFormData = {
                formFormat: valueForFormInput,
                dhisFormat: valuesToSave,
              };
              const linkContact = {
                enabled: false,
                linkTrackedEntityInstance: trackedEntityInstance,
              };
              OfflineDb.setDataIntoPouchDB(
                "activeCaseDetails",
                activeCaseDetails
              );
              OfflineDb.setDataIntoPouchDB(
                "activeCaseFormData",
                activeCaseFormData
              );
              OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
              swal({
                title: t("Success"),
                text: t("Individual Registered"),
                icon: "success",
                button: t("Close"),
              });
              //laod next active tab
              const nextTab = activeTabs[0];
              if (nextTab) {
                const indexOfNextTab =
                  programData.programs[0].programStages.findIndex(
                    (obj) => obj.id == nextTab
                  );
                setValue(indexOfNextTab + 1);
              } else {
                setValue(value);
              }
              setActiveCaseDetails({
                data: {
                  trackedEntityInstance: trackedEntityInstance,
                  enrollmentId: enroll,
                },
              });
            }
          } else {
            const activeCaseDetails = {
              trackedEntityInstance: trackedEntityInstance,
              enrollmentId: enroll,
            };

            const activeCaseFormData = {
              formFormat: valueForFormInput,
              dhisFormat: valuesToSave,
            };
            const linkContact = {
              enabled: false,
              linkTrackedEntityInstance: trackedEntityInstance,
            };
            OfflineDb.setDataIntoPouchDB(
              "activeCaseDetails",
              activeCaseDetails
            );
            OfflineDb.setDataIntoPouchDB(
              "activeCaseFormData",
              activeCaseFormData
            );
            OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
            swal({
              title: t("Success"),
              text: t("Individual Registered"),
              icon: "success",
              button: t("Close"),
            });
            //save data
            if (
              valueForFormInput[PresentlyOnAntiTBMedicationId] &&
              valueForFormInput[PresentlyOnAntiTBMedicationId] == "YES" &&
              programData.programs[0].code == "UNDP"
            ) {
              const indexOfNextTab =
                programData.programs[0].programStages.findIndex(
                  (obj) => obj.displayName == "TB treatment initiation form"
                );
              setValue(indexOfNextTab + stepIncrement);
            } else {
              //laod next active tab
              const nextTab = activeTabs[0];
              if (nextTab) {
                const indexOfNextTab =
                  programData.programs[0].programStages.findIndex(
                    (obj) => obj.id == nextTab
                  );
                setValue(indexOfNextTab + stepIncrement);
              } else {
                setValue(value);
              }
            }
            setActiveCaseDetails({
              data: {
                trackedEntityInstance: trackedEntityInstance,
                enrollmentId: enroll,
              },
            });
            setActiveCaseFormData({
              data: {
                formFormat: valueForFormInput, //valueForFormInput,
                dhisFormat: valuesToSave, //
              },
            });
          }
        }
        //})
        //setGlobalSpinner(false)
      })
      .catch((err) => {
        swal({
          title: t("Error"),
          text: "",
          icon: "error",
          button: t("Close"),
        });
        setGlobalSpinner(false);
      });
  }

  function renderRegistrationField(registrationFields, values, form) {
    const onGoogleLocatioChangeParent = (value) => {
      values[value.fieldId] = value.value.label;
      if (
        Configuration.registrationForm.googleLocationLatLngFeilds[value.fieldId]
      ) {
        if (
          Configuration.registrationForm.googleLocationLatLngFeilds[
            value.fieldId
          ].lat &&
          Configuration.registrationForm.googleLocationLatLngFeilds[
            value.fieldId
          ].lng
        ) {
          if (value.lat && value.lng) {
            values[
              Configuration.registrationForm.googleLocationLatLngFeilds[
                value.fieldId
              ].lat
            ] = value.lat.toString();
            values[
              Configuration.registrationForm.googleLocationLatLngFeilds[
                value.fieldId
              ].lng
            ] = value.lng.toString();
          }
        }
      }

      const activeCaseFormData = {
        data: {
          formFormat: values, //valueForFormInput,
          dhisFormat: null, //
        },
      };

      OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
      setActiveCaseFormData(activeCaseFormData);
    };
    return (
      <CreateField
        fieldData={registrationFields}
        values={values}
        programRules={programRules}
        programData={programData.programs[0]}
        programRulesVariables={programRulesVariables}
        linkContactFlag={linkContactFlag}
        onGoogleLocatioChangeParent={onGoogleLocatioChangeParent}
        activeCaseDetails={activeCaseDetails}
        OUJSON={OUJSON}
        Configuration={Configuration}
        customfieldobj={customfieldobj}
        currentGeolocation={currentGeolocation}
        userBO={sessionUserBoValue}
        customClassName={
          localStorage.getItem("fontSize")
            ? "FS" + localStorage.getItem("fontSize")
            : ""
        }
        cameraStatus={openCamera}
        cameraClick={() => handleCameraClick(values)}
        cameraClose={() => handleCameraClose(values)}
        imagePath={profileimageDataUrl}
        clearCameraImage={() => removeCameraImage(values)}
      />
    );
  }

  function handleCameraClick(){
    //setGlobalSpinner(true)
    setCameraStatus(true)
  }

  function handleCameraClose(){
      setGlobalSpinner(false)
      setCameraStatus(false)
  }

  function removeCameraImage(){
    setDataUri("");
    setProfileimageDataUrl("")
    console.log("clear img click");
  }

  function renderStageField(fields, values, form, stages, currentStage) {
    if (
      (currentStage.id == referralServiceStageId &&
        values[clientTypeID] == Configuration.ltbiLinkVariables.index &&
        fields.dataElement.id != referToFacilityCenter &&
        fields.dataElement.id != selectReferralServiceId) ||
      (currentStage.id == referralServiceStageId &&
        fields.dataElement.id == symptomsID)
    ) {
      return;
    } else if (
      currentStage.id == adherenceTPTStageId &&
      fields.dataElement &&
      (fields.dataElement.id == dateMedicineTakenId ||
        fields.dataElement.id == medicineTakenId ||
        fields.dataElement.id == medicineTakenId ||
        fields.dataElement.id == medicineColorCodeId ||
        fields.dataElement.id == adherenceRemarkId ||
        fields.dataElement.id == missedDoseActionId ||
        fields.dataElement.id == dateforinpersonmeetingId)
    ) {
      return;
    } else if (
      currentStage.id == adherenceTBStageId &&
      fields.dataElement &&
      (fields.dataElement.id == reasonForMissedDoseID ||
        fields.dataElement.id == adherenceRemarkId ||
        fields.dataElement.id == missedDoseActionId ||
        fields.dataElement.id == dateforinpersonmeetingId)
    ) {
      return;
    } else if (
      currentStage.id == tbTretmentInitiationStageId &&
      fields.dataElement &&
      fields.dataElement.description &&
      fields.dataElement.description == "TBAdherence_Interruption action"
    ) {
      return;
    } else if (
      currentStage.id == tptIntiationStageId &&
      fields.dataElement &&
      missedAdherenceActionId &&
      fields.dataElement.id == missedAdherenceActionId
    ) {
      return;
    } else {
      return (
        <CreateStageField
          fieldData={fields}
          values={values}
          programRules={programRules}
          programData={programData.programs[0]}
          programRulesVariables={programRulesVariables}
          dataElementGroup={dataElementGroup}
          stages={stages}
          orgid={userData.organisationUnits[0].id}
          OUJSON={OUJSON}
          customfieldobj={customfieldobj}
          programBoDetails={programBoDetails}
          Configuration={Configuration}
          customClassName={
            localStorage.getItem("fontSize")
              ? "FS" + localStorage.getItem("fontSize")
              : ""
          }
        />
      );
    }
  }

  function renderStageBySection(stage, values, form, programRules, icons) {
    let sectionWiseDE = [];
    stage.programStageSections.map((section, i) => {
      if (stage.id == adherenceStageId && i == 0) {
      } else {
        sectionWiseDE.push(
          <Grid
            container
            spacing={3}
            className={
              "mb-30px sectiondivmaincontainer section-" + i + "-" + stage.id
            }
            style={i == 0 ? { paddingTop: "30px" } : {}}
          >
            <Grid item xs={12} sm={12} md={12}>
              <Accordion defaultExpanded>
                {/* <Accordion> */}
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography className={classes.heading}>
                    {t(section.name)}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {/* <div>
                                        <p className="sectionquestiontitle">1.Food Safety</p>
                                    </div> */}
                    <div>
                      <Grid container spacing={3} className="">
                        {/* <Grid item xs={12} sm={6} md={6} lg={3}> */}
                        {section.dataElements.map((de) => {
                          return stage.programStageDataElements.map(
                            (fields) => {
                              if (de.id == fields.dataElement.id) {
                                //console.log(de.id, fields.dataElement.id);
                                return renderStageField(
                                  fields,
                                  values ? values : {},
                                  form,
                                  stage.programStageDataElements,
                                  stage
                                );
                              }
                            }
                          );
                        })}
                        {/* </Grid> */}
                      </Grid>
                    </div>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            </Grid>
          </Grid>
        );
      }
    });
    //console.log(sectionWiseDE);
    return sectionWiseDE;
  }

  function checkUserPhoneNumberExist(valueForFormInput, callback) {
    if (
      programData &&
      programData.programs &&
      programData.programs[0] &&
      programData.programs[0].code &&
      programData.programs[0].code == "Zambia_Program"
    ) {
      try {
        if (
          regPhoneNumberSecondaryId &&
          valueForFormInput[regPhoneNumberSecondaryId] &&
          valueForFormInput[regPhoneNumberSecondaryId] ==
            valueForFormInput[regPhoneNumberId]
        ) {
          swal({
            title: t(
              "Permanent and secondary phone numbers entered are the same. Please enter different phone numbers."
            ),
            text: "",
            icon: "warning",
            buttons: t("Ok"),
          });
          return;
        }
        if (
          activeCaseFormData &&
          activeCaseFormData.data &&
          activeCaseFormData.data.formFormat &&
          activeCaseFormData.data.formFormat[regPhoneNumberId]
        ) {
          if (
            activeCaseFormData.data.formFormat[regPhoneNumberId] ==
            valueForFormInput[regPhoneNumberId]
          ) {
            callback(true);
            return;
          }
        }
        if (navigator.onLine) {
          setGlobalSpinner(true);
          apiServices
            .getAPI(
              `users?fields=[id,displayName,attributeValues]&phoneNumber=${valueForFormInput[regPhoneNumberId]}`
            )
            .then((response) => {
              setGlobalSpinner(false);
              console.log("response ", response);
              if (response && response.data) {
                if (response.data.users && response.data.users.length > 0) {
                  swal({
                    title: t(
                      "The entered phone number is already registered on the system. Do you want to continue?"
                    ),
                    text: "",
                    icon: "warning",
                    buttons: [t("No"), t("Yes")],
                  }).then((AlertRes) => {
                    if (AlertRes) {
                      callback(true);
                    } else {
                      //callback(false)
                    }
                  });
                } else {
                  callback(true);
                }
              } else {
                callback(true);
              }
            })
            .catch((err) => {
              setGlobalSpinner(false);
              callback(true);
            });
        } else {
          setGlobalSpinner(false);
          callback(true);
        }
      } catch (e) {
        setGlobalSpinner(false);
        callback(true);
      }
    } else {
      callback(true);
    }
  }

  function saveRegData(valuesToSave, valueForFormInput) {
    try{
        const offlineUIC = (len, chars='A0B1C2D3E4F5G6H7I8J9K0L1M2N3O4P5Q6R7S8T9U0V1W2X3Y4Z5') => [...Array(len)].map(() => chars.charAt(Math.floor(Math.random() * chars.length))).join('')
        if(!navigator.onLine){
            let checkUic = _.find(valuesToSave,{"attribute":customfieldobj.uicId})
        if(!checkUic && !valueForFormInput[customfieldobj.uicId]){
                valueForFormInput[customfieldobj.uicId] = "OFF"+offlineUIC(12)
                valuesToSave.push({"attribute":customfieldobj.uicId,"value":"OFF"+offlineUIC(12)})
        }
        }
    }catch(e){}
    if (
      !navigator.onLine &&
      valueForFormInput[clientTypeID] &&
      valueForFormInput[clientTypeID] == Configuration.ltbiLinkVariables.contact
    ) {
      swal({
        title: t("Alert"),
        text: t(
          "Please link index first to register offline contact client. Do you want to register new Index client in offline for contact linking?"
        ),
        icon: "warning",
        buttons: [t("Cancel"), t("Ok")],
      }).then((AlertRes) => {
        //console.log("AlertRes ",AlertRes,value);
        if (AlertRes) {
          setValue(0);
          renderIndexForm(valueForFormInput);
        } else {
        }
      });
      return;
    }
    if (
      valueForFormInput[clientTypeID] &&
      valueForFormInput[clientTypeID] == Configuration.ltbiLinkVariables.contact
    ) {
      swal({
        title: t("Alert"),
        text: t("Please link/attach index first to register contact client!"),
        icon: "warning",
        buttons: [t("Cancel"), t("Attach Index")],
      }).then((AlertRes) => {
        console.log("AlertRes ", AlertRes);
        if (AlertRes) {
          openIndexClientModal(valueForFormInput);
        } else {
        }
      });
      return;
    }
    checkUserPhoneNumberExist(valueForFormInput, function (callbackRes) {
      const orgUnit = userData.organisationUnits[0].id;
      const trackedEntityType = programData.programs[0].trackedEntityType.id;
      let registrationFields =
        programData.programs[0].programTrackedEntityAttributes;
      let whatsAppFieldId = "";

      registrationFields.map((regField) => {
        const findWhatsAppAttribute =
          regField.trackedEntityAttribute.attributeValues.find(
            (x) => x.attribute.name == "WhatsAppNumber"
          );
        if (findWhatsAppAttribute) {
          whatsAppFieldId = regField.trackedEntityAttribute.id;
        }
      });

      let saveCaseInput = {
        trackedEntityType: trackedEntityType,
        orgUnit: orgUnit,
        attributes: valuesToSave,
        enrollments: [
          {
            //"trackedEntityInstance": trackedEntityInstance,
            program: programData.programs[0].id,
            //"status": "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          },
        ],
        geometry: {
          type: "Point",
          coordinates: [currentGeolocation.lng, currentGeolocation.lat],
        },
      };

      let searchableFields = [];
      let searchQuery = ``;
      if (qrCodeId && valueForFormInput && !valueForFormInput[qrCodeId]) {
        var code = generateQRCode(8);
        let qrcode = { attribute: qrCodeId, value: code };
        valuesToSave.push(qrcode);
        valueForFormInput[qrCodeId] = code;
      }
      if (navigator.onLine) {
        if (dedupEnabled) {
          setGlobalSpinner(true);
          registrationFields.map((fields) => {
            if (
              (fields.searchable == true || fields.fields == "true") &&
              fields.trackedEntityAttribute.displayName.trim().toLowerCase() !=
                "qr code"
            ) {
              searchableFields.push(fields.trackedEntityAttribute.id);
            }
          });

          searchableFields.map((searchableField) => {
            if (
              valuesToSave.find((obj) => obj.attribute == searchableField) !=
              undefined
            ) {
              const findValue = valuesToSave.find(
                (obj) => obj.attribute == searchableField
              );
              searchQuery += `&attribute=${searchableField}:LIKE:${findValue.value}`;
            }
          });
          let subURL =
            "trackedEntityInstances/query.json?ou=" +
            orgUnit +
            "&ouMode=ACCESSIBLE&&order=created:desc&program=" +
            programData.programs[0].id +
            searchQuery +
            "&pageSize=50&page=1&totalPages=false&skipPaging=true";
          apiServices.getAPI(subURL).then((searchResponse) => {
            setGlobalSpinner(false);

            if (searchResponse.data.rows.length > 0) {
              try {
                searchResponse.data.headers.map((ele) => {
                  if (ele.column && metaData) {
                    let fieldBO = _.find(metaData.trackedEntityAttributes, {
                      displayName: ele.column,
                    });
                    if (fieldBO && ele.column != fieldBO.description) {
                      ele.column = fieldBO.description;
                    }
                  }
                });
              } catch (e) {
                console.log(e);
              }
              setSearchHeader(searchResponse.data.headers);
              setSearchResponse(searchResponse.data.rows);
              setFormValuePostDeDup({
                valuesToSave: valuesToSave,
                valueForFormInput: valueForFormInput,
              });
            } else {
              setGlobalSpinner(true);
              registerNewUSer(
                saveCaseInput,
                valuesToSave,
                valueForFormInput,
                whatsAppFieldId,
                orgUnit
              );
            }
          });
        } else {
          setGlobalSpinner(true);
          registerNewUSer(
            saveCaseInput,
            valuesToSave,
            valueForFormInput,
            whatsAppFieldId,
            orgUnit
          );
        }
      } else {
        setGlobalSpinner(true)
        //OfflineStorage
        OfflineDb.getAllEntities().then((res) => {
          if (res && res.total_rows == Configuration.offline.storagelimit) {
            setGlobalSpinner(false)
            swal({
              title: t("LIMIT EXCEEDED"),
              text: t(
                `you have reached a limit of ${Configuration.offline.storagelimit} records, please sync offline records and try again`
              ),
              icon: "warning",
              button: t("Close"),
            });
          } else {
            //console.log('valuesToSave, valueForFormInput',valuesToSave, valueForFormInput,offlineFieldId)
            //valueForFormInput[offlineFieldId] = Date.now();
            //console.log(' valueForFormInput', valueForFormInput)
            //return;
            let offlineObj = {
              data: valueForFormInput,
              registration: saveCaseInput,
              services: [],
              formVersion: programData.programs[0].version,
            };
            OfflineDb.saveEntity(offlineObj).then((res) => {
                setGlobalSpinner(false)
              if (
                (addIndex || addindexoffline) &&
                programData.programs &&
                programData.programs[0] &&
                programData.programs[0].code != "UNDP"
              ) {
                setParentName(valueForFormInput[givenName]);
                swal({
                  title: t("Registered"),
                  text: t(
                    "Index registered and attached in offline successfully"
                  ),
                  icon: "success",
                  buttons: t("Ok"),
                }).then((AlertRes) => {
                  //console.log("AlertRes ",AlertRes);
                  if (AlertRes) {
                    //console.log("here",AlertRes,childFormValues);
                    setAddIndex(null);
                    console.log("offlineobj0 ", res);
                    const linkContact = {
                      enabled: true,
                      linkTrackedEntityInstance: res.id,
                    };
                    OfflineDb.setDataIntoPouchDB(
                      "linkContactFlag",
                      linkContact
                    );
                    setLinkContactFlag({
                      data: linkContact,
                    });
                    let activeCaseDataObj = childFormValues;
                    if (regAddressId && valueForFormInput[regAddressId]) {
                      activeCaseDataObj[regAddressId] =
                        valueForFormInput[regAddressId];
                    }
                    if (
                      addressLocationId &&
                      valueForFormInput[addressLocationId]
                    ) {
                      activeCaseDataObj[addressLocationId] =
                        valueForFormInput[addressLocationId];
                    }
                    setActiveCaseFormData({
                      data: {
                        formFormat: activeCaseDataObj, //valueForFormInput,
                        dhisFormat: null, //
                      },
                    });

                    addindexoffline = false;

                    // history.push("layout/home");
                  }
                });
              } else {
                const activeCaseDetails = {
                  trackedEntityInstance: res.id,
                  enrollmentId: "",
                };
                const activeCaseFormData = {
                  formFormat: valueForFormInput,
                  dhisFormat: valuesToSave,
                };
                const linkContact = {
                  enabled: false,
                  linkTrackedEntityInstance: res.id,
                };

                setActiveCaseDetails({
                  data: {
                    trackedEntityInstance: res.id,
                    enrollmentId: "",
                  },
                });
                setActiveCaseFormData({
                  data: activeCaseFormData,
                });
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseDetails",
                  activeCaseDetails
                );
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
                swal({
                  title: t("Success"),
                  text: t("Individual registered offline successfully"),
                  icon: "success",
                  button: t("Close"),
                });
                if (
                  valueForFormInput[PresentlyOnAntiTBMedicationId] &&
                  valueForFormInput[PresentlyOnAntiTBMedicationId] == "YES" &&
                  programData.programs[0].code == "UNDP"
                ) {
                  const indexOfNextTab =
                    programData.programs[0].programStages.findIndex(
                      (obj) => obj.displayName == "TB treatment initiation form"
                    );
                  setValue(indexOfNextTab + stepIncrement);
                } else {
                  //laod next active tab
                  const nextTab = activeTabs[0];
                  if (nextTab) {
                    const indexOfNextTab =
                      programData.programs[0].programStages.findIndex(
                        (obj) => obj.id == nextTab
                      );
                    setValue(indexOfNextTab + stepIncrement);
                  } else {
                    setValue(value);
                  }
                }
                //   if (
                //     valueForFormInput[PresentlyOnAntiTBMedicationId] &&
                //     valueForFormInput[PresentlyOnAntiTBMedicationId] == "Yes"
                //     && programData && programData.programs && programData.programs[0] && programData.programs[0].code == "UNDP"
                //   ) {
                //     swal({
                //       title: t("Registered"),
                //       text: t("Offline: Client registered as Index"),
                //       icon: "success",
                //       buttons: t("Ok"),
                //     }).then((AlertRes) => {
                //       console.log("AlertRes ", AlertRes);
                //       if (AlertRes) {
                //         history.push("layout/home");
                //       }
                //     });
                //   } else {
                //     swal({
                //       title: t("Success"),
                //       text: t("Client registered successfully in offline"),
                //       icon: "success",
                //       button: t("Close"),
                //     });
                //     //save data

                //     //laod next active tab
                //     const nextTab = activeTabs[0];
                //     if (nextTab) {
                //       const indexOfNextTab =
                //         programData.programs[0].programStages.findIndex(
                //           (obj) => obj.id == nextTab
                //         );

                //       setValue(indexOfNextTab + stepIncrement);
                //     } else {
                //       setValue(value);
                //     }
                //   }
              }
            });
          }
        });
      }
    });
  }

  function generateQRCode(length) {
    var result = "";
    var characters =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    var charactersLength = characters.length;
    for (var i = 0; i < length; i++) {
      result += characters.charAt(Math.floor(Math.random() * charactersLength));
    }
    return "dureProg_" + result;
  }

  function linkeRegData(valuesToSave, valueForFormInput) {
    const orgUnit = userData.organisationUnits[0].id;
    const trackedEntityType = programData.programs[0].trackedEntityType.id;
    let registrationFields =
      programData.programs[0].programTrackedEntityAttributes;
    if (qrCodeId && valueForFormInput && !valueForFormInput[qrCodeId]) {
      var code = generateQRCode(8);
      let qrcode = { attribute: qrCodeId, value: code };
      valuesToSave.push(qrcode);
      valueForFormInput[qrCodeId] = code;
    }
    let saveCaseInput =
      //{
      //     "trackedEntityType": trackedEntityType,
      //     "orgUnit": orgUnit,
      //     "attributes": valuesToSave
      // }

      {
        trackedEntityType: trackedEntityType,
        orgUnit: orgUnit,
        attributes: valuesToSave,
        enrollments: [
          {
            //"trackedEntityInstance": trackedEntityInstance,
            program: programData.programs[0].id,
            //"status": "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          },
        ],
        geometry: {
          type: "Point",
          coordinates: [currentGeolocation.lng, currentGeolocation.lat],
        },
      };

    if (navigator.onLine) {
      setGlobalSpinner(true);

      apiServices
        .postAPI("trackedEntityInstances", saveCaseInput)
        .then((response) => {
          const trackedEntityInstance =
            response.data.response.importSummaries[0].reference;
          const programId = programData.programs[0].id;
          const enrollmentInputJson = {
            trackedEntityInstance: trackedEntityInstance,
            program: programId,
            status: "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          };

          // apiServices.postAPI('enrollments', enrollmentInputJson)
          //     .then(enrollmentResponse => {
          const userCreationInput = {
            userCredentials: {
              cogsDimensionConstraints: [],
              catDimensionConstraints: [],
              username: valueForFormInput[uicId],
              password: "Test@123",
              userRoles: [{ id: patientroleid }],
            },
            surname: lastNameId && valueForFormInput[lastNameId] ? valueForFormInput[lastNameId] : "testsurname",
            firstName: valueForFormInput[firstNameId],
            phoneNumber: valueForFormInput[regPhoneNumberId],
            organisationUnits: [{ id: orgUnit }],
            dataViewOrganisationUnits: [{ id: orgUnit }],
            teiSearchOrganisationUnits: [{ id: orgUnit }],
            //"userGroups": [{"id": userGroupId}],
            attributeValues: [
              {
                value: trackedEntityInstance,
                attribute: { id: patienttrackedInstanceId },
              },
              { value: true, attribute: { id: mainAccountId } },
            ],
          };
          setGlobalSpinner(false);

          apiServices
            .postAPI("users", userCreationInput)
            .then((userResponse) => {
              registartionSuccess();
              setGlobalSpinner(false);
            })
            .catch((err) => {
              setGlobalSpinner(false);
              registartionSuccess();
              // swal({
              //     title: t("Patient registered successfully, but patient has not created as user"),
              //     text: "",
              //     icon: "warning",
              //     button: t("Close"),
              // }).then(userResponse => {
              //     registartionSuccess()
              // });
            });
          function registartionSuccess() {
            const enroll = ""; //enrollmentResponse.data.response.importSummaries[0].reference
            const getURL =
              "trackedEntityInstances/" +
              linkContactFlag.data.linkTrackedEntityInstance +
              ".json?program=" +
              programId +
              "&fields=*?";
            apiServices.getAPI(getURL).then((getParentData) => {
              const parentAttribute = [];
              getParentData.data.attributes.map((attributes) => {
                const obj = {
                  attribute: attributes.attribute,
                  value: attributes.value,
                };
                parentAttribute.push(obj);
              });

              getParentData.data.relationships.push({
                from: {
                  trackedEntityInstance: {
                    trackedEntityInstance:
                      linkContactFlag.data.linkTrackedEntityInstance,
                  },
                },
                to: {
                  trackedEntityInstance: {
                    trackedEntityInstance: trackedEntityInstance,
                  },
                },
                relationshipType: relationShipId,
              });

              const linkContactJson = {
                created: moment().format("YYYY-MM-DD"),
                orgUnit: orgUnit,
                createdAtClient: moment().format("YYYY-MM-DD"),
                trackedEntityInstance:
                  linkContactFlag.data.linkTrackedEntityInstance,
                lastUpdated: moment().format("YYYY-MM-DD"),
                trackedEntityType: trackedEntityType,
                lastUpdatedAtClient: moment().format("YYYY-MM-DD"),
                inactive: false,
                deleted: false,
                featureType: "NONE",
                programOwners: [
                  {
                    ownerOrgUnit: orgUnit,
                    program: programId,
                    trackedEntityInstance:
                      linkContactFlag.data.linkTrackedEntityInstance,
                  },
                ],
                relationships: getParentData.data.relationships,
                attributes: parentAttribute,
                geometry: {
                  type: "Point",
                  coordinates: [currentGeolocation.lng, currentGeolocation.lat],
                },
              };

              const putURL =
                "trackedEntityInstances/" +
                linkContactFlag.data.linkTrackedEntityInstance;

              apiServices
                .putAPI(putURL, linkContactJson)
                .then((linkResponse) => {
                  if (Configuration.registrationForm.linkContactInAlert) {
                    swal({
                      title: t("Contact Registered"),
                      text: t("Do you want to register another Contact?"),
                      icon: "success",
                      buttons: [t("No"), t("Yes")],
                    }).then((AlertRes) => {
                      if (AlertRes) {
                        //save data
                        const activeCaseDetails = {
                          trackedEntityInstance: trackedEntityInstance,
                          enrollmentId: enroll,
                        };
                        const linkContact = {
                          enabled: true,
                          linkTrackedEntityInstance:
                            linkContactFlag.data.linkTrackedEntityInstance,
                        };
                        const activeCaseFormData = {
                          formFormat: null,
                          dhisFormat: null,
                        };
                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseDetails",
                          activeCaseDetails
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseFormData",
                          activeCaseFormData
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "linkContactFlag",
                          linkContact
                        );

                        setActiveCaseFormData({
                          data: {
                            formFormat: null, //valueForFormInput,
                            dhisFormat: null, //
                          },
                        });
                        setValue(0);

                        //empty form
                      } else {
                        //save data
                        const activeCaseDetails = {
                          trackedEntityInstance: trackedEntityInstance,
                          enrollmentId: enroll,
                        };
                        const activeCaseFormData = {
                          formFormat: valueForFormInput,
                          dhisFormat: valuesToSave,
                        };
                        const linkContact = {
                          enabled: false,
                          linkTrackedEntityInstance: trackedEntityInstance,
                        };

                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseDetails",
                          activeCaseDetails
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "activeCaseFormData",
                          activeCaseFormData
                        );
                        OfflineDb.setDataIntoPouchDB(
                          "linkContactFlag",
                          linkContact
                        );

                        //load next active tabs
                        const nextTab = activeTabs[0];
                        if (nextTab) {
                          const indexOfNextTab =
                            programData.programs[0].programStages.findIndex(
                              (obj) => obj.id == nextTab
                            );
                          setValue(indexOfNextTab + stepIncrement);
                        } else {
                          setValue(value);
                        }
                        setActiveCaseDetails({
                          data: {
                            trackedEntityInstance: trackedEntityInstance,
                            enrollmentId: enroll,
                          },
                        });
                      }
                    });
                  } else {
                    const activeCaseDetails = {
                      trackedEntityInstance: trackedEntityInstance,
                      enrollmentId: enroll,
                    };
                    const activeCaseFormData = {
                      formFormat: valueForFormInput,
                      dhisFormat: valuesToSave,
                    };
                    const linkContact = {
                      enabled: false,
                      linkTrackedEntityInstance: trackedEntityInstance,
                    };
                    setLinkContactFlag({
                      data: linkContact,
                    });

                    OfflineDb.setDataIntoPouchDB(
                      "activeCaseDetails",
                      activeCaseDetails
                    );
                    OfflineDb.setDataIntoPouchDB(
                      "activeCaseFormData",
                      activeCaseFormData
                    );
                    OfflineDb.setDataIntoPouchDB(
                      "linkContactFlag",
                      linkContact
                    );
                    setAddContactFlag(false);
                    //load next active tabs
                    swal({
                      title: t("Success"),
                      text: t("Contact Registered successfully."),
                      icon: "success",
                      buttons: t("Ok"),
                    });
                    const nextTab = activeTabs[0];
                    if (nextTab) {
                      const indexOfNextTab =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == nextTab
                        );
                      setValue(indexOfNextTab + stepIncrement);
                    } else {
                      setValue(value);
                    }
                    setActiveCaseDetails({
                      data: {
                        trackedEntityInstance: trackedEntityInstance,
                        enrollmentId: enroll,
                      },
                    });
                  }
                  setGlobalSpinner(false);
                });
              setGlobalSpinner(false);
            });
            // })
          }
        });
    } else {
      //OfflineStorage
      let offlineObj = {
        data: valueForFormInput,
        registration: saveCaseInput,
        services: [],
        formVersion: programData.programs[0].version,
        parentId: linkContactFlag.data.linkTrackedEntityInstance,
      };
      console.log("offlineObj ", offlineObj);
      OfflineDb.saveEntity(offlineObj)
        .then((res) => {
         setGlobalSpinner(false)
          const activeCaseDetails = {
            trackedEntityInstance: res.id,
            enrollmentId: "",
          };
          const activeCaseFormData = {
            formFormat: valueForFormInput,
            dhisFormat: valuesToSave,
          };
          const linkContact = {
            enabled: false,
            linkTrackedEntityInstance: res.id,
          };

          setActiveCaseDetails({
            data: {
              trackedEntityInstance: res.id,
              enrollmentId: "",
            },
          });
          OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
          setAddContactFlag(false);
          //laod next active tab
          swal({
            title: t("Registered"),
            text: t("Contact registered offline successfully."),
            icon: "success",
            buttons: t("Ok"),
          });
          const nextTab = activeTabs[0];
          if (nextTab) {
            const indexOfNextTab =
              programData.programs[0].programStages.findIndex(
                (obj) => obj.id == nextTab
              );

            setValue(indexOfNextTab + stepIncrement);
          } else {
            setValue(value);
          }
          // if (
          //   valueForFormInput[PresentlyOnAntiTBMedicationId] &&
          //   valueForFormInput[PresentlyOnAntiTBMedicationId] == "Yes" && programData && programData.programs && programData.programs[0] && programData.programs[0].code == "UNDP"
          // ) {
          //   swal({
          //     title: t("Registered"),
          //     text: t("Offline: Client registered as Index"),
          //     icon: "success",
          //     buttons: t("Ok"),
          //   }).then((AlertRes) => {
          //     console.log("AlertRes ", AlertRes);
          //     if (AlertRes) {
          //       history.push("layout/home");
          //     }
          //   });
          // } else {
          //   swal({
          //     title: t("Success"),
          //     text: t("Client registered successfully in offline"),
          //     icon: "success",
          //     button: t("Close"),
          //   });
          //   //save data
          //   setAddContactFlag(false)
          //   //laod next active tab
          //   const nextTab = activeTabs[0];
          //   if (nextTab) {
          //     const indexOfNextTab =
          //       programData.programs[0].programStages.findIndex(
          //         (obj) => obj.id == nextTab
          //       );

          //     setValue(indexOfNextTab + stepIncrement);
          //   } else {
          //     setValue(value);
          //   }
          // }
        })
        .catch((err) => {
          console.log("linkregdataoff>>", err);
          setGlobalSpinner(false)
        });
    }
  }

  function updateRegData(
    valuesToSave,
    valueForFormInput,
    trackentityInstanceDetail
  ) {
    if (qrCodeId && valueForFormInput && !valueForFormInput[qrCodeId]) {
      var code = generateQRCode(8);
      let qrcode = { attribute: qrCodeId, value: code };
      valuesToSave.push(qrcode);
      valueForFormInput[qrCodeId] = code;
    }
    checkUserPhoneNumberExist(valueForFormInput, function (callbackRes) {
      if (navigator.onLine) {
        const orgUnit =
          userrolename &&
          userrolename.toLowerCase() == superAdmin &&
          trackentityInstanceDetail
            ? trackentityInstanceDetail.orgUnit
            : userData.organisationUnits[0].id;
        const programId = programData.programs[0].id;
        const trackedEntityType = programData.programs[0].trackedEntityType.id;
        const updateURL =
          "trackedEntityInstances/" +
          trackentityInstanceDetail.trackedEntityInstance;
        const lat = trackentityInstanceDetail.geometry
          ? trackentityInstanceDetail.geometry.coordinates[1]
          : "";
        const lng = trackentityInstanceDetail.geometry
          ? trackentityInstanceDetail.geometry.coordinates[0]
          : "";
        const updateCaseInput = {
          created: trackentityInstanceDetail.created,
          orgUnit: orgUnit,
          createdAtClient: trackentityInstanceDetail.createdAtClient,
          trackedEntityInstance:
            trackentityInstanceDetail.trackedEntityInstance,
          lastUpdated: trackentityInstanceDetail.lastUpdated,
          trackedEntityType: trackedEntityType,
          lastUpdatedAtClient: trackentityInstanceDetail.lastUpdatedAtClient,
          inactive: false,
          deleted: false,
          featureType: "NONE",
          programOwners: [
            {
              ownerOrgUnit: orgUnit,
              program: programId,
              trackedEntityInstance:
                trackentityInstanceDetail.trackedEntityInstance,
            },
          ],
          relationships:
            trackentityInstanceDetail &&
            trackentityInstanceDetail.relationships &&
            trackentityInstanceDetail.relationships.length > 0
              ? trackentityInstanceDetail.relationships
              : [],
          attributes: valuesToSave,
          geometry: { type: "Point", coordinates: [lng, lat] },
        };
        setGlobalSpinner(true);
        apiServices.putAPI(updateURL, updateCaseInput).then((updateRes) => {
          setGlobalSpinner(false);
          swal({
            title: t("Updated"),
            text: t("Client data successfully updated"),
            icon: "success",
            button: t("Close"),
          });
          const activeCaseFormData = {
            formFormat: valueForFormInput,
            dhisFormat: valuesToSave,
          };

          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          setActiveCaseFormData({
            data: {
              formFormat: valueForFormInput, //valueForFormInput,
              dhisFormat: valuesToSave, //
            },
          });
          if (
            valueForFormInput[PresentlyOnAntiTBMedicationId] &&
            valueForFormInput[PresentlyOnAntiTBMedicationId] == "YES" &&
            programData.programs[0].code == "UNDP"
          ) {
            //if present tb submitted and its yes then don't go ahead

            const indexOfNextTab =
              programData.programs[0].programStages.findIndex(
                (obj) => obj.displayName == "TB treatment initiation form"
              );
            setValue(indexOfNextTab + stepIncrement);
          } else {
            // const nextTab = activeTabs[0]
            // if (nextTab) {
            //     const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
            //     setValue(indexOfNextTab + 1)
            // } else {
            //     setValue(value)
            // }

            const nextTab = activeTabs[0];
            if (nextTab) {
              const indexOfNextTab =
                programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == nextTab
                );
              setValue(indexOfNextTab + stepIncrement);
            } else {
              setValue(value);
            }
          }
        });
      } else {
        OfflineDb.getSingleEntity(
          activeCaseDetails.data.trackedEntityInstance
        ).then((res) => {
          const tempdata = { ...res };
          tempdata.formVersion = programData.programs[0].version;
          tempdata.data = { ...tempdata.data, ...valueForFormInput };
          tempdata.registration.attributes = valuesToSave;
          //console.log("tempdata",tempdata);
          OfflineDb.updateFullEntity(tempdata).then((response) => {
            setGlobalSpinner(false)
            const activeCaseFormData = {
              data: {
                formFormat: valueForFormInput,
                dhisFormat: valuesToSave,
              },
            };
            OfflineDb.setDataIntoPouchDB(
              "activeCaseFormData",
              activeCaseFormData
            );
            setActiveCaseFormData(activeCaseFormData);
            swal({
              title: t("Updated offline"),
              text: t("Client data successfully updated"),
              icon: "success",
              button: t("Close"),
            });
            const nextTab = activeTabs[0];
            if (nextTab) {
              const indexOfNextTab =
                programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == nextTab
                );
              setValue(indexOfNextTab + stepIncrement);
            } else {
              setValue(value);
            }
          }).catch(e =>{
            setGlobalSpinner(false);
          });
        }).catch(e =>{
            setGlobalSpinner(false);
        });
      }
    });
  }

  function onSubmit(values) {
    try{
        setGlobalSpinner(true)
    if (
      !navigator.onLine &&
      values[clientTypeID] == Configuration.ltbiLinkVariables.index &&
      addIndex
    ) {
      //setAddIndex(true);
      addindexoffline = true;
    }
    if(window.cordova && profileimageDataUrl){
      values[profileimageUID] = profileimageDataUrl
    }
    let registrationFields =
      programData.programs[0].programTrackedEntityAttributes;

    let fieldValueWithAttribute = [];
    const data = values;
    if (!navigator.onLine && values[offlineFieldId] == undefined) {
      values[offlineFieldId] = Date.now();
    }
    let promises = [];
    Object.keys(values).map(function (objectKey, index) {
      var obj = {
        attribute: objectKey,
        value: values[objectKey],
      };
      const CurrentValueFilter = registrationFields
        ? registrationFields.find(
            (obj) => (obj.trackedEntityAttribute.id == objectKey)
          )
        : undefined;
      if (CurrentValueFilter) {
        if (
          (CurrentValueFilter && CurrentValueFilter.trackedEntityAttribute && CurrentValueFilter.trackedEntityAttribute.valueType && (CurrentValueFilter.trackedEntityAttribute.valueType == "IMAGE" ||
          CurrentValueFilter.trackedEntityAttribute.valueType == "FILE_RESOURCE"))
        ) {
          console.log("profileimageDataUrl ",profileimageDataUrl,values,data[objectKey])
          if(data[objectKey] && _.isObject(data[objectKey])){
            let imgUrl = data[objectKey][0]
            console.log("imgUrl ",imgUrl,dataUri,values,profileimageDataUrl)
            if (navigator.onLine) {
            setGlobalSpinner(true)
            let formData = new FormData();
            formData.append("file", imgUrl);
              promises.push(
                apiServices.postAPI("fileResources", formData).then((res) => {
                  if (res.data) {
                    return {
                      attribute: objectKey,
                      value: res.data.response.fileResource.id,
                    };
                  }
                }).catch((err) => {
                  return {
                    attribute: objectKey,
                    value: imageValue,
                  };
                })
              );
              }
            }else{
              fieldValueWithAttribute.push(obj);
            }
        } else {
          fieldValueWithAttribute.push(obj);
        }
      }
    });

    if (promises.length == 0) {
      setGlobalSpinner(false)
      if (linkContactFlag.data) {
        if (linkContactFlag.data.enabled == true) {
          //linkContact function

          linkeRegData(fieldValueWithAttribute, values);
        } else {
          if (activeCaseDetails.data) {
            //update

            updateRegData(
              fieldValueWithAttribute,
              values,
              trackentityInstanceDetails
            );
          } else {
            //save

            saveRegData(fieldValueWithAttribute, values);
          }
        }
      } else {
        if (activeCaseDetails.data) {
          //update

          updateRegData(
            fieldValueWithAttribute,
            values,
            trackentityInstanceDetails
          );
        } else {
          //save

          saveRegData(fieldValueWithAttribute, values);
        }
      }
    } else {
      Promise.all(promises).then((responses) => {
        setGlobalSpinner(false)
        responses.map((imageData) => {
          fieldValueWithAttribute.push(imageData);
        });
        if (linkContactFlag.data) {
          if (linkContactFlag.data.enabled == true) {
            //linkContact function

            linkeRegData(fieldValueWithAttribute, values);
          } else {
            if (activeCaseDetails.data) {
              //update

              updateRegData(
                fieldValueWithAttribute,
                values,
                trackentityInstanceDetails
              );
            } else {
              //save

              saveRegData(fieldValueWithAttribute, values);
            }
          }
        } else {
          if (activeCaseDetails.data) {
            //update

            updateRegData(
              fieldValueWithAttribute,
              values,
              trackentityInstanceDetails
            );
          } else {
            //save

            saveRegData(fieldValueWithAttribute, values);
          }
        }
      });
    }

    //saveRegData(fieldValueWithAttribute, values)
}catch(e){
    console.log("e",e)
    setGlobalSpinner(false)
}
  }
  // Code for Link Tab
  function addContactCallBack() {
    let address = "";
    let addressLocation = "";
    if (trackentityInstanceDetails && trackentityInstanceDetails.attributes) {
      address = trackentityInstanceDetails.attributes.find(
        (x) => x.attribute == regAddressId
      )
        ? trackentityInstanceDetails.attributes.find(
            (x) => x.attribute == regAddressId
          ).value
        : "";
      addressLocation = trackentityInstanceDetails.attributes.find(
        (x) => x.attribute == addressLocationId
      )
        ? trackentityInstanceDetails.attributes.find(
            (x) => x.attribute == addressLocationId
          ).value
        : "";
    }
    setAddIndex(null);
    setAddContactFlag(true);
    const activeCaseDetails1 = {
      trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      enrollmentId: activeCaseDetails.data.enrollmentId,
    };
    const linkContact = {
      enabled: true,
      linkTrackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
    };
    const activeCaseFormData = {
      formFormat: null, //valueForFormInput,
      dhisFormat: null, //
    };

    OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails1);
    OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
    OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

    setActiveCaseFormData({
      data: {
        //'formFormat': null, //valueForFormInput,
        formFormat: {
          [clientTypeID]: Configuration.ltbiLinkVariables.contact,
          [addressLocationId]: addressLocation,
          [regAddressId]: address,
        },
        dhisFormat: null, //
      },
    });
    setLinkContactFlag({
      data: {
        enabled: true,
        linkTrackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      },
    });
    // setActiveCaseDetails({
    //     "data": {
    //         'trackedEntityInstance': activeCaseDetails.data.trackedEntityInstance,
    //         'enrollmentId': activeCaseDetails.data.enrollmentId,
    //     }
    // })
    //console.log("searchena ",searchEnabled,props)
    if (searchEnabled && navigator.onLine) {
      setValue(1);
    } else {
      setValue(0);
    }
    setsputumTable([]);
  }

  const GroupEventData = (arrayData) => {
    console.log("arrayData",arrayData)
    let GroupArrData, arrayDataSort;
    if(arrayData && arrayData.length > 0) {
      arrayData.forEach(element => {
        element.groupDate = element.lastUpdated.split("T")[0]; //manually added new Date key for grouping
      });

       arrayDataSort = _.sortBy(arrayData,[function (o) { return o.lastUpdated; }]).reverse()

      GroupArrData = arrayDataSort.reduce(function (r, a) {
          r[a.groupDate] = r[a.groupDate] || [];
          r[a.groupDate].push(a);
          return r;
      }, Object.create(null));
    } else {
      GroupArrData = [];
    }

    console.log("GroupArrData arrayData",arrayDataSort, GroupArrData)
    return GroupArrData;
  }

  function createStructure(events) {
    // const dataElements = sessionMetaData.dataElements;
    return events.dataValues.map((values, i) => {
      return props.programData?.programs[0]?.programStages.map((stages) => {
        let filterFieldData = stages.programStageDataElements.filter(
          (obj) =>
            stages.id == events.programStage &&
            obj.dataElement.id == values.dataElement
        );
        let fieldValue = values.value;
        let lastUpdatedDate = values.lastUpdated;
      
        if (filterFieldData.length > 0) {
          const filterShowFlagAttr =
            filterFieldData[0].dataElement.attributeValues.filter(
              (obj) =>
                obj.attribute.displayName == "ShowInTable" &&
                obj.value == "true"
            );

          // console.log("filterShowFlagAttr",filterShowFlagAttr)
          try {
            if (filterFieldData[0].dataElement.valueType == "DATE") {
              //IF VALUE OF DATAELEMENT IS DATE
              fieldValue = moment(values.value).format("YYYY-MM-DD");
            }
            if (
              filterFieldData[0].dataElement.valueType == "ORGANISATION_UNIT"
            ) {
              let orgobj = props.programData.programs[0].organisationUnits.find(
                (o) => o.id == values.value
              );
              if (orgobj) {
                fieldValue = orgobj.displayName;
              }
            }
            if (
              filterFieldData[0].dataElement &&
              filterFieldData[0].dataElement.fieldMask == "Facility Referral"
            ) {
              let stageObj = props.programData.programs[0].programStages.filter(
                (stage) => stage.id == values.value
              );
              fieldValue =
                stageObj.length > 0
                  ? getTranslatedLabels(stageObj[0])
                  : values.value;
            }
            if (filterFieldData[0].dataElement.optionSet) {
              filterFieldData[0].dataElement.optionSet.options.map((option) => {
                if (option.code == values.value) {
                  fieldValue = getTranslatedLabels(option);
                }
              });
            }
          } catch (e) {}

          // console.log("filterFieldData",filterFieldData)
          if (filterShowFlagAttr.length > 0) {
            return (
                <Typography>
                  <span className="zero servicequestiontitle">
                    {getTranslatedLabels(filterFieldData[0].dataElement)} :{" "}
                  </span>
                  &nbsp;
                  <span className="zero servicequestionanswer">
                    {fieldValue}
                  </span>
                </Typography>
            );
          }
        }
      });
    });
  }

  function getEntityData(events, i, dateVal) {
    // console.log("group event",events)
    const classes = makeStyles((theme) => ({
      root: {
        width: "100%",
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
      },
    }));

    const allStages = props.programData.programs[0].programStages;
// console.log("allStagesallStages", allStages,events)
    const filterStageEvent = allStages.filter(
      (obj) =>
        obj.id == events.programStage &&
        // currentStage.id == obj.id &&
        events.status != "SCHEDULE"
    );

    // console.log("filterStageEvent", filterStageEvent)
    if (!filterStageEvent.length) {
      return null;
    }

    return ( 
      <> 
      { events && events.dataValues && events.dataValues.length > 0 && ( 
      <Card className="card-container">
          <CardHeader className="modalheader" title={`${getTranslatedLabels(filterStageEvent[0])} - ${moment(dateVal).format("LT")}`} />
          {/* <List className={classes.root}> */}
          <CardContent>
            {createStructure(events)}
          </CardContent>
          {/* </List> */}
      </Card>)}
      </>
    );
  }

  

  function createSummaryPage() {
    const allVisitData = navigator.onLine && trackentityInstanceDetails &&
    trackentityInstanceDetails.enrollments &&
    trackentityInstanceDetails.enrollments.length > 0 &&
    trackentityInstanceDetails.enrollments[0].events
      ? trackentityInstanceDetails.enrollments[0].events
      : !navigator.onLine ? trackentityInstanceDetails : [];
      
    const GroupArr = GroupEventData(allVisitData);

    // console.log("GroupArr", GroupArr, trackentityInstanceDetails,multiServicesOfflineData)
    if(!trackentityInstanceDetails?.enrollments){
      return
    }
    // console.log('trackentityInstanceDetails', trackentityInstanceDetails, metaData)
    let getProgData = metaData?.programs[0]?.programStages;
    let entityAttr = metaData?.programs[0]?.programTrackedEntityAttributes;
    let groupStages = _.groupBy(trackentityInstanceDetails?.enrollments[0]?.events, "programStage");
    let stageKeys = Object.keys(groupStages);
    let regValArr = trackentityInstanceDetails?.attributes;
    regValArr.forEach(element => { // getting Order for the register Data values
      let id = element.attribute;
      entityAttr.forEach(values => {
         if(id === values?.trackedEntityAttribute?.id){
            element.order = values.sortOrder;
         }
      });
    });

    let sorted_obj = _.sortBy(regValArr,[function (o) { return o.order; }]); // Sorting the Data based on order

    // console.log("groupStages",groupStages, stageKeys, regValArr, sorted_obj)
    return (
      <Grid container className="card-containers summary-section">
          <div className="innertabdivreg">
          <div className="header-container">
            <h3 className="pdfheader">{t('PATIENT SUMMARY')}</h3>
            <Button 
              className="modalactionbtn"
              onClick={() => {
                localStorage.setItem("form", document.getElementById('form'));
                downloadSurveyPDF()}} >
                {t('Download Summary')}
            </Button>
          </div>
          <div className="border" id="form">
            <div className="summary-header hide">
              <span>{userData?.organisationUnits[0]?.displayName ? userData?.organisationUnits[0]?.displayName : ''}</span>
              <span></span>
              {/* <img src={`../${imgUrlArr['who-logo']}`} className="whologo"/> */}
            </div>
            <div className="RegPageSummary">
            <h4>{t('Registration Details')}</h4>
            { 
              sorted_obj.map((item) => {
                  return(
                    <div className="registerDiv">
                      <span className="summaryitem">{ getTranslatedDataAttributeLabels(item.attribute, entityAttr) }: </span>
                      <span className="summaryvalue">{item.value}</span>
                    </div>
                  )
                })
              }
            </div>

            <div>
              {
                stageKeys.length > 0 && stageKeys.map((val) => {
                  let dataArr = groupStages[val];
                  let dataSortArr = _.orderBy(dataArr,"lastUpdated",["desc"]) 
                  // _.orderBy(dataArr, (a) => new Date(a.lastUpdated))
                  // console.log("dataSortArr",dataArr,dataSortArr)
                  return getProgData.map((data)=> {
                    // console.log("data", data)
                    if(data.id === val && data.id != summaryStageId) {
                      return (
                        <div className="RegPageSummary">
                          <h4>{ getTranslatedLabels(data) }</h4>
                          {
                            dataSortArr[0]?.dataValues.length > 0 ?
                            dataSortArr[0]?.dataValues.map((getVal)=> {
                              // getVal.dataElement
                              return data?.programStageDataElements.map((getIDVal)=> {
                                // return getIDVal?.dataElement.map((idVal)=> {
                                  if(getIDVal?.dataElement.id === getVal.dataElement) {
                                    return (
                                      <div className="registerDiv">
                                        <span className="summaryitem">{ getTranslatedDataElementLabels(getIDVal?.dataElement) }: </span>
                                        <span className="summaryvalue">{ getIDVal?.dataElement?.valueType == 'DATE' ? moment(getVal.value).format("YYYY-MM-DD") : getVal.value}</span>
                                      </div>
                                    )
                                  }
                                // })
                              })
                            }) : t('No Data Available!')
                          }
                        </div>
                      )
                    }
                  })
                })
              }
            </div>

            { GroupArr && Object.keys(GroupArr).length > 0 &&
              <Grid style={{ marginBottom: "50px" }} className="previous-section">
                <Card>
                  <CardHeader className="modalheader" title={t("Patient Visits")} />
                  {GroupArr && Object.keys(GroupArr).length > 0 &&
                    (() => {
                      let structure = [];
                      for (const key in GroupArr) {
                          if(GroupArr[key] != null && GroupArr[key].length > 0) { 
                            structure.push(<CardContent className="data-container">
                            <Grid container className="mt-10px mb-10px">
                              <Grid item xs={12} sm={12} md={12} key={key} className="mb-10px">
                              <Card sx={{ maxWidth: 345 }}>
                                <CardHeader className="modalheader" title={moment(GroupArr[key][0].lastUpdated).format("MMMM Do YYYY")} />
                                {GroupArr[key].map((events, i) => {
                                  return (
                                    <CardContent>
                                    { getEntityData(events, i, GroupArr[key][i].lastUpdated) }
                                    </CardContent>

                                  )})}
                                </Card>
                              </Grid>
                            </Grid></CardContent>)
                          } 
                      }

                      return structure;
                    })()
                  }
                </Card>
              </Grid>
            }
            

           
              </div>
          </div>
      </Grid>
    );
  }
  
  function createIndexContactList() {
    if (activeCaseDetails.data && navigator.onLine) {
      let programID = programData.programs[0].id,
        url = `trackedEntityInstances/${activeCaseDetails.data.trackedEntityInstance}.json?program=${programID}&fields=relationships`;
      apiServices
        .getAPI(url)
        .then((res) => {
          getChildrenById(res.data.relationships, programID);
        })
        .catch((error) => {
          setGlobalSpinner(false);
          swal({
            title: "Error",
            text: "",
            icon: "error",
            button: "Close",
          });
        });
    }
  }
  function getChildrenById(relationshipsArr, programid) {
    let p = [];
    let q = [];
    //setGlobalSpinner(true);
    relationshipsArr.map((relobj) => {
      if (
        relobj.from.trackedEntityInstance.trackedEntityInstance !=
        activeCaseDetails.data.trackedEntityInstance
      ) {
        let url = `trackedEntityInstances/${relobj.from.trackedEntityInstance.trackedEntityInstance}.json?program=${programid}&fields=*?`;
        q.push(apiServices.getAPI(url));
      }
      if (
        relobj.to.trackedEntityInstance.trackedEntityInstance !=
        activeCaseDetails.data.trackedEntityInstance
      ) {
        let url1 = `trackedEntityInstances/${relobj.to.trackedEntityInstance.trackedEntityInstance}.json?program=${programid}&fields=*?`;
        p.push(apiServices.getAPI(url1));
      }
    });

    Promise.all([...p]).then(([...res]) => {
      let childrenArr = [...res];
      setGlobalSpinner(false);
      setLinkContactList(childrenArr);
    });
    Promise.all([...q]).then(([...res]) => {
      let childrenArr = [...res];
      setGlobalSpinner(false);
      setLinkIndexList(childrenArr);
    });
  }
  // Code for Search tab
  function _createSearchForm(programObj) {
    const rulesObject = {
      programRule: [],
      programRuleVariable: [],
    };
    let attributes = programObj.programs[0].programTrackedEntityAttributes;
    return (
      <Form
        onSubmit={(values) => searchAPI(values, null, 2)}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form className="fullWidth" onSubmit={handleSubmit}>
            <div className="innertabdivreg subclass2">
              <>
                <Grid container spacing={3}>
                  {attributes.map((attribute, i) => {
                    if (
                      attribute.searchable &&
                      attribute.trackedEntityAttribute.displayName
                        .trim()
                        .toLowerCase() != "qr code"
                    ) {
                      return (
                        <CreateField
                          fieldData={attribute}
                          values={values}
                          programRules={[]}
                          programData={programObj.programs[0]}
                          programRulesVariables={[]}
                          linkContactFlag={linkContactFlag}
                          activeCaseDetails={activeCaseDetails}
                          Configuration={Configuration}
                        />
                      );
                      //fieldData={registrationFields} values={values} programRules={programRules} programData={programData.programs[0]} programRulesVariables={programRulesVariables} linkContactFlag={linkContactFlag} onGoogleLocatioChangeParent = {onGoogleLocatioChangeParent}
                      // return <CreateField fieldData ={attribute} values={values} form={form} programRules={rulesObject} key={i}/>
                    }
                  })}
                </Grid>

                <div className="buttons">
                  <button
                    className="regformsubmitbtn"
                    type="submit"
                    disabled={submitting}
                  >
                    <Trans>Submit</Trans>
                  </button>
                  <button
                    className="regformresetbtn"
                    type="button"
                    onClick={() => this.resetForm(form, values)}
                    disabled={submitting || pristine}
                  >
                    <Trans>Reset</Trans>
                  </button>
                </div>

                {/* {
                    searchResult.length > 0 ?
                    <>
                    <p className="searchformheading"><Trans>Search Results</Trans> :
                        {searchResult[1].length == 0 ?
                            <>
                            <Trans> No result found. Do you want to register the client?</Trans> 
                            <button style={{marginLeft:'20px'}} className="regformsubmitbtn" >
                                <Trans>Add New Client</Trans>
                            </button> </>: null
                        
                        }
                        
                    </p>                            
                    <SearchResults
                        searchResult = {searchResult}
                        viewType={'card'}
                        metaData={programObj}
                    />
                    </> : null
                    } */}
                {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
              </>
            </div>
          </form>
        )}
      />
    );
  }

  function searchAPI(param) {
    if(navigator.onLine){
    setGlobalSpinner(true);

    //let programData = programObj.programs[0]
    let registrationFields =
      props.programData.programs[0].programTrackedEntityAttributes;
    let clientTypeID = null;
    registrationFields.map((field, index) => {
      if (field.trackedEntityAttribute.displayName == "Client type") {
        clientTypeID = field.trackedEntityAttribute.id;
        param[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
      }
    });

    if (!_.isEmpty(param) && uicId && !param.hasOwnProperty(uicId)) {
      //do not save uic field data
      OfflineDb.setDataIntoPouchDB("activeCaseFormData", {
        formFormat: param, //valueForFormInput,
        dhisFormat: null, //
      });
      setActiveCaseFormData({
        data: {
          formFormat: param, //valueForFormInput,
          dhisFormat: null, //
        },
      });
    }
    //const metaData = JSON.parse(localStorage.getItem('metaData')) || '';
    //const sessionUserBoValue = JSON.parse(sessionStorage.getItem('userBO')) || JSON.parse(localStorage.getItem('userBO'))
    // setLoading(true)
    let orgID = sessionUserBoValue.organisationUnits[0].id, //`UuYrI1twhmN`,
      programID = sessionUserBoValue.programs[0], //`nSy7PFqQykt`,
      searchQuery = ``;

    for (var i in param) {
      searchQuery += `&attribute=${i}:LIKE:${param[i]}`;
    }
    let subURL =
      "trackedEntityInstances/query.json?ou=" +
      orgID +
      "&ouMode=ACCESSIBLE&&order=created:desc&program=" +
      programID +
      searchQuery +
      "&pageSize=50&page=1&totalPages=false&skipPaging=true";

    apiServices
      .getAPI(subURL)
      .then((searchResponse) => {
        setGlobalSpinner(false);
        if (searchResponse.data.rows.length > 0) {
          try {
            searchResponse.data.headers.map((ele) => {
              if (ele.column && metaData) {
                let fieldBO = _.find(metaData.trackedEntityAttributes, {
                  displayName: ele.column,
                });
                if (fieldBO && ele.column != fieldBO.description) {
                  ele.column = fieldBO.description;
                }
              }
            });
          } catch (e) {
            console.log(e);
          }
          setSearchHeader(searchResponse.data.headers);
          setSearchResponse(searchResponse.data.rows);
          // setFormValuePostDeDup({ 'valuesToSave': valuesToSave, 'valueForFormInput': valueForFormInput })
        } else {
          setSearchHeader([]);
          setSearchResponse([]);
        }
        // let searchArray = []
        // searchArray.push(res.data.headers)
        // searchArray.push(res.data.rows)
        // setSearchResult(searchArray)
        // setLoading(false)
      })
      .catch((error) => {
        setGlobalSpinner(false);
        // setLoading(false)
        swal({
          title: t("Error"),
          text: t(
            "At least 1 attributes should be mentioned in the search criteria."
          ),
          icon: "error",
          button: t("Close"),
        });
      });
     }
      else{
        setGlobalSpinner(false);
        swal({
            title: t("Error"),
            text: t(
              "Data could not be shown in offline mode"
            ),
            icon: "error",
            button: t("Close"),
          });
    }
  }

  const searchBySpecimenId = (param, event, a, searchtype) => {
    if(navigator.onLine){
    // console.log("searchBySpecimenId>>", param, event, a, searchtype, sessionUserBoValue, metaData);
    if (Object.keys(param).length > 1) {
      delete param[qrDataElementDetail.id];
    }
    if (searchtype) {
      localStorage.setItem("searchtype", searchtype);
    }
    setsearchFilter(param);
    setGlobalSpinner(true);
    let orgID = sessionUserBoValue.organisationUnits[0].id,
      programID = sessionUserBoValue.programs[0],
      searchQuery = ``;
    let params = {
      orguid: orgID,
      programuid: programID,
      stageuid: stageDetail ? stageDetail.id : "",
      dataelementuid: Object.keys(param)[0],
      dataelementvalue: Object.values(param)[0],
    };
    // console.log('params>>', params)
    // setGlobalSpinner(false)
    // return;
    apiServices
      .postAPI("indicators/searchdataelement", params)
      .then((searchResponse) => {
        // let searchArray = [];
        // searchArray.push(res.data.headers);
        // searchArray.push(res.data.rows);
        // setSearchResult(searchArray);
        setGlobalSpinner(false);

        if (searchResponse.data.rows.length > 0) {
          setSearchHeader(searchResponse.data.headers);
          setSearchResponse(searchResponse.data.rows);
        } else {
          setSearchHeader([]);
          setSearchResponse([]);
        }

        // localStorage.removeItem("specimen");
        // localStorage.removeItem("searchtype");
      })
      .catch((error) => {
        setGlobalSpinner(false);
        // localStorage.removeItem("specimen");
        // localStorage.removeItem("searchtype");
        swal({
          title: t("Error"),
          text: t(
            "At least 1 attributes should be mentioned in the search criteria."
          ),
          icon: "error",
          button: t("Close"),
        });
      });
    }else{
        setGlobalSpinner(false);
        swal({
            title: t("Error"),
            text: t(
                "Data could not be shown in offline mode"
            ),
            icon: "error",
            button: t("Close"),
        });
    }
  };

  function createSearchForm(programObj) {
    const rulesObject = {
      programRule: [],
      programRuleVariable: [],
    };
    let attributes = programObj.programs[0].programTrackedEntityAttributes;
    const searchPageMeta = Configuration.searchpage;
    //const [showScanner, setshowScanner] = useState(false)
    function createCustomSearchForm() {
      const rulesObject = {
        programRule: [],
        programRuleVariable: [],
      };
      let attributes = metaData.programs[0].programTrackedEntityAttributes;
      return (
        <Form
          onSubmit={(values) => searchAPI(values, null, 2)}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="fullWidth searchdiv" onSubmit={handleSubmit}>
              <div className="innertabdivreg subclass3">
                <>
                  <Grid container spacing={3}>
                    {attributes.map((attribute, i) => {
                      if (
                        attribute.searchable &&
                        attribute.trackedEntityAttribute.displayName
                          .trim()
                          .toLowerCase() != "qr code"
                      ) {
                        return (
                          <CreateSearchField
                            fieldData={attribute}
                            values={values}
                            programRules={[]}
                            programData={programObj.programs[0]}
                            programRulesVariables={[]}
                            linkContactFlag={linkContactFlag}
                            activeCaseDetails={activeCaseDetails}
                            customClassName={
                              localStorage.getItem("fontSize")
                                ? "FS" + localStorage.getItem("fontSize")
                                : ""
                            }
                          />
                        );
                        //fieldData={registrationFields} values={values} programRules={programRules} programData={programData.programs[0]} programRulesVariables={programRulesVariables} linkContactFlag={linkContactFlag} onGoogleLocatioChangeParent = {onGoogleLocatioChangeParent}
                        // return <CreateField fieldData ={attribute} values={values} form={form} programRules={rulesObject} key={i}/>
                      }
                    })}
                  </Grid>

                  <div className="buttons">
                    <button
                      className="regformsubmitbtn mt-10px"
                      type="submit"
                      disabled={submitting}
                    >
                      <Trans>Submit</Trans>
                    </button>
                    <button
                      className="regformresetbtn"
                      type="button"
                      onClick={() => form.reset()}
                      disabled={submitting}
                    >
                      <Trans>Reset</Trans>
                    </button>
                  </div>

                  {/* {
                    searchResult.length > 0 ?
                    <>
                    <p className="searchformheading"><Trans>Search Results</Trans> :
                        {searchResult[1].length == 0 ?
                            <>
                            <Trans> No result found. Do you want to register the client?</Trans> 
                            <button style={{marginLeft:'20px'}} className="regformsubmitbtn" >
                                <Trans>Add New Client</Trans>
                            </button> </>: null
                        
                        }
                        
                    </p>                            
                    <SearchResults
                        searchResult = {searchResult}
                        viewType={'card'}
                        metaData={programObj}
                    />
                    </> : null
                    } */}
                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </>
              </div>
            </form>
          )}
        />
      );
    }

    function createUICSearchForm() {
      const rulesObject = {
        programRule: [],
        programRuleVariable: [],
      };
      let attributes = metaData.programs[0].programTrackedEntityAttributes;
      return (
        <Form
          onSubmit={(values) => searchAPI(values, null, 2)}
          render={({ handleSubmit, form, submitting, pristine, values }) => (
            <form className="fullWidth" onSubmit={handleSubmit}>
              <div className="innertabdivreg subclass4">
                <>
                  <Grid container spacing={3}>
                    {attributes.map((attribute, i) => {
                      if (attribute.trackedEntityAttribute.unique) {
                        return (
                          <CreateSearchField
                            key={i}
                            fieldData={attribute}
                            values={values}
                            form={form}
                            programRules={rulesObject}
                            customClassName={
                              localStorage.getItem("fontSize")
                                ? "FS" + localStorage.getItem("fontSize")
                                : ""
                            }
                          />
                        );
                      }
                    })}
                  </Grid>

                  <div className="buttons buttonFlex">
                    <button
                      className="regformsubmitbtn"
                      type="submit"
                      disabled={submitting}
                    >
                      <Trans>Submit</Trans>
                    </button>
                    <button
                      className="regformresetbtn hide"
                      type="button"
                      onClick={() => form.reset()}
                      disabled={submitting}
                    >
                      <Trans>Reset22</Trans>
                    </button>
                  </div>

                  {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
                </>
              </div>
            </form>
          )}
        />
      );
    }

    function handleQRScanForSpecimen(data) {
      // console.log('handleQRScanForSpecimen>>', data)
      if (data) {
        setshowScanner(false);
        let obj = {};
        metaData.programs[0].programStages.map((stage) => {
          if (
            stage.displayName &&
            stage.displayName === searchPageMeta.searchby.stagename
          ) {
            stage.programStageDataElements.map((field) => {
              if (
                field.renderType &&
                field.renderType["DESKTOP"].type == "QR_CODE"
              ) {
                // setqrDataElementDetail(field.dataElement)
                obj[field.dataElement.id] = data;
              }
            });
          }
        });

        searchBySpecimenId(obj, null, 2, "qr");
      }
    }

    const closeQrScanner = () => {
      setshowScanner(false);
    };

    function openQrSacnnerForSpecimen() {
      if (window.cordova) {
        openCordovaQrScannerForSpecimen();
      } else {
        setshowScanner(true);
      }
    }

    function createQRForSpecimen() {
      return (
        <>
          {showScanner ? (
            //   <>
            //     <QrReader
            //       delay={300}
            //       onError={() => qrErrorhandler()}
            //       onScan={(e) => handleQRScanForSpecimen(e)}
            //       style={{ width: "50%" }}
            //     />
            //     <button onClick={() => closeQrScanner()}>Close</button>
            //   </>
            <div
              style={{ height: "200px", width: "200px", textAlign: "center" }}
            >
              <Html5QrcodePlugin
                fps={10}
                qrbox={200}
                disableFlip={false}
                qrCodeSuccessCallback={(e) => handleQRScanForSpecimen(e)}
              />
              <span onClick={() => closeQrScanner()}>
                <FontAwesomeIcon icon={faTimes} />
              </span>
            </div>
          ) : (
            <p
              className="qrIcon"
              style={{ textAlign: "center" }}
              onClick={() => openQrSacnnerForSpecimen()}
            >
              <FontAwesomeIcon className="fa-5x" icon={faQrcode} />
            </p>
          )}
        </>
      );
    }

    function createSpecimenSearchForm(searchFilter) {
      return (
        <Grid container spacing={3} className="pt-100">
          <Grid xs={12} md={4}>
            <Form
              onSubmit={(values) => searchBySpecimenId(values, null, 2, "id")}
              initialValues={searchFilter}
              render={({
                handleSubmit,
                form,
                submitting,
                pristine,
                values,
              }) => (
                <form id="reg-searchby-specimen" onSubmit={handleSubmit}>
                  <Grid xs={12} md={12}>
                    <Field
                      name={
                        dataElementDetail ? dataElementDetail.id : "specimen-id"
                      }
                      label={t("Specimen Id")}
                      component={InputFieldFF}
                      key={
                        dataElementDetail ? dataElementDetail.id : "specimen-id"
                      }
                      className={
                        localStorage.getItem("fontSize")
                          ? "FS" + localStorage.getItem("fontSize")
                          : ""
                      }
                      required
                    />
                  </Grid>
                  <Grid xs={12} md={12}>
                    <div className="buttons btn-specimen">
                      <button
                        className="regformsubmitbtn"
                        type="submit"
                        disabled={submitting}
                      >
                        <Trans>Submit</Trans>
                      </button>
                      <button
                        className="regformresetbtn"
                        type="button"
                        onClick={() => {
                          form.reset();
                          setsearchFilter({});
                          resetSearch();
                        }}
                        // disabled={submitting}
                      >
                        <Trans>Reset33</Trans>
                      </button>
                    </div>
                  </Grid>
                </form>
              )}
            />
          </Grid>
          <Grid xs={12} md={4}>
            <h4 className="text-center">OR</h4>
          </Grid>
          <Grid xs={12} md={4}>
            {createQRForSpecimen()}
          </Grid>
        </Grid>
      );
    }

    function handleQRScan(data) {
      if (data) {
        setshowScanner(false);
        let obj = {};
        programObj.programs[0].programTrackedEntityAttributes.map(
          (attribute) => {
            if (
              attribute.renderType &&
              attribute.renderType["DESKTOP"].type == "QR_CODE"
            ) {
              obj[attribute.trackedEntityAttribute.id] = data;
            }
          }
        );
        searchAPI(obj);
      }
    }

    function qrErrorhandler(err) {
      setshowScanner(false);
      alert(err);
    }

    function createQRFrom() {
      return (
        <div
          className="searchformcontainer qrreaderholder"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {showScanner ? (
            // <QrReader
            //     delay={300}
            //     onError={() => qrErrorhandler()}
            //     onScan={() => handleQRScan()}
            //     style={{ width: '30%', cursor: 'pointer' }}
            // />
            <div style={{ height: "200px", width: "200px", marginTop: "10px" }}>
              <Html5QrcodePlugin
                fps={10}
                qrbox={200}
                disableFlip={false}
                qrCodeSuccessCallback={(e) => handleQRScan(e)}
              />
              <span onClick={() => closeQrScanner()}>
                <FontAwesomeIcon icon={faTimes} />
              </span>
            </div>
          ) : (
            <p className="qrIcon" onClick={() => openQrSacnner()}>
              <FontAwesomeIcon className="fa-5x" icon={faQrcode} />
            </p>
          )}
        </div>
      );
    }

    const resetSearch = () => {
      setSearchResult([]);
      setsearchFilter({});
    };

    function openCordovaQrScannerForSpecimen() {
      let that = this;
      window.cordova.plugins.barcodeScanner.scan(
        function (result) {
          handleQRScanForSpecimen(result.text);
        },
        function (error) {},
        {
          preferFrontCamera: false, // iOS and Android
          showFlipCameraButton: true, // iOS and Android
          showTorchButton: false, // iOS and Android
          torchOn: false, // Android, launch with the torch switched on (if available)
          prompt: "Place a barcode inside the scan area", // Android
          resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
          //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
          disableAnimations: true, // iOS
          disableSuccessBeep: false, // iOS
        }
      );
    }
    function openCordovaQrScanner() {
      let that = this;
      window.cordova.plugins.barcodeScanner.scan(
        function (result) {
          handleQRScan(result.text);
        },
        function (error) {},
        {
          preferFrontCamera: false, // iOS and Android
          showFlipCameraButton: true, // iOS and Android
          showTorchButton: false, // iOS and Android
          torchOn: false, // Android, launch with the torch switched on (if available)
          prompt: "Place a barcode inside the scan area", // Android
          resultDisplayDuration: 500, // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
          //formats : "QR_CODE,PDF_417", // default: all but PDF_417 and RSS_EXPANDED
          //orientation : "portrait", // Android only (portrait|landscape), default unset so it rotates with the device
          disableAnimations: true, // iOS
          disableSuccessBeep: false, // iOS
        }
      );
    }
    function openQrSacnner() {
      if (window.cordova) {
        openCordovaQrScanner();
      } else {
        setshowScanner(true);
      }
    }

    const handleSearchTabChange = (event, newValue) => {
      setSearchTabValue(newValue);
    };

    return (
      <div className="searchtabscontainer customregistrationtabs regcasetabs customPadding">
        <AppBar
          position="static"
          className="secondheader"
          // style={{ bottom: '115px' }}
        >
          <Tabs
            value={searchTabvalue}
            onChange={handleSearchTabChange}
            aria-label="simple tabs example"
            variant="fullWidth"
          >
            {searchPageMeta.tabsList.map((tabdetails, i) => {
              if (tabdetails.showMenu && tabdetails.name != "Specimen") {
                return (
                  <Tab
                    className="whitetext"
                    key={i}
                    style={{ color: "#fff !important" }}
                    label={t(tabdetails.name)}
                    {...a11yProps(i)}
                  />
                );
              }
            })}
          </Tabs>
        </AppBar>
        <TabPanel
          value={searchTabvalue}
          index={0}
          dir={theme.direction}
          style={{ padding: "0px 0px !important" }}
        >
          {metaData != null ? createCustomSearchForm() : null}
        </TabPanel>

        <TabPanel
          value={searchTabvalue}
          index={1}
          dir={theme.direction}
          className={classes.paddingclass}
          style={{ padding: "20px 0px !important" }}
        >
          {metaData != null ? createUICSearchForm() : null}
        </TabPanel>

        <TabPanel
          value={searchTabvalue}
          index={2}
          dir={theme.direction}
          className={classes.paddingclass}
          style={{ padding: "20px 0px !important" }}
        >
          {metaData != null ? createQRFrom() : null}
        </TabPanel>
        <TabPanel
          value={searchTabvalue}
          index={3}
          className={classes.paddingclass}
          style={{ padding: "20px 0px !important" }}
        >
          {metaData != null ? createSpecimenSearchForm(searchFilter) : null}
        </TabPanel>
      </div>
    );
  }

  function CustomeCaseCard(row) {
    const history = useHistory();
    const { t } = useTranslation();

    const [headers] = React.useState(row.searchHeader);
    const findIndexOfClientType = headers.findIndex(
      (obj) => obj.column.trim().toLocaleLowerCase() == "client type"
    );
    const clientType = row.row[findIndexOfClientType]
      ? row.row[findIndexOfClientType]
      : "";
    const clientTypeId = headers[findIndexOfClientType]
      ? headers[findIndexOfClientType].name
      : "";
    //const [vType] = useState(row.viewType)
    const classes = useStyles();
    const [expanded, setExpanded] = useState(false);

    const [anchorEl, setAnchorEl] = useState(null);
    const [UserBO, setUserBO] = useState(null);
    const [metaData, setMetaData] = useState(null);
    const setGlobalSpinner = useGlobalSpinnerActionsContext();
    //redux state selector and dispatch action
    const postResgistrationResponse = useSelector(
      (state) => state.postResgistrationResponse
    );
    const dispatch = useDispatch();

    // async function getUserBO() {
    //   let userdata = await OfflineDb.getDataFromPouchDB('loginDetails');
    //   setUserBO(userdata.data)

    //   let metaData = await OfflineDb.getDataFromPouchDB('metaData');
    //   setMetaData(metaData.data)
    // }

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const handleExpandClick = () => {
      setExpanded(!expanded);
    };

    const seeIndividualRecordClick = () => {
      
      localStorage.setItem("trackedEntityInstance", row.row[0]);
      localStorage.setItem("linkContact", false);
      localStorage.setItem("hidebutton", true);

      setAnchorEl(null);
      setGlobalSpinner(true);
      // console.log("1233")
      history.push("/layout/individualrecord", {
        trackedEntityInstance: row.row[0],
      });
    };

    const addContcat = () => {
      const activeCaseFormData = {
        formFormat: { [clientTypeId]: Configuration.ltbiLinkVariables.contact },
        dhisFormat: null,
      };
      const linkContact = {
        enabled: true,
        linkTrackedEntityInstance: row.row[0],
      };
      //OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)
      OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
      OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
      history.push("/layout/registration");
    };

    function UpdateRecordClick() {
      setGlobalSpinner(true);

      //   const formDataMassaged = {}

      //   row.metaData.programs[0].programTrackedEntityAttributes.map(field => {
      //     const fieldId = field.trackedEntityAttribute.id
      //     const fieldValue = row.row[row.searchHeader.findIndex(obj => obj.name == field.trackedEntityAttribute.id)]

      //     formDataMassaged[fieldId]= fieldValue
      //   })

      const activeCaseDetails = {
        trackedEntityInstance: row.row[0],
        enrollmentId: "",
      };
      //   const activeCaseFormData = {
      //     'formFormat': null, //formDataMassaged,
      //     'dhisFormat': null
      //   }
      //   const linkContact = {
      //     "enabled": false,
      //     "linkTrackedEntityInstance": row.row[0]
      //   }
      OfflineDb.setDataIntoPouchDB("activeCaseDetails", activeCaseDetails);
      //   // OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)
      //   OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)
      //   setGlobalSpinner(false)
      //   history.push('/layout/registration')
      setActiveCaseDetails({
        data: {
          trackedEntityInstance: row.row[0],
          enrollmentId: "",
        },
      });
      setSearchResponse(null);
      setValue(1);
    }

    const getIndividualsList = () => {
      localStorage.setItem("trackedEntityInstance", row.row[0]);
      history.push("/layout/individual-cases-list", {
        trackedEntityInstance: row.row[0],
      });
    };

    const caseCardView = () => {
      return (
        <Grid
          item
          xs={12}
          sm={6}
          md={row.parentPage && row.parentPage == "registration" ? 6 : 3}
        >
          <Card className={classes.root}>
            <CardHeader
              className="casescardheader"
              avatar={
                <Avatar aria-label="recipe" className={classes.avatar}>
                  <EventNoteIcon />
                </Avatar>
              }
              //   action={
              //     <div>
              //       {row.hideOptions != 'true' ? <IconButton aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>
              //         <MoreVertIcon />
              //       </IconButton > : <> </>}

              //       <Menu
              //         id="simple-menu"
              //         className="casesactionmenu"
              //         anchorEl={anchorEl}
              //         keepMounted
              //         open={Boolean(anchorEl)}
              //         onClose={handleClose}
              //       >
              //         <MenuItem onClick={() =>seeIndividualRecordClick()}><VisibilityIcon /> {t('See Individual Record')}</MenuItem>
              //         <MenuItem onClick={() =>UpdateRecordClick()}><EditIcon /> {t('New/Update Individual Record')}</MenuItem>
              //       </Menu>
              //     </div>
              //   }
              title=""
              subheader=""
            />

            <CardContent className="zero caselistholder">
              <Customcaseslist
                row={row}
                viewType={row.viewType}
              ></Customcaseslist>
            </CardContent>
            <CardActions disableSpacing className="cardactionfooter">
              {row.hideOptions != "true" ? (
                <>
                  {/* <IconButton aria-label="add to favorites" onClick={seeIndividualRecordClick}>
                        <VisibilityIcon />
                      </IconButton> */}
                  <IconButton aria-label="share" onClick={UpdateRecordClick}>
                    <EditIcon />
                  </IconButton>{" "}
                </>
              ) : (
                <> </>
              )}
              {clientType.toLocaleLowerCase() == "index" ? (
                <>
                  {/* <IconButton aria-label="share" title="Individuals List" onClick={getIndividualsList}>
                        <GroupIcon />
                        </IconButton>
                    <button className="caseSearchButton" type="button" onClick={addContcat}>{t('Add contact')}</button> */}
                </>
              ) : (
                <> </>
              )}

              <IconButton
                className={clsx(classes.expand, {
                  [classes.expandOpen]: expanded,
                })}
                onClick={handleExpandClick}
                aria-expanded={expanded}
                aria-label="show more"
              ></IconButton>
            </CardActions>
          </Card>
        </Grid>
      );
    };

    return row.viewType == "card" ? caseCardView() : null;
  }

  function getUICFromAPI() {
    return new Promise((resolve, reject) => {
      if (navigator.onLine) {
        setGlobalSpinner(true);
        apiServices
          .generateUIC(uicId)
          .then((response) => {
            resolve(response.value);
            setGlobalSpinner(false);
          })
          .catch((err) => {
            setGlobalSpinner(false);
            resolve();
          });
      } else {
        OfflineDb.getDataFromPouchDB("offlineUICList").then((res) => {
          if (res && res.data) {
            let uicobj = res.data.pop();
            if (uicobj) {
              resolve(uicobj.value);
            }
            OfflineDb.setDataIntoPouchDB("offlineUICList", res.data);
          }
        });
      }
    });
  }

  async function renderIndexForm(values) {
    //console.log("values ",values)
    setChildFormValues(values);
    setAddIndex(true);
    let getUIC = await getUICFromAPI();
    const linkContact = {
      enabled: false,
      linkTrackedEntityInstance: null,
    };
    OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
    setLinkContactFlag({
      data: linkContact,
    });
    setActiveCaseFormData({
      data: {
        formFormat: {
          [clientTypeID]: Configuration.ltbiLinkVariables.index,
          [regAddressId]: values[regAddressId] ? values[regAddressId] : "",
          [addressLocationId]: values[addressLocationId]
            ? values[addressLocationId]
            : "",
          [uicId]: getUIC,
        },
        dhisFormat: null,
      },
    });
  }

  function openIndexClientModal(values) {
    setActiveCaseFormData({
      data: {
        formFormat: values,
        dhisFormat: null,
      },
    });
    if (navigator.onLine) {
      const orgUnit = userData.organisationUnits[0].id;
      const getURL =
        "trackedEntityInstances/query.json?ou=" +
        orgUnit +
        "&ouMode=SELECTED&program=" +
        programData.programs[0].id +
        "&attribute=" +
        clientTypeID +
        ":EQ:Index&skipPaging=true";
      setGlobalSpinner(true);
      apiServices
        .getAPI(getURL)
        .then((res) => {
          //console.log("res ",res);
          setGlobalSpinner(false);
          if (res.data && res.data.rows && res.data.rows.length > 0) {
            res.data.rows = res.data.rows.reverse();
          }
          setIndexClientList(res.data);
          setIndexOriginalClientList(res.data);
        })
        .catch((err) => {
          setGlobalSpinner(false);
          setIndexClientList([]);
        });
    } else {
      try {
        //OfflineStorage
        let indexList = [];
        OfflineDb.getAllEntities().then((res) => {
          if (res && res.total_rows && res.total_rows > 0) {
            let indexBO = {
              headers: [
                { column: "Instance", name: "instance" },
                { column: "First name", name: givenName },
              ],
              rows: [],
            };
            res.rows.map((entityObj) => {
              if (
                Configuration &&
                entityObj.doc.data &&
                entityObj.doc.data[clientTypeID] ==
                  Configuration.ltbiLinkVariables.index
              ) {
                let rowBO = [];
                rowBO.push(entityObj.id);
                rowBO.push(entityObj.doc.data[firstNameId]);
                indexBO.rows.push(rowBO);
              }
            });
            setIndexClientList(indexBO);
          } else {
            setIndexClientList([]);
          }
        });
      } catch (e) {
        setIndexClientList([]);
      }
    }
  }
  function handleRadioChange(event) {
    console.log(event, event.target.value);
    setIndexClientInstanceId(event.target.value);
  }

  function attachIndexSubmit() {
    let clientFound = false;
    const givenNameId =
      indexClientList && indexClientList.headers
        ? _.findIndex(indexClientList.headers, { name: givenName })
        : null;
    const addressId =
      indexClientList && indexClientList.headers
        ? _.findIndex(indexClientList.headers, { name: regAddressId })
        : null;
    const regaddressLocationId =
      indexClientList && indexClientList.headers
        ? _.findIndex(indexClientList.headers, { name: addressLocationId })
        : null;
    let addressData = null;
    let addressLocationData = null;
    indexClientList.rows.map((ele, index) => {
      if (ele.includes(indexClientInstanceId)) {
        clientFound = true;
        setParentName(ele[givenNameId]);
        addressData = addressId ? ele[addressId] : "";
        addressLocationData = regaddressLocationId
          ? ele[regaddressLocationId]
          : "";
      }
    });
    if (clientFound) {
      const linkContact = {
        enabled: true,
        linkTrackedEntityInstance: indexClientInstanceId,
      };
      OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
      setLinkContactFlag({
        data: linkContact,
      });
      if (addressData) {
        try {
          let initialValues = activeCaseFormData.data
            ? activeCaseFormData.data.formFormat != null
              ? activeCaseFormData.data.formFormat
              : {}
            : {};
          let tempObj = _.cloneDeep(initialValues);
          if (addressId && regAddressId) {
            tempObj[regAddressId] = addressData;
            console.log("childData1", initialValues);
          }
          if (regaddressLocationId && addressLocationData) {
            tempObj[addressLocationId] = addressLocationData;
            console.log("childData1", initialValues);
          }
          setActiveCaseFormData({
            data: {
              formFormat: tempObj, //valueForFormInput,
              dhisFormat: null, //
            },
          });
        } catch (e) {}
      }
      setIndexClientList(null);
    } else {
      swal({
        title: t("Alert"),
        text: t("No index client found."),
        icon: "warning",
        buttons: t("Ok"),
      });
      setIndexClientList(null);
    }
  }

  function renderIndexClientList() {
    //console.log("OpenIndexClientList ",indexClientList);
    const instanceId =
      indexClientList && indexClientList.headers
        ? _.findIndex(indexClientList.headers, { name: "instance" })
        : null;
    const givenNameId =
      indexClientList && indexClientList.headers
        ? _.findIndex(indexClientList.headers, { name: givenName })
        : null;
    //console.log("instanceId ",instanceId,givenNameId);
    return indexClientList &&
      indexClientList.rows &&
      indexClientList.rows.length > 0 ? (
      <div style={{ width: "100%", paddingLeft: "20px" }}>
        <FormControl component="fieldset">
          <RadioGroup
            aria-label="index"
            name="select-form"
            value={indexClientInstanceId}
            onChange={handleRadioChange}
          >
            {indexClientList.rows.map((ele, index) => {
              return (
                <FormControlLabel
                  style={{ textAlign: "left" }}
                  value={ele[instanceId]}
                  control={<Radio />}
                  label={ele[givenNameId]}
                />
              );
            })}
          </RadioGroup>
        </FormControl>
      </div>
    ) : (
      <>{t("No index client found!")}</>
    );
  }

  // Search tab code END
  function createRegistrationForm(
    programObj,
    programRules,
    programRulesVariables
  ) {
    let programData = programObj.programs[0];
    let registrationFields = programData.programTrackedEntityAttributes;

    let initialValues = activeCaseFormData.data
      ? activeCaseFormData.data.formFormat != null
        ? activeCaseFormData.data.formFormat
        : {}
      : {};

    /*let clientTypeID = null
    registrationFields.map((field, index) => {
        if(field.trackedEntityAttribute.displayName == "Client type"){
            clientTypeID = field.trackedEntityAttribute.id
            if(!initialValues.hasOwnProperty(clientTypeID)){
                activeCaseFormData.data.formFormat[clientTypeID] = Configuration.ltbiLinkVariables.presumptivetb;
            }
        }
    })*/
    return (
      <Form
        onSubmit={onSubmit}
        initialValues={initialValues}
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form className="fullWidth" onSubmit={handleSubmit}>
            <div className="innertabdivreg subclass5">
              <>
                {
                  // multicheckbox save logic
                  programData != null
                    ? programData.programSections.map((programSection) => {
                        if (
                          programSection.renderType["DESKTOP"].type ==
                          "SEQUENTIAL"
                        ) {
                          if (values[programSection.id] != undefined) {
                            programSection.trackedEntityAttributes.map(
                              (elements) => {
                                delete values[elements.id];
                              }
                            );
                            values[programSection.id].map((value) => {
                              values[value] = true;
                            });
                          }
                        }
                      })
                    : null
                }
              </>
              <>
                {" "}
                {!openCamera ? (
                  <p
                    className={
                      Configuration.registrationForm.showOCR
                        ? "ocrbuttonholder text-right"
                        : "ocrbuttonholder text-right hide"
                    }
                  >
                    <Button
                      className="regSearchCancelButton"
                      onClick={() => setCameraStatus(true)}
                    >
                      <ControlCameraIcon />
                      {t("OCR")}
                    </Button>
                  </p>
                ) : (
                  <> </>
                )}{" "}
              </>
              <>
                {" "}
                {openCamera ? (
                  <p
                    className={
                      Configuration.registrationForm.showOCR
                        ? "ocrbuttonholder text-right"
                        : "ocrbuttonholder text-right hide"
                    }
                  >
                    <Button
                      className="regSearchCancelButton"
                      onClick={() => setCameraStatus(false)}
                    >
                      <ControlCameraIcon />
                      {t("Close OCR")}
                    </Button>
                  </p>
                ) : (
                  <> </>
                )}{" "}
              </>
              <Grid container spacing={3}>
                {programData != null
                  ? programData.programSections.length > 0
                    ? renderRegistrationSections(
                        programData,
                        values,
                        form,
                        programRules,
                        props.icons
                      )
                    : registrationFields.map((fieldsObject) => {
                        return renderRegistrationField(
                          fieldsObject,
                          values != null ? values : {},
                          programData
                        );
                      })
                  : null}
              </Grid>
              <br />

              <Grid
                className={
                  activeCaseDetails &&
                  activeCaseDetails.error &&
                  values &&
                  values[clientTypeID] ==
                    Configuration.ltbiLinkVariables.contact
                    ? parentName
                      ? ""
                      : linkContactFlag &&
                        linkContactFlag.data &&
                        linkContactFlag.data.enabled == true
                      ? "hide"
                      : ""
                    : "hide"
                }
              >
                {
                  //console.log("initi ",values,initialValues,clientTypeID,values[clientTypeID],Configuration.ltbiLinkVariables.contact,values[clientTypeID] == Configuration.ltbiLinkVariables.contact)
                }
                <Grid container>
                  <div className="fl-left">
                    <b>Index Details:</b>
                  </div>
                  &nbsp;
                  <div className="fl-left">
                    {parentName ? parentName : "N/A"}
                  </div>
                </Grid>
                {/* {navigator.onLine ?  */}
                <Grid container style={{ maxWidth: "300px" }}>
                  <Grid
                    container
                    spacing={0}
                    xs={5}
                    lg={5}
                    className="attach-add-index-link"
                    onClick={() => openIndexClientModal(values)}
                  >
                    {navigator.onLine
                      ? t("Attach Index")
                      : t("Attach Offline Index")}
                  </Grid>
                  <Grid container spacing={0} xs={2} lg={2}>
                    OR
                  </Grid>
                  <Grid
                    container
                    spacing={0}
                    xs={5}
                    lg={5}
                    className="attach-add-index-link"
                    onClick={() => renderIndexForm(values)}
                  >
                    {t("Add Index")}
                  </Grid>
                </Grid>
                {/* : <></>} */}
              </Grid>
              {Configuration.registrationForm.enableWhatsapp ? (
                <Field
                  type="checkbox"
                  component={CheckboxFieldFF}
                  name="whatsApp"
                  label="Receive whatsApp update"
                  initialValue="whatsApp"
                  className="hide"
                />
              ) : (
                <></>
              )}
              {initialValues && initialValues[qrCodeId] ? (
                <div>
                  <QRCode
                    id="qr-gen"
                    value={initialValues[qrCodeId]}
                    size={100}
                    level={"H"}
                    includeMargin={true}
                    //onClick={enlargeImg}
                  />
                  {!window.cordova ? (
                    <p>
                      <button
                        type="button"
                        onClick={() => downloadQRCode(initialValues[qrCodeId])}
                      >
                        {t("Download QR Code")}
                      </button>
                    </p>
                  ) : (
                    <></>
                  )}
                  {window.cordova && navigator.onLine ? (
                    <p>
                      <button
                        type="button"
                        onClick={() => shareQRCode(initialValues)}
                      >
                        {t("Share QR Code")}
                      </button>
                    </p>
                  ) : null}
                </div>
              ) : (
                <></>
              )}
              <div
                className="buttons"
                style={{ textAlign: "right", paddingBottom: "10px" }}
              >
                <button
                  className="regformsubmitbtn"
                  type="submit"
                  disabled={submitting}
                >
                  {t("Submit")}
                </button>
              </div>

              {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
            </div>
          </form>
        )}
      />
    );
  }

  const downloadQRCode = (qrValue) => {
    // Generate download with use canvas and stream
    const canvas = document.getElementById("qr-gen");
    const pngUrl = canvas
      .toDataURL("image/png")
      .replace("image/png", "image/octet-stream");
    let downloadLink = document.createElement("a");
    downloadLink.href = pngUrl;
    downloadLink.download = "qrcode.png"; //`${qrValue}.png`;
    document.body.appendChild(downloadLink);
    downloadLink.click();
    document.body.removeChild(downloadLink);
  };

  function QRImageUploadSuccessCallback(r) {
    setGlobalSpinner(false);
    if (r && r.secure_url) {
      console.log("rr ", r.secure_url);
      //window.plugins.socialsharing.share('Prevent TB: QR Code', null, r.secure_url, null)
      window.plugins.socialsharing.shareViaWhatsApp(
        "Prevent TB: QR Code",
        r.secure_url,
        null /* url */,
        function () {
          console.log("share ok");
        },
        function (errormsg) {
          console.log(errormsg);
        }
      );
    }
  }

  const shareQRCode = (value) => {
    var canvas = document.getElementById("qr-gen");
    var dataUri = canvas.toDataURL("image/png");
    //console.log("base64String ",dataUri);
    //setGlobalSpinner(true)
    // Do stuff with the photo...

    //window.plugins.socialsharing.shareViaWhatsApp('Prevent TB: QR Code', null, dataUri, null)
    let messageTxt =
      "Dear " +
      value[firstNameId] +
      ", Thank you for registering in the program , please produce this QR code at the treatment center to avail quick services";
    window.plugins.socialsharing.shareViaWhatsApp(
      messageTxt,
      dataUri,
      null /* url */,
      function () {
        console.log("share ok");
      },
      function (errormsg) {
        console.log(errormsg);
      }
    );
    // const API_ENDPOINT = 'https://api.cloudinary.com/v1_1/dh5r8k5vs/upload';
    // dataUri = dataUri.includes("data:image/jpeg;base64,") ? dataUri : "data:image/jpeg;base64,"+dataUri;
    // const fileData = new FormData();
    // fileData.append('file', dataUri);
    // fileData.append('upload_preset', 'uploadthroughapp');
    // //fileData.append('tags', 'xxxxxx'); // optional

    // fetch(API_ENDPOINT, {
    //     method: 'post',
    //     body: fileData
    // })
    // .then(response => response.json())
    // .then(data => QRImageUploadSuccessCallback(data))
    // .catch(err => {
    //     console.error('Error:', err)
    //     setGlobalSpinner(false)
    // });

    // Generate download with use canvas and stream
    //const canvas = document.getElementById("qr-gen");
    // const pngUrl = canvas
    //     .toDataURL("image/png")
    //     .replace("image/png", "image/octet-stream");
    // window.canvas2ImagePlugin.saveImageDataToLibrary(
    //     function(msg){
    //         console.log(msg);  //msg is the filename path (for android and iOS)
    //     },
    //     function(err){
    //         console.log(err);
    //     },
    //     document.getElementById('qr-gen')
    // );

    // var params = {data: base64String, prefix: 'mqr_', format: 'JPG', quality: 80, mediaScanner: true};
    // window.imageSaver.saveBase64Image(params,
    //     function (filePath) {
    //       console.log('File saved on ' + filePath);
    //     },
    //     function (msg) {
    //       console.error(msg);
    //     }
    //   );
  };

  function updateRegDataToIndex() {
    const values = [];
    const UserBO = props.userData;
    const programData = props.programData.programs[0];
    const programId = programData.id;
    const orgUnit = UserBO.organisationUnits[0].id;
    const trackedEntityType = programData.trackedEntityType.id;
    const caseDetails = trackentityInstanceDetails;
    const updateURL =
      "trackedEntityInstances/" + caseDetails.trackedEntityInstance;

    caseDetails.attributes.map((attr) => {
      var obj = {
        attribute: attr.attribute,
        value: attr.value,
      };
      if (attr.attribute == clientTypeID) {
        obj["value"] = "Index";
      }
      values.push(obj);
    });
    const updateCaseInput = {
      created: caseDetails.created,
      orgUnit: orgUnit,
      createdAtClient: caseDetails.createdAtClient,
      trackedEntityInstance: caseDetails.trackedEntityInstance,
      lastUpdated: caseDetails.lastUpdated,
      trackedEntityType: trackedEntityType,
      lastUpdatedAtClient: caseDetails.lastUpdatedAtClient,
      inactive: false,
      deleted: false,
      featureType: "NONE",
      programOwners: [
        {
          ownerOrgUnit: orgUnit,
          program: programId,
          trackedEntityInstance: caseDetails.trackedEntityInstance,
        },
      ],
      relationships: [],
      attributes: values,
    };
    apiServices.putAPI(updateURL, updateCaseInput).then((updateRes) => {});
  }

  const addNextService = (currentStageBO,callback) =>{
    setAddNewServiceFlag(true);
    swal({
        title: t("New Visit"),
        text: t("Do you want to add another visit?"),
        icon: "warning",
        buttons: [t("No"), t("Yes")],
    })
    .then((AlertRes) => {
        if (AlertRes) {
            starttoNewService(currentStageBO)
        }else{
            //setValue(stageTabVal)
            setAddNewServiceFlag(false);
            //history.push('/layout/home')
            callback()
        }
    })
}


  function saveStage(
    valueToStore,
    valueForFormInput,
    currentStage,
    currentStageIndex,
    fetchActiveTab
  ) {
    console.log(
      "valueForFormInput,valueToStore",
      valueForFormInput,
      valueToStore,
      currentStage,
      adherenceStageId
    );
    const orgUnit = userData.organisationUnits[0].id;
    const programId = programData.programs[0].id;
    const referalAPIObject = { events: [] };

    let registrationFields =
      programData.programs[0].programTrackedEntityAttributes;
    let whatsAppFieldId = "";

    registrationFields.map((regField) => {
      const findWhatsAppAttribute =
        regField.trackedEntityAttribute.attributeValues.find(
          (x) => x.attribute.name == "WhatsAppNumber"
        );
      if (findWhatsAppAttribute) {
        whatsAppFieldId = regField.trackedEntityAttribute.id;
      }
    });

    const saveStageInput = {
      trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      program: programId,
      programStage: currentStage.id,
      enrollment: activeCaseDetails.data.enrollmentId,
      orgUnit: orgUnit,
      notes: [],
      dataValues: valueToStore,
      status: "COMPLETED",
      eventDate: moment().format("YYYY-MM-DD"),
    };
    // logic for regimen stage save data
    if (
      currentStage.attributeValues &&
      currentStage.attributeValues.length > 0
    ) {
      currentStage.attributeValues.map((val, i) => {
        if (
          (val.attribute.displayName === "Regimen" && val.value == "true") ||
          (val.attribute.displayName === "showFullCalender" && val.value == "true")
        ) {
          if (
            medicineTable.length > 0 &&
            val.attribute.displayName === "Regimen" &&
            val.value == "true"
          ) {
            // focefully remove treatmentAdherenceId
            valueToStore.map((ele, idx) => {
              if (ele.dataElement == treatmentAdherenceId) {
                valueToStore.splice(idx, 1);
              }
            });
            medicineTable.map((row) => {
              const regimenConfigObject = _.find(
                Configuration.treatmentRegimens,
                { code: row[treatmentRegimenId], phase: row[treatmentPhaseId] }
              );

              if (regimenConfigObject != undefined) {
                let fieldDetails = _.filter(
                  currentStage.programStageDataElements,
                  [
                    "dataElement.description",
                    regimenConfigObject.associatedFieldName,
                  ]
                );

                let objvalueToStore = _.cloneDeep(valueToStore);
                let rowdata = Object.assign({}, row);
                //medicine
                let obj = {
                  dataElement: fieldDetails[0].dataElement.id,
                  value: rowdata["medicine"]["code"],
                };
                /*objvalueToStore.map((ele,idx)=>{
                                if(ele.dataElement == fixedDoseChildren.id){
                                    //ele.value = rowdata['medicine']['code']
                                    objvalueToStore.splice(idx,1)
                                }
                            })*/
                objvalueToStore.push(Object.assign({}, obj));
                objvalueToStore.push({
                  dataElement: treatmentAdherenceId,
                  value: rowdata[treatmentAdherenceId],
                });

                let tempSaveStageInput = _.cloneDeep(saveStageInput);
                tempSaveStageInput["dataValues"] = objvalueToStore;
                referalAPIObject.events.push(tempSaveStageInput);
              }
              /*if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                            let objvalueToStore = _.cloneDeep(valueToStore);
                            let rowdata = Object.assign({},row);
                            //medicine
                            let obj =  {
                                    "dataElement":fixedDoseChildren.id,
                                    "value":rowdata['medicine']['code']
                                    }
                            objvalueToStore.push(Object.assign({},obj))
                            objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                            
                            let tempSaveStageInput = _.cloneDeep(saveStageInput);
                            tempSaveStageInput['dataValues'] = objvalueToStore
                            referalAPIObject.events.push(tempSaveStageInput)
                        }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                            let objvalueToStore = _.cloneDeep(valueToStore);
                            let rowdata = Object.assign({},row);
                            let obj =  {
                                    "dataElement":singleDoseChildren.id,
                                    "value":rowdata['medicine']['code']
                                    }
                            
                            objvalueToStore.push(Object.assign({},obj))
                            objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                            let tempSaveStageInput = _.cloneDeep(saveStageInput);
                            tempSaveStageInput['dataValues'] = objvalueToStore
                            referalAPIObject.events.push(tempSaveStageInput)
                        }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                            let objvalueToStore = _.cloneDeep(valueToStore);
                            let rowdata = Object.assign({},row);
                            let obj =  {
                                    "dataElement":fixedDoseAdult.id,
                                    "value":rowdata['medicine']['code']
                                    }
                            
                            objvalueToStore.push(Object.assign({},obj))
                            objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                            let tempSaveStageInput = _.cloneDeep(saveStageInput);
                            tempSaveStageInput['dataValues'] = objvalueToStore
                            referalAPIObject.events.push(tempSaveStageInput)
     
                        }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                            let objvalueToStore = _.cloneDeep(valueToStore);
                            let rowdata = Object.assign({},row);
                            let obj =  {
                                    "dataElement":singleDoseAdult.id,
                                    "value":rowdata['medicine']['code']
                                    }
                            objvalueToStore.push(Object.assign({},obj))
                            objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                            let tempSaveStageInput = _.cloneDeep(saveStageInput);
                            tempSaveStageInput['dataValues'] = objvalueToStore
                            referalAPIObject.events.push(tempSaveStageInput)
                        }*/
            });
          } else if (val.attribute.displayName === "showFullCalender") {
            if (fullCalendarEvents.length > 0) {
              fullCalendarEvents.map((event) => {
                if (
                  currentStage.id == adherenceTBStageId &&
                  medicineTable.length > 0
                ) {
                  medicineTable.map((row) => {
                    // debugger;
                    // focefully remove fixed dose value
                    /*valueToStore.map((ele,idx)=>{
                                      if(ele.dataElement == fixedDoseChildren.id){
                                          valueToStore.splice(idx,1)
                                      }
                                  })*/
                    const regimenConfigObject = _.find(
                      Configuration.treatmentRegimens,
                      {
                        code: row[treatmentRegimenId],
                        phase: row[treatmentPhaseId],
                      }
                    );
                    if (regimenConfigObject != undefined) {
                      let fieldDetails = _.filter(
                        currentStage.programStageDataElements,
                        [
                          "dataElement.description",
                          regimenConfigObject.associatedFieldName,
                        ]
                      );
                      //if (fieldDetails && fieldDetails.length > 0) {
                      let objvalueToStore = _.cloneDeep(valueToStore);
                      objvalueToStore = _.reject(objvalueToStore, {
                        value: "",
                      });
                      let rowdata = Object.assign({}, row);
                      let obj = {};
                      //medicine
                      if (fieldDetails && fieldDetails.length > 0) {
                        objvalueToStore = _.reject(objvalueToStore, {
                          dataElement: fieldDetails[0].dataElement.id,
                        });
                        obj = {
                          dataElement: fieldDetails[0].dataElement.id,
                          value: rowdata["medicine"]["code"],
                        };
                      }
                      objvalueToStore.map((ele, idx) => {
                        /* if (ele.dataElement == fieldDetails[0].dataElement.id) {
                                              //ele.value = rowdata['medicine']['code']
                                              objvalueToStore.splice(idx, 1)
                                          }*/

                        switch (ele.dataElement) {
                          case fieldDetails &&
                            fieldDetails[0] &&
                            fieldDetails[0].dataElement.id:
                            objvalueToStore.splice(idx, 1);
                            break;
                          case treatmentAdherenceId:
                            objvalueToStore.splice(idx, 1);
                            break;
                          case medicineColorCodeId:
                            objvalueToStore.splice(idx, 1);
                            break;
                          case medicineTakenId:
                            objvalueToStore.splice(idx, 1);
                            break;
                          case dateMedicineTakenId:
                            objvalueToStore.splice(idx, 1);
                            break;
                        }
                      });
                      try {
                        if (
                          objvalueToStore.findIndex(
                            (ob) => ob.dataElement == medicineColorCodeId
                          )
                        ) {
                          objvalueToStore.splice(
                            objvalueToStore.findIndex(
                              (ob) => ob.dataElement == medicineColorCodeId
                            ),
                            1
                          );
                        }
                        if (
                          objvalueToStore.findIndex(
                            (ob) => ob.dataElement == dateMedicineTakenId
                          )
                        ) {
                          objvalueToStore.splice(
                            objvalueToStore.findIndex(
                              (ob) => ob.dataElement == dateMedicineTakenId
                            ),
                            1
                          );
                        }
                        if (
                          objvalueToStore.findIndex(
                            (ob) => ob.dataElement == treatmentAdherenceId
                          )
                        ) {
                          objvalueToStore.splice(
                            objvalueToStore.findIndex(
                              (ob) => ob.dataElement == treatmentAdherenceId
                            ),
                            1
                          );
                        }
                        if (
                          objvalueToStore.findIndex(
                            (ob) => ob.dataElement == medicineTakenId
                          )
                        ) {
                          objvalueToStore.splice(
                            objvalueToStore.findIndex(
                              (ob) => ob.dataElement == medicineTakenId
                            ),
                            1
                          );
                        }
                      } catch (e) {}
                      if (!_.isEmpty(obj)) {
                        objvalueToStore.push(Object.assign({}, obj));
                      }

                      //radioValue
                      let medicineTakenValue =
                        radioValue &&
                        !_.isEmpty(radioValue) &&
                        _.get(radioValue, rowdata["medicine"]["code"])
                          ? _.get(radioValue, rowdata["medicine"]["code"])
                          : "yes";
                      try {
                        if (_.isArray(event.medicineTaken)) {
                          event.medicineTaken.map((med) => {
                            Object.keys(med).map((medName) => {
                              if (rowdata["medicine"]["code"] == medName) {
                                medicineTakenValue = med[medName];
                              }
                            });
                          });
                        }
                      } catch (e) {
                        console.log(e);
                      }
                      objvalueToStore.push(
                        Object.assign(
                          {},
                          {
                            dataElement: medicineTakenId,
                            value: medicineTakenValue,
                            //"value": radioValue && !_.isEmpty(radioValue) && (_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : event.medicineTaken ? event.medicineTaken : 'yes'
                          }
                        )
                      );
                      //push date medicine taken
                      objvalueToStore.push({
                        dataElement: dateMedicineTakenId,
                        value: event.start,
                      });

                      //push color code
                      objvalueToStore.push(
                        Object.assign(
                          {},
                          {
                            dataElement: medicineColorCodeId,
                            value: event.backgroundColor,
                          }
                        )
                      );

                      //push adherenceid
                      objvalueToStore.push(
                        Object.assign(
                          {},
                          {
                            dataElement: treatmentAdherenceId,
                            value: rowdata[treatmentAdherenceId],
                          }
                        )
                      );
                      let tempSaveStageInput = _.cloneDeep(saveStageInput);
                      tempSaveStageInput["dataValues"] =
                        _.cloneDeep(objvalueToStore);
                      referalAPIObject.events.push(tempSaveStageInput);
                      //}
                    }
                    /*if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                                      let objvalueToStore = _.cloneDeep(valueToStore);
                                      let rowdata = Object.assign({},row);
                                      //medicine
                                      let obj =  {
                                              "dataElement":fixedDoseChildren.id,
                                              "value":rowdata['medicine']['code']
                                              }
                                      objvalueToStore.map((ele,idx)=>{
                                          if(ele.dataElement == fixedDoseChildren.id){
                                              //ele.value = rowdata['medicine']['code']
                                              objvalueToStore.splice(idx,1)
                                          }
                                      })
                                      objvalueToStore.push(Object.assign({},obj))
                                    
                                      //radioValue
                                      
                                      objvalueToStore.push(Object.assign({},
                                          {
                                              "dataElement":medicineTakenId,
                                              "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                          }
                                      ))
                                      //push date medicine taken
                                      objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                      //push adherenceid
                                      objvalueToStore.push(Object.assign({},{"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]}))
                                      
                                      let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                      tempSaveStageInput['dataValues'] = _.cloneDeep(objvalueToStore);
                                      
                                      referalAPIObject.events.push(tempSaveStageInput)
                                  }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                                      let objvalueToStore = _.cloneDeep(valueToStore);
                                      let rowdata = Object.assign({},row);
                                      let obj =  {
                                              "dataElement":singleDoseChildren.id,
                                              "value":rowdata['medicine']['code']
                                              }
                                      objvalueToStore.map((ele,idx)=>{
                                          if(ele.dataElement == singleDoseChildren.id){
                                              objvalueToStore.splice(idx,1)
                                          }
                                      })
                                      objvalueToStore.push(Object.assign({},obj))
      
                                      //radioValue
                                      objvalueToStore.push(Object.assign({},
                                          {
                                              "dataElement":medicineTakenId,
                                              "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                          }
                                      ))
                                      //push date medicine taken
                                      objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                      objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                      let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                      tempSaveStageInput['dataValues'] = objvalueToStore
                                      referalAPIObject.events.push(tempSaveStageInput)
                                  }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                                      let objvalueToStore = _.cloneDeep(valueToStore);
                                      let rowdata = Object.assign({},row);
                                      let obj =  {
                                              "dataElement":fixedDoseAdult.id,
                                              "value":rowdata['medicine']['code']
                                              }
                                      objvalueToStore.map((ele,idx)=>{
                                          if(ele.dataElement == fixedDoseAdult.id){
                                              objvalueToStore.splice(idx,1)
                                          }
                                      })
                                      objvalueToStore.push(Object.assign({},obj))
      
                                      //radioValue
                                      objvalueToStore.push(Object.assign({},
                                          {
                                              "dataElement":medicineTakenId,
                                              "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                          }
                                      ))
                                      //push date medicine taken
                                      objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                      //push adherenceid
                                      objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                      let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                      tempSaveStageInput['dataValues'] = objvalueToStore
                                      referalAPIObject.events.push(tempSaveStageInput)
              
                                  }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                                      let objvalueToStore = _.cloneDeep(valueToStore);
                                      let rowdata = Object.assign({},row);
                                      let obj =  {
                                              "dataElement":singleDoseAdult.id,
                                              "value":rowdata['medicine']['code']
                                              }
                                      objvalueToStore.map((ele,idx)=>{
                                          if(ele.dataElement == singleDoseAdult.id){
                                              objvalueToStore.splice(idx,1)
                                          }
                                      })
                                      objvalueToStore.push(Object.assign({},obj))
                                      
                                      //radioValue
                                      objvalueToStore.push(Object.assign({},
                                          {
                                              "dataElement":medicineTakenId,
                                              "value":(_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                                          }
                                      ))
                                      //push date medicine taken
                                      objvalueToStore.push({"dataElement":dateMedicineTakenId,"value":event.start})
                                      //push adherenceid
                                      objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":rowdata[treatmentAdherenceId]})
                                      let tempSaveStageInput = _.cloneDeep(saveStageInput);
                                      tempSaveStageInput['dataValues'] = objvalueToStore
                                      referalAPIObject.events.push(tempSaveStageInput)
                                  }*/
                  });
                } else {
                  let objvalueToStore = _.cloneDeep(valueToStore);
                  objvalueToStore = _.reject(objvalueToStore, { value: "" });
                  objvalueToStore.map((ele, idx) => {
                    /* if (ele.dataElement == fieldDetails[0].dataElement.id) {
                                      //ele.value = rowdata['medicine']['code']
                                      objvalueToStore.splice(idx, 1)
                                  }*/
                    switch (ele.dataElement) {
                      case medicineColorCodeId:
                        objvalueToStore.splice(idx, 1);
                        break;
                      case medicineTakenId:
                        objvalueToStore.splice(idx, 1);
                        break;
                      case dateMedicineTakenId:
                        objvalueToStore.splice(idx, 1);
                        break;
                    }
                  });
                  objvalueToStore.push({
                    dataElement: dateMedicineTakenId,
                    value: event.start,
                  });

                  //push color code
                  objvalueToStore.push(
                    Object.assign(
                      {},
                      {
                        dataElement: medicineColorCodeId,
                        value: event.backgroundColor,
                      }
                    )
                  );

                  //push medicine taken value
                  objvalueToStore.push(
                    Object.assign(
                      {},
                      {
                        dataElement: medicineTakenId,
                        value: event.medicineTaken,
                      }
                    )
                  );
                  let tempSaveStageInput = _.cloneDeep(saveStageInput);
                  tempSaveStageInput["dataValues"] =
                    _.cloneDeep(objvalueToStore);

                  referalAPIObject.events.push(tempSaveStageInput);
                }
              });
            }
          }
        } else if (
          sputumTable.length > 0 &&
          val.attribute.displayName === "SpecimenTable" &&
          val.value == "true"
        ) {
          if (val.attribute.displayName === "SpecimenTable") {
            // console.log('sputumtable??', sputumTable)
            sputumTable.map((row) => {
              let objvalueToStore = _.cloneDeep(valueToStore);
              for (const key in row) {
                if (Object.hasOwnProperty.call(row, key)) {
                  const val = row[key];
                  let obj = {
                    dataElement: key,
                    value: val,
                  };
                  objvalueToStore.push(Object.assign({}, obj));
                }
              }

              let tempSaveStageInput = _.cloneDeep(saveStageInput);
              tempSaveStageInput["dataValues"] = objvalueToStore;
              referalAPIObject.events.push(tempSaveStageInput);
            });
          }
        } else {
          if (i + 1 == currentStage.attributeValues.length && currentStage.id != specimenStageId && currentStage.id != regimenStageId && currentStage.id != adherenceStageId) {
            referalAPIObject.events.push(saveStageInput);
          }
        }
      });
    } else {
      referalAPIObject.events.push(saveStageInput);
    }

    const getAllKeys = Object.keys(valueForFormInput);

    let OUFieldSelectedLocation = "";

    const filterReferalField = getAllKeys.map((keys) => {
      const filter = currentStage.programStageDataElements.filter(
        (obj) => obj.dataElement.id == keys
      );
      if (filter.length > 0) {
        filter.map((filteredField) => {
          if (filteredField.dataElement.fieldMask == "Facility Referral") {
            const filteredKey = filteredField.dataElement.id;
            const selectedOUField =
              currentStage.programStageDataElements.filter(
                (obj) => obj.dataElement.fieldMask == "Facility Referral OU"
              );

            const selectedOUFieldData =
              selectedOUField.length > 0
                ? valueForFormInput[selectedOUField[0].dataElement.id]
                : "";
            OUFieldSelectedLocation = selectedOUFieldData;

            const referalFieldValue = _.isArray(valueForFormInput[filteredKey])
              ? valueForFormInput[filteredKey]
              : [valueForFormInput[filteredKey]];

            referalFieldValue.map((stageId) => {
              const obj = {
                trackedEntityInstance:
                  trackentityInstanceDetails.trackedEntityInstance,
                program: programId,
                programStage: stageId,
                enrollment: navigator.onLine
                  ? trackentityInstanceDetails.enrollments[0].enrollment
                  : "",
                orgUnit: selectedOUFieldData,
                notes: [],
                dataValues: [],
                status: "SCHEDULE",
                dueDate: moment().format("YYYY-MM-DD"),
              };
              if (selectedOUFieldData) {
                referalAPIObject.events.push(obj);
              }
            });
          } else if (filteredField.dataElement.fieldMask == "Transfer Out") {
            const stageId = currentStage.id;
            const selectedOUField = filteredField.dataElement.id;
            const selectedOUFieldData =
              selectedOUField.length > 0
                ? valueForFormInput[selectedOUField]
                : "";
            OUFieldSelectedLocation = selectedOUFieldData;

            const obj = {
              trackedEntityInstance:
                trackentityInstanceDetails.trackedEntityInstance,
              program: programId,
              programStage: stageId,
              enrollment: trackentityInstanceDetails.enrollments[0].enrollment,
              orgUnit: selectedOUFieldData,
              notes: [],
              dataValues: valueToStore,
              status: "SCHEDULE",
              dueDate: moment().format("YYYY-MM-DD"),
            };
            if (selectedOUFieldData) {
              referalAPIObject.events = [];
              referalAPIObject.events.push(obj);
            }
          } else if (filteredField.dataElement.fieldMask == "Transfer In") {
            const stageId = currentStage.id;
            const selectedOUField = filteredField.dataElement.id;
            const selectedOUFieldData =
              selectedOUField.length > 0
                ? valueForFormInput[selectedOUField]
                : "";
            OUFieldSelectedLocation = selectedOUFieldData;

            const obj = {
              trackedEntityInstance:
                trackentityInstanceDetails.trackedEntityInstance,
              program: programId,
              programStage: stageId,
              enrollment: trackentityInstanceDetails.enrollments[0].enrollment,
              orgUnit: selectedOUFieldData,
              notes: [],
              dataValues: valueToStore,
              status: "SCHEDULE",
              dueDate: moment().format("YYYY-MM-DD"),
            };
            if (selectedOUFieldData) {
              referalAPIObject.events = [];
              referalAPIObject.events.push(obj);
            }
          }
        });
      }
    });
    // for Asign task stage logic
    if (
      currentStage.attributeValues &&
      currentStage.attributeValues.length > 0 &&
      currentStage.attributeValues[0].attribute.name == "Assign Task"
    ) {
      let taskAssignUserDataElement =
        currentStage.programStageDataElements.filter(
          (obj) => obj.dataElement.displayFormName == "Task Assign User"
        );
      referalAPIObject.events[0].status = "SCHEDULE";
      referalAPIObject.events[0]["assignedUser"] =
        valueForFormInput[taskAssignUserDataElement[0].dataElement.id];
    }

    // if (userData.displayName == "User Facility") {
    //     const eventsList = trackentityInstanceDetails.enrollments[0].events
    //     const ScheduledEvents = trackentityInstanceDetails.enrollments[0].events.filter(obj => obj.status == "SCHEDULE")
    //     const url = 'events/' + ScheduledEvents[0].event + '/eventDate'

    //     const PUTObject = ScheduledEvents.length > 0 ? {
    //         "event": ScheduledEvents[0].event,
    //         "enrollment": ScheduledEvents[0].enrollment,
    //         "dueDate": "2020-10-12",
    //         "status": "COMPLETED",
    //         "program": ScheduledEvents[0].program,
    //         "programStage": ScheduledEvents[0].programStage,
    //         "orgUnit": ScheduledEvents[0].orgUnit,
    //         "eventDate": "2020-10-12",
    //         "trackedEntityInstance": ScheduledEvents[0].trackedEntityInstance
    //     } : {}

    //     apiServices.putAPI(url, PUTObject)
    //         .then(ReferalResponse => {
    //             apiServices.postAPI('events.json', referalAPIObject)
    //                 .then(stageResponse => {
    //                     swal({
    //                         title: t("Success"),
    //                         text: t("Successfully submited event"),
    //                         icon: "success",
    //                         button: t("Close"),
    //                     });
    //                 })
    //         })
    // } else {
    //console.log("referalAPIObject ",referalAPIObject)
    //return;
    if (navigator.onLine) {
      setGlobalSpinner(true);
      apiServices
        .postAPI("events.json", referalAPIObject)
        .then((stageResponse) => {
          setGlobalSpinner(false);
          try {
            if (
              currentStage.id == tbTretmentInitiationStageId &&
              valueForFormInput[tbtreatmentinitiatedId] &&
              valueForFormInput[tbtreatmentinitiatedId] == "Yes"
            ) {
              if (
                Configuration &&
                Configuration.registrationForm &&
                Configuration.registrationForm.enableWhatsapp &&
                valueForFormInput[whatsAppFieldId]
              ) {
                let phoneCode =
                  regPhoneNumberCodeId &&
                  valueForFormInput[regPhoneNumberCodeId]
                    ? valueForFormInput[regPhoneNumberCodeId]
                    : "91";
                apiServices
                  .getAPI(
                    `whatsapp/send/custommessage?phonenumbers=${phoneCode}${valueForFormInput[whatsAppFieldId]}&name=${valueForFormInput[firstNameId]}&uic=${valueForFormInput[uicId]}&msgtype=treatment`
                  )
                  .then((response) => {});
              }
            }
            if (
              currentStage.id == adherenceStageId &&
              valueForFormInput[dateMedicineTakenId]
            ) {
              if (
                Configuration &&
                Configuration.registrationForm &&
                Configuration.registrationForm.enableWhatsapp &&
                valueForFormInput[whatsAppFieldId]
              ) {
                let phoneCode =
                  regPhoneNumberCodeId &&
                  valueForFormInput[regPhoneNumberCodeId]
                    ? valueForFormInput[regPhoneNumberCodeId]
                    : "91";
                apiServices
                  .getAPI(
                    `whatsapp/send/custommessage?phonenumbers=${phoneCode}${valueForFormInput[whatsAppFieldId]}&name=${valueForFormInput[firstNameId]}&uic=${valueForFormInput[uicId]}&msgtype=adhearanceSuccess`
                  )
                  .then((response) => {});
              }
            }
          } catch (e) {}
          if (!workFlow) {
            OfflineDb.setDataIntoPouchDB("newSeviceStart", false);
            setServiceStartFlag(false);
          }

          if (
            currentStageIndex == 1 &&
            programData.programs[0].useFirstStageDuringRegistration == true &&
            relationShipId != "" &&
            Configuration.registrationForm.linkContactInAlert
          ) {
            swal({
              title: t("Individual Registered"),
              text: t("Do you want to initiate the individual registration?"),
              icon: "success",
              buttons: [t("No"), t("Yes")],
            }).then((AlertRes) => {
              if (AlertRes) {
                //save data
                const linkContact = {
                  enabled: true,
                  linkTrackedEntityInstance:
                    activeCaseDetails.data.trackedEntityInstance,
                };
                const activeStageCaseFormData = {
                  formFormat: null, //valueForFormInput,
                  dhisFormat: null, //
                };

                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeStageCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                setActiveCaseFormData({
                  data: {
                    formFormat: null, //valueForFormInput,
                    dhisFormat: null, //
                  },
                });
                setValue(0);
              } else {
                const linkContact = {
                  enabled: false,
                  linkTrackedEntityInstance:
                    activeCaseDetails.data.trackedEntityInstance,
                };
                const activeStageCaseFormData = {
                  formFormat: valueForFormInput, //valueForFormInput,
                  dhisFormat: null, //
                };

                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeStageCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                //check next active tab
                const nextTab =
                  fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1];
                if (nextTab) {
                  const indexOfNextTab =
                    programData.programs[0].programStages.findIndex(
                      (obj) => obj.id == nextTab
                    );
                  //setValue(indexOfNextTab + stepIncrement);
                  if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
                        addNextService(currentStage,function(){
                            setValue(indexOfNextTab + stepIncrement)
                        })
                    }else{
                        setValue(indexOfNextTab + stepIncrement)
                    }
                } else {
                  setValue(value);
                  swal({
                    title: t("Success"),
                    text: t("Successfully submited event"),
                    icon: "success",
                    button: t("Close"),
                  });
                  //history.push("/layout/home");
                  if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
                        addNextService(currentStage,function(){
                            history.push("/layout/home");
                        })
                    }else{
                        history.push("/layout/home");
                    }
                }
              }
            });
          } else if (
            props.stageTabValue &&
            props.stageTabValue != 0 &&
            props.stageInstanceID
          ) {
            let submittedDataValues = "";
            let stageID = "";
            let orgUnit = "";
            let trackeInstanceID =
              trackentityInstanceDetails.trackedEntityInstance;
            trackentityInstanceDetails.enrollments[0].events.map((event) => {
              submittedDataValues = event.dataValues;
              stageID = event.programStage;
              orgUnit = event.orgUnit;
            });
            const updateURL = "events/" + props.stageInstanceID;
            let UpdateStageInput = {
              dataValues: submittedDataValues,
              event: props.stageInstanceID,
              program: programId,
              programStage: stageID,
              orgUnit: orgUnit,
              trackedEntityInstance: trackeInstanceID,
              status: "COMPLETED",
              dueDate: moment().format("YYYY-MM-DD"),
              eventDate: moment().format("YYYY-MM-DD"),
              completedDate: moment().format("YYYY-MM-DD"),
            };

            apiServices
              .putAPI(updateURL, UpdateStageInput)
              .then((stageResponse) => {
                const trasferAPI =
                  "30/tracker/ownership/transfer?trackedEntityInstance=" +
                  trackeInstanceID +
                  "&program=" +
                  programId +
                  "&ou=" +
                  referalAPIObject.events[0].orgUnit;
                apiServices.putAPI(trasferAPI, {}).then((trasferResponse) => {
                  swal({
                    title: t("Success"),
                    text: t("Successfully submitted event"),
                    icon: "success",
                    button: t("Close"),
                  });
                  history.push("/layout/home");
                });
              });
          } else {
            let redirectedHome = false;
            const getURL =
              "trackedEntityInstances/" +
              activeCaseDetails.data.trackedEntityInstance +
              ".json?program=" +
              programId +
              "&fields=*?";
            setGlobalSpinner(true);
            apiServices.getAPI(getURL).then((res) => {
              setGlobalSpinner(false);
              setTrackentityInstanceDetails(res.data);

              const previousFilledData = activeCaseFormData;
              //debugger;
              setActiveCaseFormData({
                data: {
                  formFormat: valueForFormInput, //,
                  dhisFormat: null, //
                },
                setdata: true,
              });
              //checkTabs(currentStage)

              const linkContact = {
                enabled: false,
                linkTrackedEntityInstance:
                  activeCaseDetails.data.trackedEntityInstance,
              };
              const activeStageCaseFormData = {
                formFormat: valueForFormInput, //valueForFormInput,
                dhisFormat: null, //
              };

              setActiveCaseFormData({
                data: {
                  formFormat: valueForFormInput, //valueForFormInput,
                  dhisFormat: null, //
                },
              });

              OfflineDb.setDataIntoPouchDB(
                "activeCaseFormData",
                activeStageCaseFormData
              );
              OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
              if (
                currentStage.name.trim().toLocaleLowerCase() ==
                "tb testing form"
              ) {
                let testResultTBObj =
                  currentStage.programStageDataElements.filter(
                    (obj) =>
                      obj.dataElement.displayName.trim() == "Test result (TB)"
                  );
                let testResultTBId =
                  testResultTBObj.length > 0
                    ? testResultTBObj[0].dataElement.id
                    : null;
                if (
                  valueForFormInput[clientTypeID] ==
                    Configuration.ltbiLinkVariables.presumptivetb &&
                  valueForFormInput[testResultTBId].trim().toUpperCase() ==
                    "POSITIVE"
                ) {
                  updateRegDataToIndex();
                }
              }
              if (
                currentStage.name.trim().toLocaleLowerCase() == "transfer out"
              ) {
                redirectedHome = true;
              }

              let nextTab;
              if(currentStage.id == followupStageId && redirectedFromFollowup?.data) {
                programData.programs[0].programStages.map((allStages) => {
                  // if(allStages?.attributeValues.length > 0) {
                  
                  //   var attributeList = allStages?.attributeValues[0]
                  //   if(attributeList?.attribute.displayName == "ShowSummaryTab" && attributeList?.value == "true") {
                  //     nextTab = allStages.id
                  //   }
                  // }
                  if(allStages?.description == "Appointments") {
                    nextTab = allStages.id
                  }
                })
              } else {
                nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1];
              }

              //next tab
              // let nextTab =
              //   fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1];

              // if(currentStage.id == historyscreeningStageId) {
              //   if(showCasesInRegistration) {
              //     nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 2]
              //   } else {
              //     redirectedHome = true
              //   }
              // }

              // if(currentStage.id == initialassessmentStageId) {
              //   if(valueForFormInput[refertonextlevelsecondarytertiarycarecentrebreastcancer] == "Yes" ||
              //     valueForFormInput[refertonextlevelsecondarytertiarycarecentrechildhoodcancer] == "Yes" ||
              //     valueForFormInput[refertonextlevelsecondarytertiarycarecentregeneralcancers] == "Yes"
              //   ) {
              //     nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1]
              //   } else if(valueForFormInput[referforfurtherinvestigationshypertensioncardiovasculardiseases] == "Yes" ||
              //     valueForFormInput[referforfurtherinvestigationsdiabetes] == "Yes" ||
              //     valueForFormInput[referforfurtherinvestigationsortreatment] == "Yes" ||
              //     valueForFormInput[referforfurtherinvestigationscervicalcancer] == "Yes"
              //   ) {
              //     nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 2]
              //   }
              // }

              // if(currentStage.id == referraltohospitalstertiarycentersStageId) {
              //   nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 5]
              // }

              const nextTabStage = programData.programs[0].programStages.find(
                (obj) => obj.id == nextTab
              );
              if (!stageAccessCheck(nextTabStage)) {
                redirectedHome = true;
                stepIncrement = stepIncrement + 1;
                let nextOfNextTab =
                  fetchActiveTab[fetchActiveTab.indexOf(nextTabStage.id) + 1];
                let nextTabStageCheck =
                  programData.programs[0].programStages.find(
                    (obj) => obj.id == nextOfNextTab
                  );
                if (nextOfNextTab) {
                  redirectedHome = false;
                  if (!stageAccessCheck(nextTabStageCheck))
                    stepIncrement = stepIncrement + 1;
                }
              }

              if (currentStage.id == diagnosisStageId || currentStage.id == followupStageId) {
                redirectedHome = false;
              }

              if (currentStage.id == summaryStageId) {
                redirectedHome = false;
              }

              if (nextTab && !redirectedHome) {
                swal({
                  title: t("Success"),
                  text: t("Successfully submited event"),
                  icon: "success",
                  button: t("Close"),
                });
                const indexOfNextTab =
                  programData.programs[0].programStages.findIndex(
                    (obj) => obj.id == nextTab
                  );
                checkAndGetAdherenceDetails(
                  indexOfNextTab + stepIncrement,
                  res.data
                );
                //setValue(indexOfNextTab + stepIncrement);
                if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
                    addNextService(currentStage,function(){
                        setValue(indexOfNextTab + stepIncrement)
                    })
                }else{
                    setValue(indexOfNextTab + stepIncrement)
                }
                if (programBoDetails && programBoDetails.isReferralWorkflow) {
                  if (
                    valueForFormInput[clientTypeID] ==
                    Configuration.ltbiLinkVariables.index
                  ) {
                    let nextTabIndex = indexOfNextTab;
                    if (currentStage.id == riskAssementStageId) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == referralServiceStageId
                        );
                    } else if (currentStage.id == referralServiceStageId) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTretmentInitiationStageId
                        );
                    } else if (currentStage.id == adherenceTBStageId) {
                      nextTabIndex =
                        programData.programs[0].programStages.length;
                    }
                    stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                    setValue(nextTabIndex + stepIncrement);
                  } else if (currentStage.id == referralServiceStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tbTretmentInitiationStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTretmentInitiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    } else if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tptIntiationStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tptIntiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    }
                  }
                  if (currentStage.id == sampleCollectionStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tbTestingStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTestingStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    } else if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tbInfectionTestingStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbInfectionTestingStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    }
                  }
                  // if (currentStage.id == followupStageId || currentStage.id == diagnosisStageId) {
                  //   history.push("/layout/home");
                  // }
                  if (
                    currentStage.id == tbTretmentInitiationStageId &&
                    valueForFormInput[selectReferralServiceId] &&
                    (valueForFormInput[selectReferralServiceId] ==
                      tbTretmentInitiationStageId ||
                      valueForFormInput[selectReferralServiceId] ==
                        tbTestingStageId)
                  ) {
                    //history.push('/layout/home');
                  }
                  if (currentStage.id == tbTestingStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      valueForFormInput[testresultTBId] &&
                      valueForFormInput[testresultTBId].toLowerCase() ==
                        "positive"
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTretmentInitiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    } else if (
                      valueForFormInput[testresultTBId] &&
                      valueForFormInput[testresultTBId].toLowerCase() ==
                        "negative"
                    ) {
                      if (
                        !valueForFormInput[IspatienteligibleforTBIId] ||
                        (valueForFormInput[IspatienteligibleforTBIId] &&
                          valueForFormInput[
                            IspatienteligibleforTBIId
                          ].toLowerCase() == "no")
                      ) {
                        history.push("/layout/home");
                      }
                    }
                  }
                  if (currentStage.id == tbInfectionTestingStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      !valueForFormInput[IspatienteligibleforTPTId] ||
                      (valueForFormInput[IspatienteligibleforTPTId] &&
                        valueForFormInput[
                          IspatienteligibleforTPTId
                        ].toLowerCase() == "no")
                    ) {
                      history.push("/layout/home");
                    } else if (
                      valueForFormInput[IspatienteligibleforTPTId] &&
                      valueForFormInput[
                        IspatienteligibleforTPTId
                      ].toLowerCase() == "yes"
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tptIntiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    }
                  }
                }
                if (userrolename && userrolename == patientRole) {
                  history.push("/layout/home");
                }

                if(currentStage.id == summaryStageId){
                  history.push("/layout/home");
                }
              } else {
                setValue(value);
                swal({
                  title: t("Success"),
                  text: t("Successfully submited event"),
                  icon: "success",
                  button: t("Close"),
                });
                if (userrolename && userrolename == patientRole) {
                  history.push("/layout/home");
                } else {
                    if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
                        addNextService(currentStage,function(){
                            history.push("/layout/home");
                        })
                    }else{
                        history.push("/layout/home");
                    }
                }
              }
              setGlobalSpinner(false);
            });
          }
          //Remove as per ramesh suggestion
          // if (OUFieldSelectedLocation != '') {
          //     setGlobalSpinner(true)
          //     let subURLApi = 'tracker/ownership/transfer?trackedEntityInstance=' + activeCaseDetails.data.trackedEntityInstance + '&program=' + programId + '&ou=' + OUFieldSelectedLocation
          //     apiServices.putAPI(subURLApi, {})
          //         .then(ReferalResponse => {
          //             setGlobalSpinner(false)
          //         })
          // }
          setGlobalSpinner(false);
          setMedicineTable([]);
        })
        .catch((err) => {
          setGlobalSpinner(false);
          swal({
            title: t("Error"),
            text: t("Somthing went wrong"),
            icon: "error",
            buttons: t("Close"),
          });
        });
      // if offline
    } else {
      console.log(
        "valueForFormInput,valueToStore1",
        valueForFormInput,
        valueToStore,
        referalAPIObject
      );
      updateOfflineServiceData(
        valueForFormInput,
        valueToStore,
        currentStage,
        referalAPIObject,
        fetchActiveTab
      );
      /*return;
        let instance = { "data": valueForFormInput, "servicedata": referalAPIObject }
        setGlobalSpinner(false)
        OfflineDb.updateEntity(activeCaseDetails.data.trackedEntityInstance, instance).then(res => {

            const linkContact = {
                "enabled": false,
                "linkTrackedEntityInstance": activeCaseDetails.data.trackedEntityInstance
            }
            const activeStageCaseFormData = {
                'formFormat': valueForFormInput,
                'dhisFormat': null
            }

            setActiveCaseFormData({
                "data": {
                    'formFormat': valueForFormInput,
                    'dhisFormat': null
                }
            })

            OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeStageCaseFormData)
            OfflineDb.setDataIntoPouchDB('linkContactFlag', linkContact)

            //next tab
            const nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + stepIncrement]
            if (nextTab) {
                swal({
                    title: t("Success"),
                    text: t("Successfully submited event offline"),
                    icon: "success",
                    button: t("Close"),
                });
                const indexOfNextTab = programData.programs[0].programStages.findIndex(obj => obj.id == nextTab)
                setValue(indexOfNextTab + stepIncrement)
            } else {
                setValue(value)
                swal({
                    title: t("Success"),
                    text: t("Successfully submited event offline"),
                    icon: "success",
                    button: t("Close"),
                });
                history.push('/layout/home');
            }
        })*/
    }
  }

  function updateStage(
    valueToStore,
    valueForFormInput,
    currentStage,
    currentStageIndex,
    eventId,
    fetchActiveTab,
    eventStatus
  ) {
    //debugger;
    const orgUnit =
      userrolename &&
      userrolename.toLowerCase() == superAdmin &&
      trackentityInstanceDetails
        ? trackentityInstanceDetails.orgUnit
        : userData.organisationUnits[0].id;
    const programId = programData.programs[0].id;
    const updateURL = "33/events?strategy=CREATE_AND_UPDATE"; //'events/' + eventId
    let registrationFields =
      programData.programs[0].programTrackedEntityAttributes;
    let whatsAppFieldId = "";

    registrationFields.map((regField) => {
      const findWhatsAppAttribute =
        regField.trackedEntityAttribute.attributeValues.find(
          (x) => x.attribute.name == "WhatsAppNumber"
        );
      if (findWhatsAppAttribute) {
        whatsAppFieldId = regField.trackedEntityAttribute.id;
      }
    });
    let UpdateStageInput = {
      dataValues: valueToStore,
      event: eventId,
      program: programId,
      programStage: currentStage.id,
      orgUnit: orgUnit,
      trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
      status: "COMPLETED",
      dueDate: moment().format("YYYY-MM-DD"),
      eventDate: moment().format("YYYY-MM-DD"),
      completedDate: moment().format("YYYY-MM-DD"),
    };

    const referalAPIObject = { events: [] };

    if (currentStage.id == regimenStageId && medicineTable.length > 0) {
      //remove forecefully
      _.remove(valueToStore, { value: "Ethambutol" });
      let CreateStageEventInput = {
        //"dataValues": valueToStore,
        //"event": eventId,
        program: programId,
        programStage: currentStage.id,
        orgUnit: orgUnit,
        trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
        status: "COMPLETED",
        dueDate: moment().format("YYYY-MM-DD"),
        eventDate: moment().format("YYYY-MM-DD"),
        completedDate: moment().format("YYYY-MM-DD"),
      };
      let treatmentAdherenceVal = "";
      let scheduleEventId = null;
      medicineTable.map((row, i) => {
        if (row["eventdetails"]) {
          treatmentAdherenceVal = row[treatmentAdherenceId];
          UpdateStageInput = {
            dataValues: row["eventdetails"]["dataValues"],
            event: row["eventdetails"]["event"],
            program: programId,
            programStage: currentStage.id,
            orgUnit: orgUnit,
            trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
            status: "COMPLETED",
            dueDate: moment().format("YYYY-MM-DD"),
            eventDate: moment().format("YYYY-MM-DD"),
            completedDate: moment().format("YYYY-MM-DD"),
          };
          referalAPIObject.events.push(UpdateStageInput);
        } else {
          if (eventStatus && eventStatus == "SCHEDULE") {
            if (!scheduleEventId) {
              scheduleEventId = true;
              CreateStageEventInput["event"] = eventId; // to complete schedule event
            } else if (CreateStageEventInput.hasOwnProperty("event")) {
              delete CreateStageEventInput.event;
            }
          }
          const regimenConfigObject = _.find(Configuration.treatmentRegimens, {
            code: row[treatmentRegimenId],
            phase: row[treatmentPhaseId],
          });
          if (regimenConfigObject != undefined) {
            let fieldDetails = _.filter(currentStage.programStageDataElements, [
              "dataElement.description",
              regimenConfigObject.associatedFieldName,
            ]);
            let objvalueToStore = _.cloneDeep(valueToStore);
            let rowdata = Object.assign({}, row);
            //medicine
            let obj = {
              dataElement: fieldDetails[0].dataElement.id,
              value: rowdata["medicine"]["code"],
            };
            try {
              if (
                objvalueToStore.findIndex(
                  (ob) => ob.dataElement == treatmentAdherenceId
                )
              ) {
                objvalueToStore.splice(
                  objvalueToStore.findIndex(
                    (ob) => ob.dataElement == treatmentAdherenceId
                  ),
                  1
                );
              }
            } catch (e) {}

            objvalueToStore.push(Object.assign({}, obj));
            objvalueToStore.push({
              dataElement: treatmentAdherenceId,
              value: rowdata[treatmentAdherenceId],
            }); //treatmentAdherenceVal
            objvalueToStore.push({
              dataElement: treatmentRegimenId,
              value: rowdata[treatmentRegimenId],
            });
            objvalueToStore.push({
              dataElement: treatmentStartDateId,
              value: moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD"),
            });
            objvalueToStore.push({
              dataElement: treatmentEndDateId,
              value: moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD"),
            });
            objvalueToStore.push({
              dataElement: treatmentDoseId,
              value: rowdata[treatmentDoseId],
            });
            CreateStageEventInput["dataValues"] = _.uniqBy(
              objvalueToStore,
              "dataElement"
            );
            referalAPIObject.events.push(
              Object.assign({}, CreateStageEventInput)
            );
          }
          /*if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                    let objvalueToStore = _.cloneDeep(valueToStore);
                    let rowdata = Object.assign({},row);
                    //medicine
                    let obj =  {
                            "dataElement":fixedDoseChildren.id,
                            "value":rowdata['medicine']['code']
                            }
                    objvalueToStore.push(Object.assign({},obj))
                    objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                    objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                    objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                    
                    CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                    referalAPIObject.events.push(Object.assign({},CreateStageEventInput))
                }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                    let objvalueToStore = _.cloneDeep(valueToStore);
                    let rowdata = Object.assign({},row);
                    let obj =  {
                            "dataElement":singleDoseChildren.id,
                            "value":rowdata['medicine']['code']
                            }
                    
                    objvalueToStore.push(Object.assign({},obj))
                    objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                    objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                    objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                    
                    CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                    referalAPIObject.events.push(Object.assign({},CreateStageEventInput))
                }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                    let objvalueToStore = _.cloneDeep(valueToStore);
                    let rowdata = Object.assign({},row);
                    let obj =  {
                            "dataElement":fixedDoseAdult.id,
                            "value":rowdata['medicine']['code']
                            }
                    
                    objvalueToStore.push(Object.assign({},obj))
                    objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                    objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                    objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                    
                    CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                    referalAPIObject.events.push(Object.assign({},CreateStageEventInput))

                }else if(row[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                    let objvalueToStore = _.cloneDeep(valueToStore);
                    let rowdata = Object.assign({},row);
                    let obj =  {
                            "dataElement":singleDoseAdult.id,
                            "value":rowdata['medicine']['code']
                            }
                    objvalueToStore.push(Object.assign({},obj))
                    objvalueToStore.push({"dataElement":treatmentAdherenceId,"value":treatmentAdherenceVal})
                    objvalueToStore.push({"dataElement":treatmentRegimenId,"value":rowdata[treatmentRegimenId]})
                    objvalueToStore.push({"dataElement":treatmentStartDateId,"value":moment(rowdata[treatmentStartDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentEndDateId,"value":moment(rowdata[treatmentEndDateId]).format("YYYY-MM-DD")})
                    objvalueToStore.push({"dataElement":treatmentDoseId,"value":rowdata[treatmentDoseId]})
                    
                    CreateStageEventInput['dataValues'] = _.uniqBy(objvalueToStore, 'dataElement');
                    referalAPIObject.events.push(Object.assign({},CreateStageEventInput))
                }*/
        }
      });
    } else if (currentStage.id == adherenceStageId) {
      if (fullCalendarEvents.length > 0) {
        let CreateStageEventInput = {
          program: programId,
          programStage: currentStage.id,
          orgUnit: orgUnit,
          trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
          status: "COMPLETED",
          dueDate: moment().format("YYYY-MM-DD"),
          eventDate: moment().format("YYYY-MM-DD"),
          completedDate: moment().format("YYYY-MM-DD"),
        };
        fullCalendarEvents.map((event) => {
          if (!event.hasOwnProperty("editmode")) {
            if (
              medicineTable.length > 0 &&
              currentStage.id == adherenceTBStageId
            ) {
              medicineTable.map((row) => {
                console.log("row ", row);
                const regimenConfigObject = _.find(
                  Configuration.treatmentRegimens,
                  {
                    code: row[treatmentRegimenId],
                    phase: row[treatmentPhaseId],
                  }
                );
                if (regimenConfigObject != undefined) {
                  //debugger
                  let fieldDetails = _.filter(
                    currentStage.programStageDataElements,
                    [
                      "dataElement.description",
                      regimenConfigObject.associatedFieldName,
                    ]
                  );

                  let objvalueToStore = _.cloneDeep(valueToStore);
                  objvalueToStore = _.reject(objvalueToStore, { value: "" });
                  let rowdata = Object.assign({}, row);
                  let obj = {};
                  if (fieldDetails && fieldDetails.length > 0) {
                    //medicine
                    objvalueToStore = _.reject(objvalueToStore, {
                      dataElement: fieldDetails[0].dataElement.id,
                    });
                    obj = {
                      dataElement: fieldDetails[0].dataElement.id,
                      value: rowdata["medicine"]["code"],
                    };
                  }
                  objvalueToStore.map((ele, idx) => {
                    switch (ele.dataElement) {
                      case fieldDetails &&
                        fieldDetails.length > 0 &&
                        fieldDetails[0].dataElement.id:
                        objvalueToStore.splice(idx, 1);
                        break;
                      case treatmentAdherenceId:
                        objvalueToStore.splice(idx, 1);
                        break;
                      case medicineColorCodeId:
                        objvalueToStore.splice(idx, 1);
                        break;
                      case medicineTakenId:
                        objvalueToStore.splice(idx, 1);
                        break;
                    }
                  });
                  try {
                    if (
                      objvalueToStore.findIndex(
                        (ob) => ob.dataElement == medicineColorCodeId
                      )
                    ) {
                      objvalueToStore.splice(
                        objvalueToStore.findIndex(
                          (ob) => ob.dataElement == medicineColorCodeId
                        ),
                        1
                      );
                    }
                    if (
                      objvalueToStore.findIndex(
                        (ob) => ob.dataElement == dateMedicineTakenId
                      )
                    ) {
                      objvalueToStore.splice(
                        objvalueToStore.findIndex(
                          (ob) => ob.dataElement == dateMedicineTakenId
                        ),
                        1
                      );
                    }
                    if (
                      objvalueToStore.findIndex(
                        (ob) => ob.dataElement == treatmentAdherenceId
                      )
                    ) {
                      objvalueToStore.splice(
                        objvalueToStore.findIndex(
                          (ob) => ob.dataElement == treatmentAdherenceId
                        ),
                        1
                      );
                    }
                    if (
                      objvalueToStore.findIndex(
                        (ob) => ob.dataElement == medicineTakenId
                      )
                    ) {
                      objvalueToStore.splice(
                        objvalueToStore.findIndex(
                          (ob) => ob.dataElement == medicineTakenId
                        ),
                        1
                      );
                    }
                  } catch (e) {}

                  if (!_.isEmpty(obj)) {
                    objvalueToStore.push(Object.assign({}, obj));
                  }

                  //radioValue
                  let medicineTakenValue =
                    radioValue &&
                    !_.isEmpty(radioValue) &&
                    _.get(radioValue, rowdata["medicine"]["code"])
                      ? _.get(radioValue, rowdata["medicine"]["code"])
                      : "yes";
                  try {
                    if (_.isArray(event.medicineTaken)) {
                      event.medicineTaken.map((med) => {
                        Object.keys(med).map((medName) => {
                          if (rowdata["medicine"]["code"] == medName) {
                            medicineTakenValue = med[medName];
                          }
                        });
                      });
                    }
                  } catch (e) {
                    console.log(e);
                  }
                  console.log("medicineTakenValue ", medicineTakenValue);
                  objvalueToStore.push(
                    Object.assign(
                      {},
                      {
                        dataElement: medicineTakenId,
                        value: medicineTakenValue
                          ? medicineTakenValue
                          : radioValue &&
                            !_.isEmpty(radioValue) &&
                            _.get(radioValue, rowdata["medicine"]["code"])
                          ? _.get(radioValue, rowdata["medicine"]["code"])
                          : event.medicineTaken
                          ? event.medicineTaken
                          : "yes",
                        //"value": event.medicineTaken ? event.medicineTaken : (_.get(radioValue, rowdata['medicine']['code'])) ? _.get(radioValue, rowdata['medicine']['code']) : 'yes'
                      }
                    )
                  );
                  //push date medicine taken
                  objvalueToStore.push({
                    dataElement: dateMedicineTakenId,
                    value: event.start,
                  });

                  //push color code
                  objvalueToStore.push(
                    Object.assign(
                      {},
                      {
                        dataElement: medicineColorCodeId,
                        value: event.backgroundColor,
                      }
                    )
                  );

                  //push adherenceid
                  objvalueToStore.push(
                    Object.assign(
                      {},
                      {
                        dataElement: treatmentAdherenceId,
                        value: rowdata[treatmentAdherenceId],
                      }
                    )
                  );

                  CreateStageEventInput["dataValues"] = _.uniqBy(
                    objvalueToStore,
                    "dataElement"
                  );
                  referalAPIObject.events.push(
                    Object.assign({}, CreateStageEventInput)
                  );
                  console.log("event ", event, CreateStageEventInput);
                  /*let tempSaveStageInput = _.cloneDeep(saveStageInput);
                            tempSaveStageInput['dataValues'] = _.cloneDeep(objvalueToStore);
                            referalAPIObject.events.push(tempSaveStageInput)*/
                }
              });
            } else {
              let objvalueToStore = _.cloneDeep(valueToStore);
              objvalueToStore = _.reject(objvalueToStore, { value: "" });
              objvalueToStore.map((ele, idx) => {
                switch (ele.dataElement) {
                  case dateMedicineTakenId:
                    objvalueToStore.splice(idx, 1);
                    break;
                  case medicineColorCodeId:
                    objvalueToStore.splice(idx, 1);
                    break;
                  case medicineTakenId:
                    objvalueToStore.splice(idx, 1);
                    break;
                }
              });
              let newdateselectedarr = [];

              newdateselectedarr.push({
                dataElement: dateMedicineTakenId,
                value: event.start,
              });
              newdateselectedarr.push({
                dataElement: medicineColorCodeId,
                value: event.backgroundColor,
              });
              newdateselectedarr.push({
                dataElement: medicineTakenId,
                value: event.medicineTaken,
              });
              try {
                objvalueToStore = _.merge(objvalueToStore, newdateselectedarr);
              } catch (e) {
                objvalueToStore = newdateselectedarr;
              }
              CreateStageEventInput["dataValues"] = _.uniqBy(
                objvalueToStore,
                "dataElement"
              );
              referalAPIObject.events.push(
                Object.assign({}, CreateStageEventInput)
              );
            }
          }
        });
      }
    } else if (currentStage.id == specimenStageId && sputumTable.length > 0) {
      let CreateStageEventInput = {
        program: programId,
        programStage: currentStage.id,
        orgUnit: orgUnit,
        trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
        status: "COMPLETED",
        dueDate: moment().format("YYYY-MM-DD"),
        eventDate: moment().format("YYYY-MM-DD"),
        completedDate: moment().format("YYYY-MM-DD"),
      };

      sputumTable.map((row) => {
        if (row["eventdetails"]) {
          UpdateStageInput = {
            dataValues: row["eventdetails"]["dataValues"],
            event: row["eventdetails"]["event"],
            program: programId,
            programStage: currentStage.id,
            orgUnit: orgUnit,
            trackedEntityInstance: activeCaseDetails.data.trackedEntityInstance,
            status: "COMPLETED",
            dueDate: moment().format("YYYY-MM-DD"),
            eventDate: moment().format("YYYY-MM-DD"),
            completedDate: moment().format("YYYY-MM-DD"),
          };
          referalAPIObject.events.push(UpdateStageInput);
        } else {
          let objvalueToStore = _.cloneDeep(valueToStore);
          for (const key in row) {
            if (Object.hasOwnProperty.call(row, key)) {
              const val = row[key];
              let obj = {
                dataElement: key,
                value: val || null,
              };
              objvalueToStore.push(Object.assign({}, obj));
            }
          }
          let tempCSEI = _.cloneDeep(CreateStageEventInput);
          tempCSEI["dataValues"] = _.uniqBy(objvalueToStore, "dataElement");
          referalAPIObject.events.push(tempCSEI);
        }
      });
    } else {
      const getAllKeys = Object.keys(valueForFormInput);

      let OUFieldSelectedLocation = "";

      const filterReferalField = getAllKeys.map((keys) => {
        const filter = currentStage.programStageDataElements.filter(
          (obj) => obj.dataElement.id == keys
        );
        if (filter.length > 0) {
          filter.map((filteredField) => {
            if (filteredField.dataElement.fieldMask == "Facility Referral") {
              const filteredKey = filteredField.dataElement.id;
              const selectedOUField =
                currentStage.programStageDataElements.filter(
                  (obj) => obj.dataElement.fieldMask == "Facility Referral OU"
                );

              const selectedOUFieldData =
                selectedOUField.length > 0
                  ? valueForFormInput[selectedOUField[0].dataElement.id]
                  : "";
              OUFieldSelectedLocation = selectedOUFieldData;

              const referalFieldValue = _.isArray(
                valueForFormInput[filteredKey]
              )
                ? valueForFormInput[filteredKey]
                : [valueForFormInput[filteredKey]];
              referalFieldValue.map((stageId) => {
                let sortedEvents = _.filter(
                  trackentityInstanceDetails.enrollments[0].events,
                  { programStage: stageId, status: "SCHEDULE" }
                );
                if (selectedOUFieldData && sortedEvents.length == 0) {
                  const obj = {
                    trackedEntityInstance:
                      activeCaseDetails.data.trackedEntityInstance,
                    program: programId,
                    programStage: stageId,
                    enrollment: navigator.onLine
                      ? trackentityInstanceDetails.enrollments[0].enrollment
                      : "",
                    orgUnit: selectedOUFieldData,
                    notes: [],
                    dataValues: [],
                    status: "SCHEDULE",
                    dueDate: moment().format("YYYY-MM-DD"),
                    eventDate: moment().format("YYYY-MM-DD"),
                  };

                  referalAPIObject.events.push(obj);
                }
              });
            }
            if (
              filteredField.dataElement.fieldMask == "Transfer In" ||
              filteredField.dataElement.fieldMask == "Transfer Out"
            ) {
              const stageId = currentStage.id;
              const selectedOUField = filteredField.dataElement.id;
              const selectedOUFieldData =
                selectedOUField.length > 0
                  ? valueForFormInput[selectedOUField]
                  : "";
              OUFieldSelectedLocation = selectedOUFieldData;

              let eventStatus = "COMPLETED";
              if (filteredField.dataElement.fieldMask == "Transfer Out") {
                eventStatus = "SCHEDULE";
              }
              UpdateStageInput = {
                dataValues: valueToStore,
                event: eventId,
                program: programId,
                programStage: currentStage.id,
                orgUnit: selectedOUFieldData,
                trackedEntityInstance:
                  activeCaseDetails.data.trackedEntityInstance,
                status: eventStatus,
                dueDate: moment().format("YYYY-MM-DD"),
                eventDate: moment().format("YYYY-MM-DD"),
                completedDate: moment().format("YYYY-MM-DD"),
              };
            }
          });
        }
      });
      referalAPIObject.events.push(UpdateStageInput);
    }

    //console.log('referalAPIObject>>>', referalAPIObject,adherenceStageId)
    // setGlobalSpinner(false)
    //return

    if (navigator.onLine) {
      setGlobalSpinner(true);
      apiServices
        .postAPI(updateURL, referalAPIObject)
        .then((stageResponse) => {
          if (
            props.stageTabValue &&
            props.stageTabValue != 0 &&
            props.stageInstanceID
          ) {
            swal({
              title: t("Success"),
              text: t("Successfully submitted event"),
              icon: "success",
              button: t("Close"),
            });
            history.push("/layout/home");
            setGlobalSpinner(false);
          } else {
            let redirectedHome = false;
            const getURL =
              "trackedEntityInstances/" +
              activeCaseDetails.data.trackedEntityInstance +
              ".json?program=" +
              programId +
              "&fields=*?";
            setGlobalSpinner(true);
            apiServices.getAPI(getURL).then((res) => {
              setGlobalSpinner(false);
              setTrackentityInstanceDetails(res.data);
              try {
                if (
                  currentStage.id == adherenceStageId &&
                  valueForFormInput[dateMedicineTakenId]
                ) {
                  if (
                    Configuration &&
                    Configuration.registrationForm &&
                    Configuration.registrationForm.enableWhatsapp &&
                    valueForFormInput[whatsAppFieldId]
                  ) {
                    let phoneCode =
                      regPhoneNumberCodeId &&
                      valueForFormInput[regPhoneNumberCodeId]
                        ? valueForFormInput[regPhoneNumberCodeId]
                        : "91";
                    apiServices
                      .getAPI(
                        `whatsapp/send/custommessage?phonenumbers=${phoneCode}${valueForFormInput[whatsAppFieldId]}&name=${valueForFormInput[firstNameId]}&uic=${valueForFormInput[uicId]}&msgtype=adhearanceSuccess`
                      )
                      .then((response) => {});
                  }
                }
              } catch (e) {}
              if (!workFlow) {
                OfflineDb.setDataIntoPouchDB("newSeviceStart", false);
                setServiceStartFlag(false);
              }

              const linkContact = {
                enabled: false,
                linkTrackedEntityInstance:
                  activeCaseDetails.data.trackedEntityInstance,
              };
              const activeCaseFormData = {
                formFormat: valueForFormInput, //valueForFormInput,
                dhisFormat: null, //
              };

              OfflineDb.setDataIntoPouchDB(
                "activeCaseFormData",
                activeCaseFormData
              );
              OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
              if (
                currentStage.name.trim().toLocaleLowerCase() ==
                "tb testing form"
              ) {
                let testResultTBObj =
                  currentStage.programStageDataElements.filter(
                    (obj) =>
                      obj.dataElement.displayName.trim() == "Test result (TB)"
                  );
                let testResultTBId =
                  testResultTBObj.length > 0
                    ? testResultTBObj[0].dataElement.id
                    : null;
                if (
                  valueForFormInput[clientTypeID] ==
                    Configuration.ltbiLinkVariables.presumptivetb &&
                  valueForFormInput[testResultTBId].trim().toUpperCase() ==
                    "POSITIVE"
                ) {
                  updateRegDataToIndex();
                }
              }
              if (
                currentStage.name.trim().toLocaleLowerCase() == "transfer out"
              ) {
                redirectedHome = true;
              }

              //debugger;
              //next tabs
              let nextTab;
              if(currentStage.id == followupStageId && redirectedFromFollowup?.data) {
                programData.programs[0].programStages.map((allStages) => {
                  // if(allStages?.attributeValues.length > 0) {
                  //   var attributeList = allStages?.attributeValues[0]
                  //   if(attributeList?.attribute.displayName == "ShowSummaryTab" && attributeList?.value == "true") {
                  //     nextTab = allStages.id
                  //   }
                  // }

                  if(allStages?.description == "Appointments") {
                    nextTab = allStages.id
                  }
                })
              } else {
                nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1];
              }


              // if(currentStage.id == historyscreeningStageId) {
              //   if(showCasesInRegistration) {
              //     nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 2]
              //   } else {
              //     redirectedHome = true
              //   }
              // }

              // if(currentStage.id == initialassessmentStageId) {
              //   if(valueForFormInput[refertonextlevelsecondarytertiarycarecentrebreastcancer] == "Yes" ||
              //     valueForFormInput[refertonextlevelsecondarytertiarycarecentrechildhoodcancer] == "Yes" ||
              //     valueForFormInput[refertonextlevelsecondarytertiarycarecentregeneralcancers] == "Yes"
              //   ) {
              //     nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 1]
              //   } else if(valueForFormInput[referforfurtherinvestigationshypertensioncardiovasculardiseases] == "Yes" ||
              //     valueForFormInput[referforfurtherinvestigationsdiabetes] == "Yes" ||
              //     valueForFormInput[referforfurtherinvestigationsortreatment] == "Yes" ||
              //     valueForFormInput[referforfurtherinvestigationscervicalcancer] == "Yes"
              //   ) {
              //     nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 2]
              //   }
              // }

              // if(currentStage.id == referraltohospitalstertiarycentersStageId) {
              //   nextTab = fetchActiveTab[fetchActiveTab.indexOf(currentStage.id) + 5]
              // }

              

              
              let nextTabStage = programData.programs[0].programStages.find(
                  (obj) => obj.id == nextTab
                );

              // console.log("nextTabStage", nextTabStage)
              if (!stageAccessCheck(nextTabStage)) {
                redirectedHome = true;
                stepIncrement = stepIncrement + 1;
                let nextOfNextTab =
                  fetchActiveTab[fetchActiveTab.indexOf(nextTabStage.id) + 1];
                let nextTabStageCheck =
                  programData.programs[0].programStages.find(
                    (obj) => obj.id == nextOfNextTab
                  );
                if (nextOfNextTab) {
                  redirectedHome = false;
                  if (!stageAccessCheck(nextTabStageCheck))
                    stepIncrement = stepIncrement + 1;
                }
              }

              if (currentStage.id == diagnosisStageId) {
               redirectedHome = false;
              }

              if (currentStage.id == followupStageId) {
                redirectedHome = false;
              }

              if (currentStage.id == summaryStageId) {
                redirectedHome = false;
              }

              if (nextTab && !redirectedHome) {
                swal({
                  title: t("Updated"),
                  text: t("Successfully updated event"),
                  icon: "success",
                  button: t("Close"),
                });
                const indexOfNextTab =
                  programData.programs[0].programStages.findIndex(
                    (obj) => obj.id == nextTab
                  );
                checkAndGetAdherenceDetails(
                  indexOfNextTab + stepIncrement,
                  res.data
                );
                // console.log("currentStage.id", currentStage.id)
                //setValue(indexOfNextTab + stepIncrement);
                if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
                    addNextService(currentStage,function(){
                        setValue(indexOfNextTab + stepIncrement)
                    })
                } else {
                    setValue(indexOfNextTab + stepIncrement)
                }
                if (programBoDetails && programBoDetails.isReferralWorkflow) {
                  if (
                    valueForFormInput[clientTypeID] ==
                    Configuration.ltbiLinkVariables.index
                  ) {
                    let nextTabIndex = indexOfNextTab;
                    if (currentStage.id == riskAssementStageId) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == referralServiceStageId
                        );
                    } else if (currentStage.id == referralServiceStageId) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTretmentInitiationStageId
                        );
                    } else if (currentStage.id == adherenceTBStageId) {
                      nextTabIndex =
                        programData.programs[0].programStages.length;
                    }
                    stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                    setValue(nextTabIndex + stepIncrement);
                  } else if (currentStage.id == referralServiceStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tbTretmentInitiationStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTretmentInitiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    } else if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tptIntiationStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tptIntiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    }
                  }
                  if (currentStage.id == sampleCollectionStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tbTestingStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTestingStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    } else if (
                      valueForFormInput[selectReferralServiceId] &&
                      valueForFormInput[selectReferralServiceId] ==
                        tbInfectionTestingStageId
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbInfectionTestingStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    }
                  }
                  if (
                    currentStage.id == tbTretmentInitiationStageId &&
                    valueForFormInput[selectReferralServiceId] &&
                    (valueForFormInput[selectReferralServiceId] ==
                      tbTretmentInitiationStageId ||
                      valueForFormInput[selectReferralServiceId] ==
                        tbTestingStageId)
                  ) {
                    //history.push('/layout/home');
                  }
                  if (currentStage.id == tbTestingStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      valueForFormInput[testresultTBId] &&
                      valueForFormInput[testresultTBId].toLowerCase() ==
                        "positive"
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tbTretmentInitiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    } else if (
                      valueForFormInput[testresultTBId] &&
                      valueForFormInput[testresultTBId].toLowerCase() ==
                        "negative"
                    ) {
                      if (
                        !valueForFormInput[IspatienteligibleforTBIId] ||
                        (valueForFormInput[IspatienteligibleforTBIId] &&
                          valueForFormInput[
                            IspatienteligibleforTBIId
                          ].toLowerCase() == "no")
                      ) {
                        history.push("/layout/home");
                      }
                    }
                  }
                  if (currentStage.id == tbInfectionTestingStageId) {
                    let nextTabIndex = indexOfNextTab;
                    if (
                      !valueForFormInput[IspatienteligibleforTPTId] ||
                      (valueForFormInput[IspatienteligibleforTPTId] &&
                        valueForFormInput[
                          IspatienteligibleforTPTId
                        ].toLowerCase() == "no")
                    ) {
                      history.push("/layout/home");
                    } else if (
                      valueForFormInput[IspatienteligibleforTPTId] &&
                      valueForFormInput[
                        IspatienteligibleforTPTId
                      ].toLowerCase() == "yes"
                    ) {
                      nextTabIndex =
                        programData.programs[0].programStages.findIndex(
                          (obj) => obj.id == tptIntiationStageId
                        );
                      stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                      setValue(nextTabIndex + stepIncrement);
                    }
                  }
                }
                //currentStage.id == diagnosisStageId || 
                if(currentStage.id == summaryStageId){
                   history.push("/layout/home");
                }
                if (userrolename && userrolename == patientRole) {
                  history.push("/layout/home");
                }
              } else {
                console.log("checker", 2)
                setValue(value);
                swal({
                  title: t("Updated"),
                  text: t("Successfully updated event"),
                  icon: "success",
                  button: t("Close"),
                });
                if (userrolename && userrolename == patientRole) {
                  history.push("/layout/home");
                } else {
                    if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
                        addNextService(currentStage,function(){
                            history.push("/layout/home");
                        })
                    }else{
                        history.push("/layout/home");
                    }
                  
                }
              }
            });
            setGlobalSpinner(false);
          }
        })
        .catch((err) => {
          setGlobalSpinner(false);
        });
    } else {
      updateOfflineServiceData(
        valueForFormInput,
        valueToStore,
        currentStage,
        referalAPIObject,
        fetchActiveTab
      );
    }
  }
  function updateOfflineServiceData(
    valueForFormInput,
    valueToStore,
    currentStage,
    referalAPIObject,
    fetchActiveTab
  ) {
    setGlobalSpinner(false);
    OfflineDb.getSingleEntity(
      activeCaseDetails.data.trackedEntityInstance
    ).then((res) => {
      let redirectedHome = false;
      const tempdata = { ...res };
      tempdata.formVersion = programData.programs[0].version;
      tempdata.data = { ...tempdata.data, ...valueForFormInput };
      //debugger
      if (tempdata && !tempdata.hasOwnProperty("services")) {
        swal({
          title: t("Warning"),
          text: t(
            "Offline services are not be avaialble for online registered client."
          ),
          icon: "warning",
          button: t("Close"),
        });
        return;
      }
      if (tempdata.services.length > 0) {
        //console.log(_.find(tempdata.services, { events: [{ programStage:currentStage.id }] }))
        let servicedetails = _.find(tempdata.services, {
          events: [{ programStage: currentStage.id }],
        });
        let serviceEventIndex = _.findIndex(tempdata.services, { events: [{ programStage:currentStage.id }] });
        tempdata.services.map(service =>{
            service.events.map((ele,i) =>{
                if(ele.programStage === currentStage.id){
                    servicedetails =  service
                    serviceEventIndex = i 
                }
            })
        })
        if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description] && addNewServiceFlag){
            servicedetails = undefined
        }
        if (servicedetails != undefined) {
          //servicedetails.events[0].dataValues = valueToStore;
          servicedetails.events[serviceEventIndex].dataValues = valueToStore
            if(currentStage.id == tbTretmentInitiationStageId){
                servicedetails.events[serviceEventIndex].dataValues = referalAPIObject.events[0].dataValues
                servicedetails.events[serviceEventIndex].status = "COMPLETED"
                servicedetails.events[serviceEventIndex].trackedEntityInstance = activeCaseDetails.data.trackedEntityInstance
            }
        } else {
          tempdata.services.push(referalAPIObject);
        }
        /*tempdata.services.map((service,idx)=>{
                let servicedetails = _.filter(service.events, ['programStage',currentStage.id])
                //console.log(servicedetails)
                if(servicedetails.length > 0){
                    tempdata.services[idx].events[0].dataValues = valueToStore
                }else{
                    tempdata.services.push(referalAPIObject)
                }
            })*/
      } else {
        tempdata.services.push(referalAPIObject);
      }
      OfflineDb.updateFullEntity(tempdata).then((response) => {
        const linkContact = {
          enabled: false,
          linkTrackedEntityInstance:
            activeCaseDetails.data.trackedEntityInstance,
        };
        const activeStageCaseFormData = {
          formFormat: valueForFormInput,
          dhisFormat: null,
        };

        setActiveCaseFormData({
          data: {
            formFormat: valueForFormInput,
            dhisFormat: null,
          },
        });

        OfflineDb.setDataIntoPouchDB(
          "activeCaseFormData",
          activeStageCaseFormData
        );
        OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

        //next tab
        const nextTab =
          fetchActiveTab[
            fetchActiveTab.indexOf(currentStage.id) + stepIncrement
          ];
        const nextTabStage = programData.programs[0].programStages.find(
          (obj) => obj.id == nextTab
        );
        if (!stageAccessCheck(nextTabStage)) {
          redirectedHome = true;
          stepIncrement = stepIncrement + 1;
          let nextOfNextTab =
            fetchActiveTab[fetchActiveTab.indexOf(nextTabStage.id) + 1];
          let nextTabStageCheck = programData.programs[0].programStages.find(
            (obj) => obj.id == nextOfNextTab
          );
          if (nextOfNextTab) {
            redirectedHome = false;
            if (!stageAccessCheck(nextTabStageCheck))
              stepIncrement = stepIncrement + 1;
          }
        }
        if (nextTab && !redirectedHome) {
          swal({
            title: t("Success"),
            text: t("Successfully submited event offline"),
            icon: "success",
            button: t("Close"),
          });
          const indexOfNextTab =
            programData.programs[0].programStages.findIndex(
              (obj) => obj.id == nextTab
            );
          checkAndGetAdherenceDetails(indexOfNextTab + stepIncrement);
          //setValue(indexOfNextTab + stepIncrement);
          if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
            addNextService(currentStage,function(){
                setValue(indexOfNextTab + stepIncrement)
            })
        }else{
            setValue(indexOfNextTab + stepIncrement)
        }
          if (programBoDetails && programBoDetails.isReferralWorkflow) {
            if (
              valueForFormInput[clientTypeID] ==
              Configuration.ltbiLinkVariables.index
            ) {
              let nextTabIndex = indexOfNextTab;
              if (currentStage.id == riskAssementStageId) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == referralServiceStageId
                );
              } else if (currentStage.id == referralServiceStageId) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tbTretmentInitiationStageId
                );
              } else if (currentStage.id == adherenceTBStageId) {
                nextTabIndex = programData.programs[0].programStages.length;
              }
              stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
              setValue(nextTabIndex + stepIncrement);
            } else if (currentStage.id == referralServiceStageId) {
              let nextTabIndex = indexOfNextTab;
              if (
                valueForFormInput[selectReferralServiceId] &&
                valueForFormInput[selectReferralServiceId] ==
                  tbTretmentInitiationStageId
              ) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tbTretmentInitiationStageId
                );
                stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                setValue(nextTabIndex + stepIncrement);
              } else if (
                valueForFormInput[selectReferralServiceId] &&
                valueForFormInput[selectReferralServiceId] ==
                  tptIntiationStageId
              ) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tptIntiationStageId
                );
                stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                setValue(nextTabIndex + stepIncrement);
              }
            }
            if (currentStage.id == sampleCollectionStageId) {
              let nextTabIndex = indexOfNextTab;
              if (
                valueForFormInput[selectReferralServiceId] &&
                valueForFormInput[selectReferralServiceId] == tbTestingStageId
              ) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tbTestingStageId
                );
                stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                setValue(nextTabIndex + stepIncrement);
              } else if (
                valueForFormInput[selectReferralServiceId] &&
                valueForFormInput[selectReferralServiceId] ==
                  tbInfectionTestingStageId
              ) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tbInfectionTestingStageId
                );
                stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                setValue(nextTabIndex + stepIncrement);
              }
            }
            if (
              currentStage.id == tbTretmentInitiationStageId &&
              valueForFormInput[selectReferralServiceId] &&
              (valueForFormInput[selectReferralServiceId] ==
                tbTretmentInitiationStageId ||
                valueForFormInput[selectReferralServiceId] == tbTestingStageId)
            ) {
              //history.push('/layout/home');
            }
            if (currentStage.id == tbTestingStageId) {
              let nextTabIndex = indexOfNextTab;
              if (
                valueForFormInput[testresultTBId] &&
                valueForFormInput[testresultTBId].toLowerCase() == "positive"
              ) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tbTretmentInitiationStageId
                );
                stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                setValue(nextTabIndex + stepIncrement);
              } else if (
                valueForFormInput[testresultTBId] &&
                valueForFormInput[testresultTBId].toLowerCase() == "negative"
              ) {
                if (
                  !valueForFormInput[IspatienteligibleforTBIId] ||
                  (valueForFormInput[IspatienteligibleforTBIId] &&
                    valueForFormInput[
                      IspatienteligibleforTBIId
                    ].toLowerCase() == "no")
                ) {
                  history.push("/layout/home");
                }
              }
            }
            if (currentStage.id == tbInfectionTestingStageId) {
              let nextTabIndex = indexOfNextTab;
              if (
                !valueForFormInput[IspatienteligibleforTPTId] ||
                (valueForFormInput[IspatienteligibleforTPTId] &&
                  valueForFormInput[IspatienteligibleforTPTId].toLowerCase() ==
                    "no")
              ) {
                history.push("/layout/home");
              } else if (
                valueForFormInput[IspatienteligibleforTPTId] &&
                valueForFormInput[IspatienteligibleforTPTId].toLowerCase() ==
                  "yes"
              ) {
                nextTabIndex = programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == tptIntiationStageId
                );
                stepIncrement = searchEnabled && navigator.onLine ? 2 : 1;
                setValue(nextTabIndex + stepIncrement);
              }
            }
          }
          if (userrolename && userrolename == patientRole) {
            history.push("/layout/home");
          }
          if (currentStage.id == followupStageId || currentStage.id == diagnosisStageId) {
            history.push("/layout/home");
          }
        } else {
          setValue(value);
          swal({
            title: t("Success"),
            text: t("Successfully submited event offline"),
            icon: "success",
            button: t("Close"),
          });
          if (userrolename && userrolename == patientRole) {
            history.push("/layout/home");
          } else {
            //history.push("/layout/home");
            if(Configuration.addnewservicepopup && Configuration.addnewservicepopup[currentStage.description]){
                addNextService(currentStage,function(){
                    history.push("/layout/home");
                })
            }else{
                history.push("/layout/home");
            }
          }
        }
      });
    });
  }

  function getMultiserviceArray() {
    //programRules activeCaseFormData
    let programStages = programData.programs[0].programStages;
    let stageSequenceArr = [];
    if (programRules != null) {
      programRules.map((rules) => {
        const filteredRule = rules.programRuleActions.filter(
          (obj) => obj.programRuleActionType == "DISPLAYKEYVALUEPAIR"
        );
        if (filteredRule.length > 0) {
          //const operators = ['==', '!=']
          const condition = rules.condition;
          const splitConditions = condition.split("&&");

          splitConditions.map((splitCondition) => {
            let StageDetails = {};
            StageDetails["name"] = splitCondition
              .split("V{program_stage_name} == ")[1]
              .replace(/\'/g, "")
              .trim();
            let stageObj = programStages.filter(
              (obj) =>
                obj.displayName.toLocaleLowerCase() ==
                StageDetails["name"].toLocaleLowerCase()
            );
            StageDetails["id"] =
              stageObj.length > 0 ? stageObj[0].id : undefined;
            stageSequenceArr.push(StageDetails);
          });
        }
      });
    }

    if (trackentityInstanceDetails.enrollments) {
      if (
        trackentityInstanceDetails.enrollments[0].events.length >=
        stageSequenceArr.length
      ) {
        return true;
      }
    }
    return false;
  }

  function gotoNewService() {
    let registrationFormData = {};
    programData.programs[0].trackedEntityAttribute.map((attribute) => {
      if (
        activeCaseFormData.data.formFormat.hasOwnProperty(
          attribute.trackedEntityAttribute.id
        )
      ) {
        registrationFormData[attribute.trackedEntityAttribute.id] =
          activeCaseFormData.data.formFormat[
            attribute.trackedEntityAttribute.id
          ];
      }
    });
    const activeCaseFormData = {
      formFormat: registrationFormData, //valueForFormInput,
      dhisFormat: null, //
    };

    OfflineDb.setDataIntoPouchDB("newSeviceStart", true);
    setServiceStartFlag(true);

    OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
    setValue(1);
  }
  const handleDateClick = (arg) => {
    // bind with an arrow function
    //arg.jsEvent.target.classList.add("bg-green");
  };
  const handleEventClick = (arg) => {
    // bind with an arrow function
  };
  const handleDateSelect_old = (selectInfo) => {
    //let title = prompt("Please enter a new title for your event");
    //let calendarApi = selectInfo.view.calendar;

    //selectInfo.jsEvent.target.classList.add("bg-green");

    // set selected date in state variable
    setFullCalenderSelectedDate(selectInfo.startStr);
    //getMedicinesListFromEvents()
    //calendarApi.unselect() // clear date selection

    /*if (title) {
      calendarApi.addEvent({
        id: 1,
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      });
    }*/
  };
  function checkIsMedicineTakenOnSelectedDate_old(dateSelected) {
    if (trackentityInstanceDetails.enrollments[0].events.length > 0) {
      let sortedEvents = _.filter(
        trackentityInstanceDetails.enrollments[0].events,
        { programStage: adherenceStageId }
      );
      if (sortedEvents.length > 0) {
        let finalEvents = _.filter(sortedEvents, {
          dataValues: [
            { dataElement: dateMedicineTakenId, value: dateSelected },
          ],
        });
        return finalEvents.length > 0 ? true : false;
      }
    } else {
      return false;
    }
  }

  function handleDateSelect(selectInfo, stage) {
    setMissedDoseInputValue(null);
    setTempMedicineTakenEvent([]);
    //console.log("stage ",selectInfo, stage);
    //let title = prompt("Please enter a new title for your event");
    let calendarApi = selectInfo.view.calendar;
    let formvaluedata = _.cloneDeep(activeCaseFormData);
    let events = [...fullCalendarEvents];
    //console.log("selectInfo.startStr ",selectInfo,selectInfo.startStr,checkIsMedicineTakenOnSelectedDate(selectInfo.startStr));
    //selectInfo.jsEvent.target.classList.add("bg-green");
    if (checkIsMedicineTakenOnSelectedDate(selectInfo.dateStr)) {
      // let findCurrentDateValue = events.find(
      //   (obj) => obj.start == selectInfo.startStr
      // );
      // if (findCurrentDateValue) {
      //   _.remove(events, (o) => {
      //     return o.new;
      //   });
      //   setFullCalendarEvents(events);
      // }

      //   swal({
      //     title: t("Info"),
      //     text: t("You have already submitted medicine for this date!"),
      //     icon: "info",
      //     button: t("Close"),
      //   });
      if (stage.id == adherenceTPTStageId) {
        setCalendarEventPopup(true);
        let findCurrentDateValue = events.find(
          (obj) => obj.start == selectInfo.dateStr
        );
        if (findCurrentDateValue) {
          setEventRecordedon(findCurrentDateValue.start);
          setDoseEventStatus(
            findCurrentDateValue.medicineTaken == "Yes"
              ? t("Dose taken")
              : findCurrentDateValue.medicineTaken == "No"
              ? t("Missed dose")
              : ""
          );
          if (
            findCurrentDateValue &&
            findCurrentDateValue.medicineTaken == "No"
          ) {
            setReasonForMissedDose(
              findCurrentDateValue.reasonForMissedDose
                ? findCurrentDateValue.reasonForMissedDose
                : t("N/A")
            );
          }
        }
      } else if (stage.id == adherenceTBStageId) {
        try {
          setCalendarEventPopup(true);
          let findCurrentDateValue = events.find(
            (obj) => obj.start == selectInfo.dateStr
          );
          let doseTakenMedicine = [];
          let missedDoseMedicine = [];
          let selectedDateEvents = [];
          let medicineNameDataElementId = null;
          let stageData = _.isEmpty(trackentityInstanceDetails)
            ? []
            : trackentityInstanceDetails.enrollments[0].events;
          let sortedEvents = _.filter(stageData, {
            programStage: adherenceTBStageId,
          });
          if (sortedEvents.length > 0) {
            let finalEvents = _.filter(sortedEvents, {
              dataValues: [{ dataElement: dateMedicineTakenId }],
            });
            finalEvents.map((event) => {
              let eventObj = _.find(event.dataValues, {
                value: selectInfo.dateStr,
              });
              if (eventObj) {
                selectedDateEvents.push(event);
              }
            });
          }
          medicineTable.map((row) => {
            const regimenConfigObject = _.find(
              Configuration.treatmentRegimens,
              { code: row[treatmentRegimenId], phase: row[treatmentPhaseId] }
            );
            if (regimenConfigObject != undefined) {
              let fieldDetails = _.find(stage.programStageDataElements, [
                "dataElement.description",
                regimenConfigObject.associatedFieldName,
              ]);
              if (!medicineNameDataElementId && fieldDetails) {
                medicineNameDataElementId = fieldDetails.dataElement.id;
              }
            }
          });
          if (medicineNameDataElementId) {
            selectedDateEvents.map((event) => {
              let eventYes = _.find(event.dataValues, {
                dataElement: medicineTakenId,
                value: "yes",
              });
              let eventNo = _.find(event.dataValues, {
                dataElement: medicineTakenId,
                value: "no",
              });
              if (eventYes) {
                let medName = _.find(event.dataValues, {
                  dataElement: medicineNameDataElementId,
                });
                if (medName && medName.value) {
                  doseTakenMedicine.push(medName.value);
                }
              }
              if (eventNo) {
                let medName = _.find(event.dataValues, {
                  dataElement: medicineNameDataElementId,
                });
                if (medName && medName.value) {
                  missedDoseMedicine.push(medName.value);
                }
              }
            });
          }
          if (findCurrentDateValue) {
            setEventRecordedon(findCurrentDateValue.start);
            setDoseEventStatus(
              findCurrentDateValue.backgroundColor
                ? findCurrentDateValue.backgroundColor == "#f58634"
                  ? t("Partially dose taken")
                  : findCurrentDateValue.backgroundColor == "#ff4d4d"
                  ? t("Missed dose")
                  : findCurrentDateValue.backgroundColor == "#4caf50"
                  ? t("Dose taken")
                  : " "
                : ""
            );
            if (doseTakenMedicine.length > 0) {
              setDoseTakenMedicines(doseTakenMedicine.toString());
            }
            if (missedDoseMedicine.length > 0) {
              setMissedDoseMedicines(missedDoseMedicine.toString());
            }
          }
        } catch (e) {
          console.log(e);
        }
      }
      calendarApi.unselect(); // clear date selection
    } else if (!checkIsMedicineTakenOnValidDate(selectInfo, stage)) {
      swal({
        title: t("Info"),
        text: t("Please select valid date!"),
        icon: "info",
        button: t("Close"),
      });
      calendarApi.unselect(); // clear date selection
    } else {
      // set selected date in state variable
      if (stage.id == adherenceTPTStageId) {
        setOpenEventPopup(true);
      } else if (stage.id == adherenceTBStageId) {
        setOpenMedicineListEventPopup(true);
        //setMedicineTakenRadioValue('yes')
        let tempMedicineTakenArr = [];
        if (medicineTable && medicineTable.length > 0) {
          let radioObj = {};
          medicineTable.map((med) => {
            radioObj[med.medicine.code] = "yes";
          });
          setRadioValue(radioObj);
          tempMedicineTakenArr.push(radioObj);
        }
        setTempMedicineTakenEvent(null);
        setTimeout(() => {
          setTempMedicineTakenEvent(tempMedicineTakenArr);
        }, 10);
      }
      setCalendarSelectedDate(selectInfo.dateStr);
      setFullCalenderSelectedDate(selectInfo.dateStr);

      //   let radioObj = {};
      //   medicineTable.map((med) => {
      //     radioObj[med.medicine.code] = "yes";
      //   });
      //   if(stage && stage.id == adherenceTBStageId){
      //     setRadioValue(radioObj);
      //   }else{
      //     setRadioValue('yes')
      //   }
      //   let bgColor = "#4caf50";
      //   if (events.length > 0) {
      //     let findCurrentDateValue = events.find(
      //       (obj) => obj.start == selectInfo.dateStr
      //     );
      //     if (findCurrentDateValue) {
      //       findCurrentDateValue.backgroundColor = bgColor;
      //       /**REMOVE FROM EVENT ARRAY */
      //     //   _.remove(events, (o) => {
      //     //     return o.new && o.start == selectInfo.startStr;
      //     //   });
      //       /** */
      //     } else {
      //     //   _.remove(events, (o) => {
      //     //     return o.new;
      //     //   });
      //       events.push({
      //         start: selectInfo.dateStr,
      //         end: selectInfo.dateStr,
      //         allDay: true,
      //         backgroundColor: bgColor,
      //         display: "background",
      //         overlap: false,
      //         new: true,
      //         medicineTaken: "yes"
      //       });
      //     }
      //   } else {
      //     events.push({
      //       start: selectInfo.dateStr,
      //       end: selectInfo.dateStr,
      //       allDay: true,
      //       backgroundColor: bgColor,
      //       display: "background",
      //       overlap: false,
      //       new: true,
      //       medicineTaken: "yes"
      //     });
      //   }

      //   setTimeout(() => {
      //     setFullCalendarEvents(events);
      //   }, 10);
    }
    /*if (title) {
      calendarApi.addEvent({
        id: 1,
        title,
        start: selectInfo.startStr,
        end: selectInfo.endStr,
        allDay: selectInfo.allDay
      });
    }*/
  }
  function checkIsMedicineTakenOnValidDate(selectInfo, currentStage) {
    //console.log("calendarStartDate ",calendarStartDate);
    if (currentStage.id == adherenceTBStageId) {
      let selectedDate = getDateWithoutTime(new Date(selectInfo.dateStr));
      if (
        calendarStartDate &&
        calendarEndDate &&
        selectedDate >= getDateWithoutTime(new Date(calendarStartDate)) &&
        selectedDate <= getDateWithoutTime(new Date()) &&
        selectedDate <= getDateWithoutTime(new Date(calendarEndDate))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      let selectedDate = getDateWithoutTime(new Date(selectInfo.dateStr));
      // console.log("fullCalendarEvents", fullCalendarEvents);
      //console.log("selectedDate ",selectedDate,getDateWithoutTime(new Date(calendarStartDate)),selectedDate >= getDateWithoutTime(new Date(calendarStartDate)),selectedDate <= getDateWithoutTime(new Date(moment(calendarStartDate).add(5, "days"))),selectedDate <= getDateWithoutTime(new Date()));
      if (calendarStartDate && tptStartRegimen && tptStartRegimen == "3HR") {
        if (
          selectedDate >= getDateWithoutTime(new Date(calendarStartDate)) &&
          selectedDate <=
            getDateWithoutTime(
              new Date(moment(calendarStartDate).add(120 - 1, "days"))
            ) &&
          selectedDate <= getDateWithoutTime(new Date())
        ) {
          return true;
        }
      } else if (
        calendarStartDate &&
        tptStartRegimen &&
        tptStartRegimen == "4R"
      ) {
        if (
          selectedDate >= getDateWithoutTime(new Date(calendarStartDate)) &&
          selectedDate <=
            getDateWithoutTime(
              new Date(moment(calendarStartDate).add(160 - 1, "days"))
            ) &&
          selectedDate <= getDateWithoutTime(new Date())
        ) {
          return true;
        }
      } else if (
        calendarStartDate &&
        tptStartRegimen &&
        tptStartRegimen == "6H"
      ) {
        if (
          selectedDate >= getDateWithoutTime(new Date(calendarStartDate)) &&
          selectedDate <=
            getDateWithoutTime(
              new Date(moment(calendarStartDate).add(239 - 1, "days"))
            ) &&
          selectedDate <= getDateWithoutTime(new Date())
        ) {
          return true;
        }
      } else if (
        calendarStartDate &&
        tptStartRegimen &&
        tptStartRegimen == "3HP"
      ) {
        if (
          selectedDate >= getDateWithoutTime(new Date(calendarStartDate)) &&
          selectedDate <=
            getDateWithoutTime(
              new Date(moment(calendarStartDate).add(120 - 1, "days"))
            ) &&
          selectedDate <= getDateWithoutTime(new Date())
        ) {
          //if (trackentityInstanceDetails.enrollments[0].events.length > 0) {
          if (fullCalendarEvents.length > 0) {
            try {
              // let sortedEvents = _.orderBy(_.filter(
              // trackentityInstanceDetails.enrollments[0].events,
              // { programStage: adherenceStageId }
              // ), ['created'], ['desc']);
              let sortedEvents = _.orderBy(
                fullCalendarEvents,
                ["start"],
                ["desc"]
              );
              //console.log("sortedEvents ",sortedEvents);
              if (sortedEvents.length > 0) {
                //let lastMedicineTakenDate = _.find(sortedEvents[0].dataValues,{'dataElement':dateMedicineTakenId})
                let lastMedicineTakenDate = sortedEvents[0]["start"]; //_.find(sortedEvents[0].dataValues,{'dataElement':dateMedicineTakenId})
                let medicineTakenStatus = sortedEvents[0]["medicineTaken"]; //_.find(sortedEvents[0].dataValues,{'dataElement':medicineTakenStatus})
                if (lastMedicineTakenDate && medicineTakenStatus) {
                  let date1 = moment(selectedDate);
                  let date2 = moment(lastMedicineTakenDate);
                  let days = date1.diff(date2, "days");
                  if (days >= 7 && medicineTakenStatus == "Yes") {
                    return true;
                  } else if (days >= 1 && medicineTakenStatus == "No") {
                    return true;
                  }
                }
              } else {
                return true;
              }
            } catch (e) {}
          } else {
            return true;
          }
        }
      } else if (
        calendarStartDate &&
        tptStartRegimen &&
        tptStartRegimen == "1HP"
      ) {
        if (
          selectedDate >= getDateWithoutTime(new Date(calendarStartDate)) &&
          selectedDate <=
            getDateWithoutTime(
              new Date(moment(calendarStartDate).add(40 - 1, "days"))
            ) &&
          selectedDate <= getDateWithoutTime(new Date())
        ) {
          return true;
        }
      } else {
        return false;
      }
    }
  }
  function checkIsMedicineTakenOnSelectedDate(dateSelected) {
    if (navigator.onLine && trackentityInstanceDetails && trackentityInstanceDetails.enrollments && trackentityInstanceDetails.enrollments[0] && trackentityInstanceDetails.enrollments[0].events.length > 0) {
      let sortedEvents = _.filter(
        trackentityInstanceDetails.enrollments[0].events,
        { programStage: adherenceStageId }
      );
      if (sortedEvents.length > 0) {
        let finalEvents = _.filter(sortedEvents, {
          dataValues: [
            { dataElement: dateMedicineTakenId, value: dateSelected },
          ],
        });
        return finalEvents.length > 0 ? true : false;
      }
    } else if(!navigator.onLine){
        //do something here
        OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance).then(res=>{
            console.log("res ",res,activeCaseDetails.data.trackedEntityInstance,adherenceStageId,adherenceTBStageId,tbTretmentInitiationStageId);
            let sortedEvents = _.filter(
                res.services, { events: [{ programStage:adherenceStageId }] }
            );
            console.log("sortedEvents ",sortedEvents);
            if (sortedEvents.length > 0) {
            let finalEvents = _.filter(sortedEvents, {
                dataValues: [
                { dataElement: dateMedicineTakenId, value: dateSelected },
                ],
            });
            return finalEvents.length > 0 ? true : false;
            }
        })
    }else {
      return false;
    }
  }

  const getSputumTableDetail = () => {
    let sortedEvents = _.filter(
      trackentityInstanceDetails.enrollments[0].events,
      { programStage: specimenStageId }
    );
    if (sortedEvents.length > 0) {
      // console.log('sortedEvents>>>', sortedEvents)

      let arrTemp = [];
      sortedEvents.map((event) => {
        let sputumTableObj = {};
        sputumTableObj["eventdetails"] = Object.assign({}, event);
        event.dataValues.map((dv) => {
          if (dv.dataElement == dateOfSampleCollection) {
            sputumTableObj[dateOfSampleCollection] = moment(dv.value).format(
              "MM/DD/YYYY"
            );
          } else if (dv.dataElement == specimenid) {
            sputumTableObj[specimenid] = dv.value;
          } else if (dv.dataElement == specimenType) {
            sputumTableObj[specimenType] = dv.value;
          } else if (dv.dataElement == noOfSputumCollected) {
            sputumTableObj[noOfSputumCollected] = dv.value;
          } else if (dv.dataElement == sputumQRCode) {
            sputumTableObj[sputumQRCode] = dv.value;
          }
        });
        sputumTableObj["action"] = "edit";
        arrTemp.push(sputumTableObj);
      });
      setsputumTable(arrTemp);
    }
  };

function getMedicinesListFromEvents(currentStage,allEvents) {
    try{
    //debugger
        let sortedEvents = trackentityInstanceDetails && trackentityInstanceDetails.enrollments && trackentityInstanceDetails.enrollments[0] ? _.filter(trackentityInstanceDetails.enrollments[0].events, { 'programStage': regimenStageId }) : [];
        if(!navigator.onLine){
            sortedEvents = allEvents ? _.filter(allEvents, { 'programStage': regimenStageId })  : []
        }
        if (sortedEvents.length > 0) {
            //get treatment adherence value
            let objTreatmentAdherence = _.find(sortedEvents[sortedEvents.length - 1].dataValues, { 'dataElement': treatmentAdherenceId });
            
            let treatmentAdherenceValue = (objTreatmentAdherence != undefined) ? objTreatmentAdherence.value : "";
            //filter events by treatmentAdherenceId 
            let finalEvents = _.filter(sortedEvents, { dataValues: [{ dataElement: treatmentAdherenceId, value: treatmentAdherenceValue }] });
            if(finalEvents.length == 0){
            finalEvents = [sortedEvents[sortedEvents.length - 1]]
            }
            //console.log("finalEvents ",finalEvents)
            if (finalEvents.length > 0) {
                setMedicineTable([])
                let arrTemp = [];
                finalEvents.map(eventObj => {
                    /*let objRegimen =  _.find(eventObj.dataValues, { 'dataElement':  treatmentRegimenId});
                    let medicineid = null;
                    if(objRegimen.value == "Regimen 1 - Child (Fixed)"){
                        medicineid = fixedDoseChildren.id;
                    }else if(objRegimen.value == "Regimen 1 - Child (Single dose)"){
                        medicineid = singleDoseChildren.id;
                    }else if(objRegimen.value == "Regimen 1 - Adult (Fixed dose)"){
                        medicineid = fixedDoseAdult.id;
                    }else if(objRegimen.value == "Regimen 1 - Adult (Single dose)"){
                        medicineid = singleDoseAdult.id;
                    }
                    
                    setMedicineRadioId(medicineid)
                    let objMedicine =  _.find(eventObj.dataValues, { 'dataElement':  medicineid});
                    let finalObj = {};
                    if(objMedicine) {
                        if(objMedicine.value){
                            finalObj[medicineid] = objMedicine.value;
                        }
                    }
                    
                    
                    let objTreatmentAdherence =  _.find(eventObj.dataValues, { 'dataElement':  treatmentAdherenceId});
                    finalObj[treatmentAdherenceId] = objTreatmentAdherence ? objTreatmentAdherence.value : {};
                    arrTemp.push(finalObj)  */

            let regmineTableObj = {}; //arrTemp=[];
            //arrTemp=_.cloneDeep(medicineTable)
            regmineTableObj["eventdetails"] = Object.assign({}, eventObj);
            let objRegimen = _.find(eventObj.dataValues, {
              dataElement: treatmentRegimenId,
            });
            regmineTableObj[treatmentRegimenId] = objRegimen
              ? objRegimen.value
              : "";

            let objPhase = _.find(eventObj.dataValues, {
              dataElement: treatmentPhaseId,
            });
            regmineTableObj[treatmentPhaseId] = objPhase ? objPhase.value : "";
            eventObj.dataValues.map((DE) => {
              /*if(DE.dataElement == treatmentRegimenId){
                            regmineTableObj[treatmentRegimenId] = DE.value
                        }else*/
                        if (DE.dataElement == treatmentStartDateId) {
                            regmineTableObj[treatmentStartDateId] = moment(DE.value).format('MM/DD/YYYY');
                        } else if (DE.dataElement == treatmentEndDateId) {
                            regmineTableObj[treatmentEndDateId] = moment(DE.value).format('MM/DD/YYYY');
                        } else if (DE.dataElement == treatmentDoseId) {
                            regmineTableObj[treatmentDoseId] = DE.value
                        } else if (DE.dataElement == treatmentAdherenceId) {
                            regmineTableObj[treatmentAdherenceId] = DE.value
                        }
                    })

            const regimenConfigObject = _.find(
              Configuration.treatmentRegimens,
              {
                code: regmineTableObj[treatmentRegimenId],
                phase: regmineTableObj[treatmentPhaseId],
              }
            );
            //console.log("sortedEvents ",regimenConfigObject,sortedEvents,treatmentAdherenceId,finalEvents,eventObj,treatmentStartDateId,treatmentRegimenId,treatmentPhaseId);
            if (regimenConfigObject != undefined) {
              let fieldDetails = _.filter(
                currentStage.programStageDataElements,
                [
                  "dataElement.description",
                  regimenConfigObject.associatedFieldName,
                ]
              );
              let objMedicineName = _.find(eventObj.dataValues, {
                dataElement: fieldDetails[0].dataElement.id,
              });
              //console.log("fieldDetails ",fieldDetails,)
              fieldDetails[0].dataElement.optionSet.options.map((ele) => {
                if (objMedicineName && objMedicineName.value == ele.code) {
                  let obj = Object.assign({}, regmineTableObj);
                  obj["medicine"] = Object.assign({}, ele);
                  arrTemp.push(obj);

                  //setMedicineTable(arrTemp)
                }
              });
            }
            /*if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  fixedDoseChildren.id});
                        fixedDoseChildren.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                                
                                //setMedicineTable(arrTemp)
                            }
                            
                        })
                    }else if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  singleDoseChildren.id});
                        singleDoseChildren.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                            }
                        })
                    }else if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  fixedDoseAdult.id});
                        fixedDoseAdult.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                            }
                        })
                    }else if(regmineTableObj[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
                        let objMedicineName =  _.find(eventObj.dataValues, { 'dataElement':  singleDoseAdult.id});
                        singleDoseAdult.optionSet.options.map(ele=>{
                            if(objMedicineName.value == ele.code){
                                let obj = Object.assign({},regmineTableObj)
                                obj['medicine'] = Object.assign({},ele);
                                arrTemp.push(obj)
                            }
                        })
                    }*/
          });

          //console.log("arrTemp ",arrTemp);
          setMedicineTable(_.sortBy(arrTemp, treatmentRegimenId));
          /*setMedicineListForCalender(arrTemp)
           */
        } else {
          setMedicineTable([]);
        }
      } else {
        setMedicineTable([]);
      }
    } catch (e) {
      console.log("e ", e);
      setMedicineTable([]);
    }
  }

  function getDateWithoutTime(dt) {
    dt.setHours(0, 0, 0, 0);
    return dt;
  }

  function renderFullCalender(stage, stageDataElements) {
    //trackentityInstanceDetails.enrollments[0].events;
    /*let sortedEvents = _.filter(trackentityInstanceDetails.enrollments[0].events, { 'programStage':  regimenStageId});
    
    if(sortedEvents.length > 0){
        let arrTemp = [];
        sortedEvents.map(eventObj=>{
            let objRegimen =  _.find(eventObj.dataValues, { 'dataElement':  treatmentRegimenId});
            let medicineid = null;
            if(objRegimen.value == "Regimen 1 - Child (Fixed)"){
                medicineid = fixedDoseChildren.id;
            }else if(objRegimen.value == "Regimen 1 - Child (Single dose)"){
                medicineid = singleDoseChildren.id;
            }else if(objRegimen.value == "Regimen 1 - Adult (Fixed dose)"){
                medicineid = fixedDoseAdult.id;
            }else if(objRegimen.value == "Regimen 1 - Adult (Single dose)"){
                medicineid = singleDoseAdult.id;
            }

            let objMedicine =  _.find(eventObj.dataValues, { 'dataElement':  medicineid});
            let finalObj = {};
            finalObj[medicineid] = objMedicine.value;

            let objTreatmentAdherence =  _.find(eventObj.dataValues, { 'dataElement':  treatmentAdherenceId});
            finalObj[treatmentAdherenceId] = objTreatmentAdherence.value;
            arrTemp.push(finalObj)  
        })
        //setMedicineListForCalender(arrTemp)
        
    }*/
    //setIsFullCalenderPresentInStage(true)
    /*stageDataElements.map(field=>{
        if(field.dataElement.displayName.trim().toLocaleLowerCase() == "date medicine taken"){
            setDateMedicineTakenId(field.dataElement.id)
        }else if(field.dataElement.displayName.trim().toLocaleLowerCase() == "medicine taken"){
            setMedicineTakenId(field.dataElement.id)
        } 
    })*/
    return (
      <>
        <FullCalendar
          plugins={[dayGridPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left: "prev",
            center: "title",
            right: "today next",
          }}
          weekends={true}
          dateClick={(env) => handleDateSelect(env, stage)}
          //validRange={{ end: moment().add(1, "days").format("YYYY-MM-DD") }}
          selectAllow={function (info) {
            return info.start <= getDateWithoutTime(new Date());
          }}
          selectable={true}
          unselectAuto={false}
          //select={(env) => handleDateSelect(env,stage)}
          longPressDelay={100}
          initialDate={
            fullCalenderSelectedDate ? fullCalenderSelectedDate : new Date()
          }
          //eventClick={handleEventClick}
          //ref={calendarComponentRef}
          events={fullCalendarEvents}
          /*eventSources={
            [
                {
                    //color: 'lightgreen',
                    events:fullCalendarEvents
                }
            ]
        }*/
        />
      </>
    );
  }
  // function handleMedicineRadioChange(event,name){

  //     let bgColor = "#00bcd4";
  //     if(name == 'rhzRadio'){
  //         if(event.target.value == 'yes' && ethambutolRadio == 'yes'){
  //             bgColor = '#4caf50'
  //         }else if(event.target.value == 'yes' && ethambutolRadio == 'no'){
  //             bgColor = '#f58634'
  //         }else if(event.target.value == 'no' && ethambutolRadio == 'yes'){
  //             bgColor = '#f58634'
  //         }else if(event.target.value == 'no' && ethambutolRadio == 'no'){
  //             bgColor = '#ce1212'
  //         }
  //         setRhzRadio(event.target.value)
  //     }else if(name == 'ethambutolRadio'){
  //         if(rhzRadio == 'yes' && event.target.value == 'yes'){
  //             bgColor = '#4caf50'
  //         }else if(rhzRadio == 'yes' && event.target.value == 'no'){
  //             bgColor = '#f58634'
  //         }else if(rhzRadio == 'no' && event.target.value == 'yes'){
  //             bgColor = '#f58634'
  //         }else if(rhzRadio == 'no' && event.target.value == 'no'){
  //             bgColor = '#ce1212'
  //         }
  //         setEthambutolRadio(event.target.value)
  //     }
  //     let events = [...fullCalendarEvents];

  //     if(events.length > 0) {
  //        let findCurrentDateValue = events.find(obj => obj.start == fullCalenderSelectedDate)
  //        if(findCurrentDateValue) {
  //             findCurrentDateValue.backgroundColor = bgColor
  //        } else {
  //         events.push(
  //             {
  //                 start  : fullCalenderSelectedDate,
  //                 end    : fullCalenderSelectedDate,
  //                 allDay : true,
  //                 backgroundColor: bgColor,
  //                 display: 'background',
  //                 overlap: false
  //             }
  //         )
  //        }
  //     } else {
  //         events.push(
  //             {
  //                 start  : fullCalenderSelectedDate,
  //                 end    : fullCalenderSelectedDate,
  //                 allDay : true,
  //                 backgroundColor: bgColor,
  //                 display: 'background',
  //                 overlap: false
  //             }
  //         )
  //     }
  //     //  events[0] = {
  //     //     start  : fullCalenderSelectedDate,
  //     //     end    : fullCalenderSelectedDate,
  //     //     allDay : true,
  //     //     backgroundColor: bgColor,
  //     //     display: 'background',
  //     //     overlap: false
  //     // }
  //     setFullCalendarEvents(null)
  //     setTimeout(()=>{
  //         setFullCalendarEvents(events)
  //     },10)

  // }

  function setMedicineTakenValue(medicinevalue) {
    //console.log("medicinevalue ",medicinevalue)
    setMedicineTakenRadioValue(medicinevalue);
  }
  function submitMedicineStatusEvent(values) {
    if (MedicineTakenRadioValue) {
      if (CalendarSelectedDate) {
        let event = {
          target: {
            value: MedicineTakenRadioValue,
          },
        };
        //console.log("values ",values,values[adverseDrugReaction],adverseDrugReaction)
        handleMedicineRadioChange(event, values);
      } else {
        swal({
          title: t("Info"),
          text: t("Please select date!"),
          icon: "info",
          button: t("Close"),
        });
      }
      setOpenEventPopup(null);
      setMedicineTakenRadioValue(null);
    } else {
      swal({
        title: t("Info"),
        text: t("Please select dose status!"),
        icon: "info",
        button: t("Close"),
      });
    }
  }

  function submitMedicineListEventPopup(values) {
    try {
      if (tempMedicineTakenEvent && tempMedicineTakenEvent.length > 0) {
        const noArray = [];
        const yesArray = [];
        let events = [...fullCalendarEvents];
        let bgColor = "#4caf50";

        tempMedicineTakenEvent.map((temp1) => {
          Object.keys(temp1).map((radio) => {
            if (temp1[radio] == "yes") {
              if (noArray.find((obj) => obj.name == radio)) {
                noArray = noArray.filter((obj) => obj.name != radio);
              }
              yesArray.push({
                name: radio,
                value: "yes",
              });
            } else {
              if (yesArray.find((obj) => obj.name == radio)) {
                yesArray = yesArray.filter((obj) => obj.name != radio);
              }
              noArray.push({
                name: radio,
                value: "no",
              });
            }
          });
        });

        if (noArray.length > 0) {
          if (noArray.length == medicineTable.length) {
            bgColor = "#ff4d4d";
          } else {
            bgColor = "#f58634";
          }
        } else if (yesArray.length == medicineTable.length) {
          bgColor = "#4caf50";
        } else {
          bgColor = "#00bcd4";
        }

        if (events.length > 0) {
          let findCurrentDateValue = events.find(
            (obj) => obj.start == fullCalenderSelectedDate
          );
          if (findCurrentDateValue) {
            findCurrentDateValue.backgroundColor = bgColor;
            findCurrentDateValue.medicineTaken = tempMedicineTakenEvent;
          } else {
            events.push({
              start: fullCalenderSelectedDate,
              end: fullCalenderSelectedDate,
              allDay: true,
              backgroundColor: bgColor,
              display: "background",
              overlap: false,
              medicineTaken: tempMedicineTakenEvent,
            });
          }
        } else {
          events.push({
            start: fullCalenderSelectedDate,
            end: fullCalenderSelectedDate,
            allDay: true,
            backgroundColor: bgColor,
            display: "background",
            overlap: false,
            medicineTaken: tempMedicineTakenEvent,
          });
        }
        console.log("events ", events, tempMedicineTakenEvent);
        setFullCalendarEvents(null);
        setTimeout(() => {
          setFullCalendarEvents(events);
        }, 10);
        setOpenMedicineListEventPopup(null);
      } else {
        swal({
          title: t("Info"),
          text: t("Please select medicine taken status!"),
          icon: "info",
          button: t("Close"),
        });
      }
    } catch (e) {
      console.log(e);
    }
  }

  function handleMedicineTakenRadioChange(event, value, name) {
    try {
      let radioObj = {};
      radioObj[name] = event.target.value;
      //setRadioValue(radioObj)
      //console.log("tempMedicineTakenEvent ",tempMedicineTakenEvent,[...tempMedicineTakenEvent])
      let medicineTakenEvent = [...tempMedicineTakenEvent];
      //medicineTakenEvent.push(radioObj)
      //setTempMedicineTakenEvent(medicineTakenEvent)
      if (tempMedicineTakenEvent.length > 0) {
        let findCurrentMedicine = tempMedicineTakenEvent.find(function (e) {
          return e.hasOwnProperty(name);
        });
        if (findCurrentMedicine) {
          findCurrentMedicine[name] = event.target.value;
        } else {
          medicineTakenEvent.push(radioObj);
        }
      } else {
        medicineTakenEvent.push(radioObj);
      }
      setTempMedicineTakenEvent(null);
      setTimeout(() => {
        setTempMedicineTakenEvent(medicineTakenEvent);
        setRadioValue(medicineTakenEvent[0]);
      }, 10);
    } catch (e) {
      console.log(e);
    }
  }

  function handleMedicineRadioChange(event, value, name) {
    let bgColor = "#00bcd4";
    let medicineTakenValue = event.target.value;
    const noArray = [];
    const yesArray = [];
    let temp1 = radioValue;
    console.log("radioValue ", radioValue, name);
    if (name) {
      //&& !_.isEmpty(radioValue
      temp1[name] = event.target.value;
    } else {
      temp1 = medicineTakenValue;
    }
    setRadioValue(temp1);
    if (name) {
      Object.keys(temp1).map((radio) => {
        if (temp1[radio] == "yes") {
          if (noArray.find((obj) => obj.name == radio)) {
            noArray = noArray.filter((obj) => obj.name != radio);
          }
          yesArray.push({
            name: radio,
            value: "yes",
          });
        } else {
          if (yesArray.find((obj) => obj.name == radio)) {
            yesArray = yesArray.filter((obj) => obj.name != radio);
          }
          noArray.push({
            name: radio,
            value: "no",
          });
        }
      });

      if (noArray.length > 0) {
        if (noArray.length == medicineTable.length) {
          bgColor = "#ff4d4d";
        } else {
          bgColor = "#f58634";
        }
      } else if (yesArray.length == medicineTable.length) {
        bgColor = "#4caf50";
      } else {
        bgColor = "#00bcd4";
      }
    } else {
      if (medicineTakenValue && medicineTakenValue.toLowerCase() == "yes") {
        bgColor = "#4caf50";
      } else if (
        medicineTakenValue &&
        medicineTakenValue.toLowerCase() == "no"
      ) {
        bgColor = "#ff4d4d";
      }
    }

    let events = [...fullCalendarEvents];

    if (events.length > 0) {
      let findCurrentDateValue = events.find(
        (obj) => obj.start == fullCalenderSelectedDate
      );
      if (findCurrentDateValue) {
        findCurrentDateValue.backgroundColor = bgColor;
        findCurrentDateValue.medicineTaken = medicineTakenValue;
      } else {
        events.push({
          start: fullCalenderSelectedDate,
          end: fullCalenderSelectedDate,
          allDay: true,
          backgroundColor: bgColor,
          display: "background",
          overlap: false,
          medicineTaken: medicineTakenValue,
        });
      }
    } else {
      events.push({
        start: fullCalenderSelectedDate,
        end: fullCalenderSelectedDate,
        allDay: true,
        backgroundColor: bgColor,
        display: "background",
        overlap: false,
        medicineTaken: medicineTakenValue,
      });
    }
    console.log("events ", events);
    setFullCalendarEvents(null);
    setTimeout(() => {
      setFullCalendarEvents(events);
    }, 10);
  }

  function setRegimenStageDEIds(stage) {
    stage.programStageDataElements.map((DE) => {
      let fieldname = DE.dataElement.description
        ? DE.dataElement.description
        : DE.dataElement.formName
        ? DE.dataElement.formName
        : DE.dataElement.displayName;
      if (fieldname.trim().toLocaleLowerCase() == "treatment regimen") {
        setTreatmentRegimenId(DE.dataElement.id);
      } else if (fieldname.trim().toLocaleLowerCase() == "treatment phase") {
        setTreatmentPhaseId(DE.dataElement.id);
      } else if (fieldname.trim().toLocaleLowerCase() == "fixed dose (adult)") {
        setFixedDoseAdult(DE.dataElement);
      } else if (
        fieldname.trim().toLocaleLowerCase() == "fixed dose (children)"
      ) {
        setFixedDoseChildren(DE.dataElement);
      } else if (
        fieldname.trim().toLocaleLowerCase() == "single dose (adult)"
      ) {
        setSingleDoseAdult(DE.dataElement);
      } else if (
        fieldname.trim().toLocaleLowerCase() == "single dose (children)"
      ) {
        setSingleDoseChildren(DE.dataElement);
      } else if (
        fieldname.trim().toLocaleLowerCase() == "treatment start date"
      ) {
        setTreatmentStartDateId(DE.dataElement.id);
      } else if (fieldname.trim().toLocaleLowerCase() == "treatment end date") {
        setTreatmentEndDateId(DE.dataElement.id);
      } else if (
        fieldname.trim().toLocaleLowerCase() == "treatment dosage (mg)"
      ) {
        setTreatmentDoseId(DE.dataElement.id);
      } else if (
        fieldname.trim().toLocaleLowerCase() == "treatment adherence id"
      ) {
        setTreatmentAdherenceId(DE.dataElement.id);
      }
    });
  }
  function addRegimen(stage, formvalues) {
    //formvalues[treatmentRegimenId] = "";
    let regmineTableObj = {},
      arrTemp = [];
    arrTemp = _.cloneDeep(medicineTable);
    regmineTableObj[treatmentRegimenId] = formvalues[treatmentRegimenId];
    regmineTableObj[treatmentPhaseId] = formvalues[treatmentPhaseId];
    regmineTableObj[treatmentStartDateId] = moment(
      formvalues[treatmentStartDateId]
    ).format("MM/DD/YYYY");
    regmineTableObj[treatmentEndDateId] = moment(
      formvalues[treatmentEndDateId]
    ).format("MM/DD/YYYY");
    regmineTableObj[treatmentDoseId] = formvalues[treatmentDoseId]
      ? formvalues[treatmentDoseId]
      : "";
    regmineTableObj[treatmentAdherenceId] =
      userData.userCredentials.username + "_" + Date.now();
    const regimenConfigObject = _.find(Configuration.treatmentRegimens, {
      code: formvalues[treatmentRegimenId],
      phase: formvalues[treatmentPhaseId],
    });
    if (regimenConfigObject != undefined) {
      let fieldDetails = _.filter(stage.programStageDataElements, [
        "dataElement.description",
        regimenConfigObject.associatedFieldName,
      ]);
      fieldDetails[0].dataElement.optionSet.options.map((ele) => {
        let obj = Object.assign({}, regmineTableObj);
        obj["medicine"] = ele;
        arrTemp.push(obj);
        setMedicineTable(arrTemp);
      });
    } else {
      if (
        formvalues[tbtreatmentinitiatedId] &&
        formvalues[tbtreatmentinitiatedId] == "Yes"
      ) {
        swal({
          title: t("Alert"),
          text: t("Please fill all required fields."),
          icon: "warning",
          button: t("Close"),
        });
      }
    }
    /*if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option1){
        fixedDoseChildren.optionSet.options.map(ele=>{
            let obj = Object.assign({},regmineTableObj)
            obj['medicine'] = ele;
            arrTemp.push(obj)
            
            setMedicineTable(arrTemp)
        })
    }else if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option2){
        singleDoseChildren.optionSet.options.map(ele=>{
            let obj = Object.assign({},regmineTableObj)
            obj['medicine'] = ele;
            arrTemp.push(obj)
            setMedicineTable(arrTemp)
        })
    }else if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option3){
        fixedDoseAdult.optionSet.options.map(ele=>{
            let obj = Object.assign({},regmineTableObj)
            obj['medicine'] = ele;
            arrTemp.push(obj)
            setMedicineTable(arrTemp)
        })
    }else if(formvalues[treatmentRegimenId] == Configuration.treatmentRegimens.option4){
        singleDoseAdult.optionSet.options.map(ele=>{
            let obj = Object.assign({},regmineTableObj)
            obj['medicine'] = ele;
            arrTemp.push(obj)
            setMedicineTable(arrTemp)
        })
    }*/
  }

  const resetSpecimen = () => {
    if (
      activeCaseFormData &&
      activeCaseFormData.data &&
      activeCaseFormData.data.formFormat
    ) {
      if (activeCaseFormData.data.formFormat[specimenType]) {
        activeCaseFormData.data.formFormat[dateOfSampleCollection] =
          moment().format();
        // delete activeCaseFormData.data.formFormat[specimenid];
        delete activeCaseFormData.data.formFormat[noOfSputumCollected];
        delete activeCaseFormData.data.formFormat[sputumQRCode];
        delete activeCaseFormData.data.formFormat[sampleCollectionAt];
        delete activeCaseFormData.data.formFormat[specimenType];
        let tempobj = _.cloneDeep(activeCaseFormData);
        setActiveCaseFormData(tempobj);
      }
    }
  };

  const addSpecimen = (stage, formvalues) => {
    // console.log("addSpecimen>>>", stage, formvalues);
    let sputumTableObj = {},
      arrTemp = [];
    arrTemp = _.cloneDeep(sputumTable);
    // const [specimenType, setspecimenType] = useState(null);
    // const [dateOfSampleCollection, setdateOfSampleCollection] = useState(null);
    // const [specimenid, setspecimenid] = useState(null);
    // const [noOfSputumCollected, setnoOfSputumCollected] = useState(null);
    sputumTableObj[dateOfSampleCollection] = formvalues[dateOfSampleCollection];
    sputumTableObj[specimenid] = formvalues[specimenid];
    sputumTableObj[specimenType] = formvalues[specimenType];
    sputumTableObj[noOfSputumCollected] = formvalues[noOfSputumCollected];
    sputumTableObj[sputumQRCode] = formvalues[sputumQRCode];
    arrTemp.push(sputumTableObj);
    setsputumTable(arrTemp);

    formvalues[dateOfSampleCollection] = moment().format();
    delete formvalues[specimenid];
    delete formvalues[noOfSputumCollected];
    delete formvalues[sputumQRCode];
    delete formvalues[sampleCollectionAt];
    delete formvalues[specimenType];

    const activeCaseFormData = {
      data: {
        formFormat: formvalues, //valueForFormInput,
        dhisFormat: null, //
      },
    };
    let tempobj = _.cloneDeep(activeCaseFormData);
    setActiveCaseFormData(tempobj);
  };

  const removeFromTable = (array, index) => {
    let temparr = _.cloneDeep(array);
    temparr.splice(temparr.indexOf(index), 1);
    setsputumTable(temparr);
  };

  function starttoNewService(currentStage) {
    setGlobalSpinner(true);
    let currentStageDataToRemove = [];
    let updatedFormData = {};
    programData.programs[0].programTrackedEntityAttributes.map((attribute) => {
      if (
        activeCaseFormData.data.formFormat.hasOwnProperty(
          attribute.trackedEntityAttribute.id
        )
      ) {
        updatedFormData[attribute.trackedEntityAttribute.id] =
          activeCaseFormData.data.formFormat[
            attribute.trackedEntityAttribute.id
          ];
      }
    });

    programData.programs[0].programStages.map((stages, index) => {
      if (stages.id != currentStage.id) {
        stages.programStageDataElements.map((attribute) => {
          if (
            activeCaseFormData.data.formFormat.hasOwnProperty(
              attribute.dataElement.id
            )
          ) {
            updatedFormData[attribute.dataElement.id] =
              activeCaseFormData.data.formFormat[attribute.dataElement.id];
          }

          dataElementGroup.map((dataElements) => {
            if (dataElements.displayName == attribute.dataElement.displayName) {
              if (
                activeCaseFormData.data.formFormat.hasOwnProperty(
                  dataElements.id
                )
              ) {
                updatedFormData[dataElements.id] =
                  activeCaseFormData.data.formFormat[dataElements.id];
              }
            }
          });
        });
      } else if(stages.id == currentStage.id){
        stages.programStageDataElements.map((attribute) => {
        dataElementGroup.map((dataElements) => {
          if (dataElements.displayName == attribute.dataElement.displayName) {
            if (
              activeCaseFormData.data.formFormat.hasOwnProperty(
                dataElements.id
              )
            ) {
              activeCaseFormData.data.formFormat[dataElements.id] = false
            }
          }
        });
      })
      }
      // else if (stages.id == currentStage.id) {
      //   stages.programStageDataElements.map((attribute) => {
      //     let fieldShowInTable = false;
      //     if (
      //       attribute.dataElement.attributeValues &&
      //       attribute.dataElement.attributeValues.length > 0
      //     ) {
      //       fieldShowInTable =
      //         _.find(attribute.dataElement.attributeValues, [
      //           "attribute.name",
      //           "ShowInTable",
      //         ]) &&
      //         _.find(attribute.dataElement.attributeValues, [
      //           "attribute.name",
      //           "ShowInTable",
      //         ]).value == "true"
      //           ? true
      //           : false;
      //     }
      //     if (
      //       activeCaseFormData.data.formFormat.hasOwnProperty(
      //         attribute.dataElement.id
      //       )
      //     ) {
      //       if (fieldShowInTable) {
      //         delete activeCaseFormData.data.formFormat[
      //           attribute.dataElement.id
      //         ];
      //       } else {
      //         updatedFormData[attribute.dataElement.id] =
      //           activeCaseFormData.data.formFormat[attribute.dataElement.id];

      //         dataElementGroup.map((dataElements) => {
      //           if (
      //             dataElements.displayName == attribute.dataElement.displayName
      //           ) {
      //             updatedFormData[dataElements.id] =
      //               activeCaseFormData.data.formFormat[dataElements.id];
      //           }
      //         });
      //       }
      //     }
      //   });
      // }
    });

            
    console.log("updatedFormData ", updatedFormData);
    
    for(let i=0; i <currentStage.programStageDataElements.length; i++ ) {

      if(Object.hasOwn(updatedFormData, currentStage.programStageDataElements[i].dataElement.id)) {
        delete updatedFormData[
          currentStage.programStageDataElements[i].dataElement.id
                  ];
      }
    }

    console.log("updatedFormData vv", updatedFormData);

    const activeCaseFormData1 = {
      formFormat: updatedFormData, //valueForFormInput,
      dhisFormat: null, //
    };
    setActiveCaseFormData({
      data: {
        formFormat: updatedFormData, //valueForFormInput,
        dhisFormat: null, //
      },
    });
    OfflineDb.setDataIntoPouchDB("newSeviceStart", true);
    setServiceStartFlag(true);

    OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData1);
    setTimeout(function () {
      setGlobalSpinner(false);
      document
        .querySelector(".innertabdivreg")
        .scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 500);
  }

  function checkNewServiceStatus(currentStage) {
    let updatedFormData = {};
    const events = _.isEmpty(trackentityInstanceDetails)
      ? []
      : trackentityInstanceDetails.enrollments[0].events;
    const filterCurrentEvent = events.filter(
      (obj) => obj.programStage == currentStage.id && obj.status != "SCHEDULE"
    );
    if (filterCurrentEvent.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  function createStageForms(stage, index) {
    const stageIndex = index;
    const currentStage = stage;
    let initialValues = activeCaseFormData.data
      ? activeCaseFormData.data.formFormat != null
        ? activeCaseFormData.data.formFormat
        : {}
      : {};
    let uicUID = null;
    let nameUID = null;
    // let ageUID = null;
    // let genderUID = null;
    let clientTypeUID = null;
    // programData.programs[0].programTrackedEntityAttributes.map((field, index) => {
    //     if (field.trackedEntityAttribute.displayName == "First name") {
    //         nameUID = field.trackedEntityAttribute.id
    //     }
    //     if (field.trackedEntityAttribute.displayName == "UIC") {
    //         uicUID = field.trackedEntityAttribute.id
    //     }
    //     if (field.trackedEntityAttribute.displayName == "Age") {
    //         ageUID = field.trackedEntityAttribute.id
    //     }
    //     if (field.trackedEntityAttribute.displayName == "Client type") {
    //         clientTypeUID = field.trackedEntityAttribute.id
    //     }
    //     if (field.trackedEntityAttribute.displayName == "Gender") {
    //         genderUID = field.trackedEntityAttribute.id
    //     }
    // })
    var getCordovaFilePath = (imageObj) => {
      return new Promise((resolve, reject) => {
        //console.log("imageObj",imageObj)
        window.resolveLocalFileSystemURL(
          imageObj[0]["uri"],
          function (fileEntry) {
            window.requestFileSystem(
              window.LocalFileSystem.PERSISTENT,
              0,
              function (fileSys) {
                fileSys.root.getDirectory(
                  "RTMUPLOADS",
                  { create: true, exclusive: false },
                  function (dir) {
                    //var imageName = new Date().getTime() +".jpg";
                    fileEntry.copyTo(
                      dir,
                      imageObj[0]["name"],
                      function (entry) {
                        //console.log("entry ",entry)
                        var path =
                          "cdvfile://localhost/persistent" + entry.fullPath;
                        //console.log("path "+path);
                        resolve(path);
                      },
                      function (error) {
                        console.log("error 4895", JSON.stringify(error));
                        //reject(error)
                        resolve(
                          "cdvfile://localhost/persistent/RTMUPLOADS/" +
                            imageObj[0]["name"]
                        );
                      }
                    );
                  },
                  function (error) {
                    console.log("error 4902", JSON.stringify(error));
                    //reject(error);
                    resolve('');
                    setGlobalSpinner(false)
                  }
                );
              },
              function (error) {
                console.log("error 4908", JSON.stringify(error));
                //reject(error);
                resolve('');
                setGlobalSpinner(false)
              }
            );
          },
          function (error) {
            console.log("error 4914", JSON.stringify(error));
            //reject(error);
            resolve('');
            setGlobalSpinner(false)
          }
        );
      });
    };
    async function onStageSubmit(values, index) {
      setGlobalSpinner(true);
      //if(navigator.onLine){
      let fieldValueWithAttribute = [];

      programData.programs[0].programStages.map((stages, index) => {
        fetchActiveTabs(stages, values);
        // return <TabPanel value={value} index={index + 1}>
        //     {createStageForms(stages, index + 1)}
        // </TabPanel>
      });
      let fetchActiveTab = fetchActiveTabs(currentStage, values);

      //set date maually at the time of save satge
      /*if(isFullCalenderPresentInStage){
            values[dateMedicineTakenId] = fullCalenderSelectedDate;
        }*/
      const data = values;
      let promises = [];

      for (let objectKey of Object.keys(values)) {
        //Object.keys(values).map(async function (objectKey, index) {

        if (
          dataElementGroup.find((array) => array.id == objectKey) == undefined
        ) {
          var obj = {
            dataElement: objectKey,
            value:
              Array.isArray(data[objectKey]) == true
                ? data[objectKey].toString()
                : data[objectKey],
          };
          const CurrentStageValueFilter = stage.programStageDataElements.find(
            (obj) => obj.dataElement.id == objectKey
          );

          if (CurrentStageValueFilter != undefined) {
            if (
              CurrentStageValueFilter.dataElement.valueType == "IMAGE" ||
              CurrentStageValueFilter.dataElement.valueType == "FILE_RESOURCE"
            ) {
              if (data[objectKey]) {
                let formData = new FormData();
                formData.append("file", data[objectKey][0]);
                //formData.append('file', data[objectKey][0]);
                //if online
                if (navigator.onLine) {
                  promises.push(
                    apiServices
                      .postAPI("fileResources", formData)
                      .then((res) => {
                        console.log(res, "fileResources res");
                        if (res.data) {
                          //fieldValueWithAttribute.push({"dataElement": objectKey, "value": res.data.response.fileResource.id })
                          return {
                            dataElement: objectKey,
                            value: res.data.response.fileResource.id,
                          };
                        }
                      })
                      .catch((err) => {
                        console.log(
                          stageImageValue,
                          objectKey,
                          "fileResources err"
                        );
                        return {
                          dataElement: objectKey,
                          value: stageImageValue[objectKey],
                        };
                      })
                  );
                } else {
                  if (
                    window.cordova &&
                    data[objectKey] &&
                    _.isArray(data[objectKey]) &&
                    data[objectKey][0] &&
                    data[objectKey][0].uri
                  ) {
                    console.log(data[objectKey]);
                    let path = await getCordovaFilePath(data[objectKey]);
                    //console.log("4913",path)
                    fieldValueWithAttribute.push({
                      dataElement: objectKey,
                      value: path,
                    });
                    values[objectKey] = path;

                    // await getCordovaFilePath(data[objectKey]).then(res => {
                    //     console.log("4919",res)
                    // });
                  }
                }
              }
            } else {
              fieldValueWithAttribute.push(obj);
            }
          }
        } else {
          if (data[objectKey].length > 0) {
            data[objectKey].map((eachFields) => {
              var obj = {
                dataElement: eachFields,
                value: true,
              };
              const CurrentStageValueFilter =
                stage.programStageDataElements.find(
                  (obj) => obj.dataElement.id == objectKey
                );
              if (CurrentStageValueFilter != undefined) {
                fieldValueWithAttribute.push(obj);
              }
            });
          }
        }
        //})
      }

      //return;

      const events = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.enrollments[0].events;
      let filterCurrentEvent = events.filter(
        (obj) => obj.programStage == currentStage.id
      );
      //debugger;
      if (promises.length == 0) {
        if (filterCurrentEvent.length > 0 && newServiceStartFlag == false) {
          if (
            currentStage.attributeValues &&
            currentStage.attributeValues.length > 0 &&
            currentStage.attributeValues[0].attribute.name == "Assign Task"
          ) {
            saveStage(
              fieldValueWithAttribute,
              values,
              currentStage,
              stageIndex,
              fetchActiveTab
            );
          } else {
            const eventId = editEventsId
              ? editEventsId
              : filterCurrentEvent[filterCurrentEvent.length - 1].event;
            if (filterCurrentEvent.length == 1) {
              updateStage(
                fieldValueWithAttribute,
                values,
                currentStage,
                stageIndex,
                eventId,
                fetchActiveTab,
                filterCurrentEvent[0].status
              );
            }

            if (filterCurrentEvent.length > 1) {
              const scheduledEvent = filterCurrentEvent.filter(
                (obj) => obj.status == "SCHEDULE"
              );
              if (scheduledEvent.length > 0) {
                const eventId = editEventsId
                  ? editEventsId
                  : scheduledEvent[scheduledEvent.length - 1].event;
                updateStage(
                  fieldValueWithAttribute,
                  values,
                  currentStage,
                  stageIndex,
                  eventId,
                  fetchActiveTab,
                  "SCHEDULE"
                );
              }
              if (scheduledEvent.length == 0) {
                filterCurrentEvent = _.sortBy(filterCurrentEvent, "created");
                const eventId = editEventsId ? editEventsId
                : filterCurrentEvent[filterCurrentEvent.length - 1].event;
                updateStage(
                  fieldValueWithAttribute,
                  values,
                  currentStage,
                  stageIndex,
                  eventId,
                  fetchActiveTab,
                  null
                );
              }
            }
          }
        } else {
          saveStage(
            fieldValueWithAttribute,
            values,
            currentStage,
            stageIndex,
            fetchActiveTab
          );
        }
      } else {
        Promise.all(promises).then((responses) => {
          responses.map((imageData) => {
            fieldValueWithAttribute.push(imageData);
          });

          if (filterCurrentEvent.length > 0 && newServiceStartFlag == false) {
            if (
              currentStage.attributeValues &&
              currentStage.attributeValues.length > 0 &&
              currentStage.attributeValues[0].attribute.name == "Assign Task"
            ) {
              saveStage(
                fieldValueWithAttribute,
                values,
                currentStage,
                stageIndex,
                fetchActiveTab
              );
            } else {
              const eventId = editEventsId
                ? editEventsId
                : filterCurrentEvent[filterCurrentEvent.length - 1].event;
              if (filterCurrentEvent.length == 1) {
                updateStage(
                  fieldValueWithAttribute,
                  values,
                  currentStage,
                  stageIndex,
                  eventId,
                  fetchActiveTab,
                  filterCurrentEvent[0].status
                );
              }

              if (filterCurrentEvent.length > 1) {
                const scheduledEvent = filterCurrentEvent.filter(
                  (obj) => obj.status == "SCHEDULE"
                );
                if (scheduledEvent.length > 0) {
                  const eventId = editEventsId
                    ? editEventsId
                    : scheduledEvent[scheduledEvent.length - 1].event;
                  updateStage(
                    fieldValueWithAttribute,
                    values,
                    currentStage,
                    stageIndex,
                    eventId,
                    fetchActiveTab,
                    "SCHEDULE"
                  );
                }
                if (scheduledEvent.length == 0) {
                  filterCurrentEvent = _.sortBy(filterCurrentEvent, "created");
                  const eventId = editEventsId ? editEventsId
                  : filterCurrentEvent[filterCurrentEvent.length - 1].event;
                  updateStage(
                    fieldValueWithAttribute,
                    values,
                    currentStage,
                    stageIndex,
                    eventId,
                    fetchActiveTab,
                    null
                  );
                }
              }
            }
          } else {
            saveStage(
              fieldValueWithAttribute,
              values,
              currentStage,
              stageIndex,
              fetchActiveTab
            );
          }
        });
      }

      /*}else{
            //offline
            //activeCaseDetails.data.trackedEntityInstance
            OfflineDb.getDataFromPouchDB('activeCaseDetails').then(activeCaseDetails=>{
                OfflineDb.updateEntity(activeCaseDetails.data.trackedEntityInstance,values).then(res=>{
                    
                })
            })
            OfflineDb.getSingleEntity(activeCaseDetails.data.trackedEntityInstance).then(res=>{
                
            })
            
        }*/
    }

    const checkNewServiceVisibility = (currentStage) => {
      return (
        Configuration.hidenewservicebutton[currentStage.displayName] ||
        Configuration.hidenewservicebutton[currentStage.description]
      );
    };

    const checkAccordianVisibility = (currentStage) => {
      return Configuration.hideformhistoryaccordian[currentStage.displayName];
    };


    let ageGender = initialValues
      ? initialValues[genderUID]
        ? " (" + t(initialValues[genderUID]) + ")"
        : ""
      : "";

    const renderCellValues = (currentStage) => {
      return currentStage.programStageDataElements.map((stages) => {
        if (stages.dataElement.valueType == "BOOLEAN") {
          if (
            dataElementGroup.filter(
              (obj) => obj.displayName == stages.dataElement.displayName
            ).length > 0
          ) {
            //return <TableCell>{stages.dataElement.displayName.includes('_') ? stages.dataElement.displayName.split('_')[1] : stages.dataElement.displayName}</TableCell>
            return (
              <TableCell>
                {getTranslatedDataElementLabels(stages.dataElement)}
              </TableCell>
            );
          }
        } else {
          //return <TableCell>{stages.dataElement.displayName.includes('_') ? stages.dataElement.displayName.split('_')[1] : stages.dataElement.displayName}</TableCell>
          return (
            <TableCell>
              {getTranslatedDataElementLabels(stages.dataElement)}
            </TableCell>
          );
        }
      });
    };
    const renderCellDataValues = (currentStage) => {
      //console.log("currentStage0 ",currentStage.displayName);
      let allEvents = trackentityInstanceDetails && trackentityInstanceDetails.enrollments && trackentityInstanceDetails.enrollments.length > 0 ? trackentityInstanceDetails.enrollments[0].events : []
      if(!navigator.onLine){
        allEvents = multiServicesOfflineData
      }
      return (
        allEvents.map((events, i) => {
          if (
            currentStage.id == events.programStage &&
            events.status != "SCHEDULE"
          ) {
            return (
              <TableRow key={events.event + i}>
                {currentStage.programStageDataElements.map((stages) => {
                  if (stages.dataElement.valueType == "BOOLEAN") {
                    if (
                      dataElementGroup.filter(
                        (obj) =>
                          obj.displayName == stages.dataElement.displayName
                      ).length > 0
                    ) {
                      const filterDataElementGroup = dataElementGroup.filter(
                        (obj) =>
                          obj.displayName == stages.dataElement.displayName
                      )[0];
                      let selectedValues = "";
                      filterDataElementGroup.dataElements.map((elements) => {
                        let filterFieldData = events.dataValues.filter(
                          (obj) => elements.id == obj.dataElement
                        );
                        if (
                          filterFieldData.length > 0 &&
                          filterFieldData[0].value == "true"
                        ) {
                          selectedValues +=
                            (elements.displayName.includes("_")
                              ? elements.displayName.split("_")[1]
                              : elements.displayName) + " ,";
                        }
                      });
                      selectedValues = selectedValues.slice(0, -1);
                      return <TableCell>{selectedValues}</TableCell>;
                    }
                  } else if (
                    stages.dataElement.valueType == "IMAGE" ||
                    stages.dataElement.valueType == "FILE_RESOURCE"
                  ) {
                    let filterFieldData = events.dataValues.filter(
                      (obj) => stages.dataElement.id == obj.dataElement
                    );
                    if (filterFieldData.length > 0) {
                      return (
                        <TableCell>
                          <IconButton
                            onClick={(e) => {
                              setimageDataUrl(
                                events.event,
                                stages.dataElement.id
                              );
                            }}
                          >
                            <Image />
                          </IconButton>
                        </TableCell>
                      );
                    } else return <TableCell>{t("N/A")}</TableCell>;
                  } else {
                    let filterFieldData = events.dataValues.filter(
                      (obj) => stages.dataElement.id == obj.dataElement
                    );
                    let selectedValues = ""; //filterFieldData.length > 0 ? filterFieldData[0].value : ""
                    try {
                      if (
                        filterFieldData.length > 0 &&
                        stages.dataElement.valueType == "DATE"
                      ) {
                        //IF VALUE OF DATAELEMENT IS DATE
                        selectedValues = moment(
                          filterFieldData[0].value
                        ).format("YYYY-MM-DD");
                      } else if (
                        filterFieldData.length > 0 &&
                        stages.dataElement.valueType == "ORGANISATION_UNIT"
                      ) {
                        let orgobj =
                          programData.programs[0].organisationUnits.find(
                            (o) => o.id == filterFieldData[0].value
                          );
                        if (orgobj) {
                          selectedValues = orgobj.displayName;
                        }
                      } else if (
                        filterFieldData.length > 0 &&
                        stages.dataElement.fieldMask == "Facility Referral"
                      ) {
                        let stageNme =
                          programData.programs[0].programStages.find(
                            (o) => o.id == filterFieldData[0].value
                          );
                        if (stageNme) {
                          selectedValues = stageNme.displayName;
                        }
                      } else if (filterFieldData.length > 0) {
                        selectedValues = filterFieldData[0].value;
                      }
                    } catch (e) {
                      console.log(e);
                    }
                    if (selectedValues) {
                      return <TableCell>{selectedValues}</TableCell>;
                    } else return <TableCell>{t("N/A")}</TableCell>;
                  }
                })}
                <TableCell>
                  <IconButton
                    onClick={(e) => {
                      loadActiveCaseFormData(events,i);
                    }}
                  >
                    <EditIcon />
                  </IconButton>
                </TableCell>
                {/* {
                    userrolename && userrolename.toLowerCase() == superAdmin ?
                    <TableCell>
                        <IconButton onClick={e => {
                            removeFromTable(events)
                        }}>
                            <DeleteIcon />
                        </IconButton>
                    </TableCell>
                    :
                    <></>
                } */}
              </TableRow>
            );
          }
          // return (getEntityData(events,i))
        })
      );
    };
    const editMultiServiceData = (index) => {
        //setEditMultiServiceId(index)
        try{
            let temparr = _.cloneDeep(multiServicesOfflineData)
            //console.log(temparr[index])
            let updatedFormData = temparr[index]
            console.log("updatedFormData",updatedFormData);
            let filterData = {}
            updatedFormData.dataValues.map(ele => {
                filterData[ele.dataElement] = ele.value
            })
            const activeCaseFormData1 = {
                data: {
                    'formFormat': {...activeCaseFormData.data.formFormat, ...filterData}, //valueForFormInput,
                    'dhisFormat': null //
                }
            }
            let tempobj = _.cloneDeep(activeCaseFormData1)
            setActiveCaseFormData(tempobj)
             document.getElementsByClassName("innertabdivreg")[0].scrollTo({
                top: 0,
                behavior: "smooth",
            });
        }catch(e){
        }
    }
    const loadActiveCaseFormData = (event,eventIndex) => {
        setAddNewServiceFlag(false);
        if(!navigator.onLine){
            editMultiServiceData(eventIndex)
            return;
        }
      setEditEventsId(event.event);
      let InitialValueData = {};
      let promises = [];
      const DataElementGroup = dataElementGroup;
      const stageList = programData.programs[0].programStages;
      let registrationData = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.attributes;
      let stageData1 = _.isEmpty(trackentityInstanceDetails)
        ? []
        : trackentityInstanceDetails.enrollments[0].events;
      let stageData = [];
      let ObjecteHolder = {};

      if (stageList != null) {
        stageList.map((stages) => {
          const filterEvent = stageData1.filter(
            (obj) => obj.programStage == stages.id
          );
          if (filterEvent.length > 1) {
            stageData.push(filterEvent[filterEvent.length - 1]);
          } else if (filterEvent.length == 1) {
            stageData.push(filterEvent[0]);
          }
          // set stage id regimen
          if (stages.attributeValues && stages.attributeValues.length > 0) {
            stages.attributeValues.map((val) => {
              if (
                val.attribute.displayName === "Regimen" &&
                val.value == "true"
              ) {
                if (!_.isEmpty(stageData1)) {
                  getMedicinesListFromEvents(stages);
                } else {
                  setMedicineTable([]);
                }
              } else if (val.attribute.displayName === "showFullCalender") {
                //handleMedicineRadioChange(event,value,name)
                let sortedEvents = _.filter(stageData1, {
                  programStage: stages.id,
                });
                if (sortedEvents.length > 0) {
                  //const grouped = _.groupBy(sortedEvents, { dataValues: ['value']});
                  //console.log("grouped",grouped,dateMedicineTakenId)
                  let finalEvents = _.filter(sortedEvents, {
                    dataValues: [{ dataElement: dateMedicineTakenId }],
                  });
                  //console.log("grouped",finalEvents,dateMedicineTakenId)
                  let events = [];
                  finalEvents.map((event) => {
                    let mediDateObj = _.filter(event.dataValues, {
                      dataElement: dateMedicineTakenId,
                    });
                    let mediColorCodeObj = _.filter(event.dataValues, {
                      dataElement: medicineColorCodeId,
                    });
                    if (mediDateObj.length > 0 && mediColorCodeObj.length > 0) {
                      let obj = {};
                      obj["start"] = mediDateObj[0].value;
                      obj["end"] = mediDateObj[0].value;
                      obj["allDay"] = true;
                      obj["backgroundColor"] = mediColorCodeObj[0].value;
                      obj["display"] = "background";
                      obj["overlap"] = false;
                      obj["editmode"] = true;
                      events.push(obj);
                    }
                  });
                  events = _.uniqBy(events, "start");
                  setFullCalendarEvents(events);
                  //console.log("groupedevents",events)
                }
              } else if (
                val.attribute.displayName === "SpecimenTable" &&
                val.value == "true"
              ) {
                if (!_.isEmpty(stageData1)) {
                  // console.log('getdatasputuntable>>>', stages, stageData1, trackentityInstanceDetails)
                  getSputumTableDetail(stages);
                }
              }
            });
          }
        });
      }

      registrationData.map((fields) => {
        const filterField =
          programData.programs[0].programTrackedEntityAttributes.find(
            (obj) => obj.trackedEntityAttribute.id == fields.attribute
          );

        InitialValueData[fields.attribute] = fields.value;

        if (
          filterField &&
          filterField.trackedEntityAttribute &&
          (filterField.trackedEntityAttribute.valueType == "IMAGE" ||
            filterField.trackedEntityAttribute.valueType == "FILE_RESOURCE")
        ) {
          if (fields.value) {
            const resourceGetApi = "fileResources/" + fields.value;
            promises.push(
              apiServices.getAPI(resourceGetApi).then((resources) => {
                return { dataElement: fields.attribute, value: resources.data };
              })
            );
          }
        }

        // multicheckbox edit logic
        programData.programs[0].programSections.map((programSection) => {
          if (programSection.renderType["DESKTOP"].type == "SEQUENTIAL") {
            programSection.trackedEntityAttributes.map((elements) => {
              if (
                programSection.trackedEntityAttributes.find(
                  (array) => array.id == fields.attribute
                )
              ) {
                if (InitialValueData[programSection.id] == undefined) {
                  InitialValueData[programSection.id] = [fields.attribute];
                } else {
                  if (
                    !InitialValueData[programSection.id].includes(
                      fields.attribute
                    )
                  ) {
                    InitialValueData[programSection.id].push(fields.attribute);
                  }
                }
              }
            });
          }
        });
      });

      stageData.map((events) => {
        let dataValue = [];
        if (events.programStage == event.programStage)
          dataValue = event.dataValues;
        else dataValue = events.dataValues;
        dataValue.map((fields) => {
          if (stageList != null) {
            stageList.map((stages) => {
              const filter = stages.programStageDataElements.filter(
                (obj) => obj.dataElement.id == fields.dataElement
              );

              if (filter.length > 0) {
                if (filter[0].dataElement.fieldMask == "Facility Referral") {
                  try {
                    InitialValueData[fields.dataElement] =
                      fields.value.split(",");
                  } catch (e) {
                    console.log(e);
                  }
                } else if (
                  filter[0].dataElement.valueType == "IMAGE" ||
                  filter[0].dataElement.valueType == "FILE_RESOURCE"
                ) {
                  if (fields.value) {
                    const resourceGetApi = "fileResources/" + fields.value;
                    ObjecteHolder[fields.dataElement] = fields.value;
                    promises.push(
                      apiServices.getAPI(resourceGetApi).then((resources) => {
                        return {
                          dataElement: fields.dataElement,
                          value: resources.data,
                        };
                      })
                    );
                  }
                } else {
                  DataElementGroup.map((DEG) => {
                    DEG.dataElements.map((dataElements) => {
                      if (
                        DEG.dataElements.find(
                          (array) =>
                            array.id == fields.dataElement &&
                            fields.value == "true"
                        )
                      ) {
                        if (InitialValueData[DEG.id] == undefined) {
                          InitialValueData[DEG.id] = [fields.dataElement];
                        } else {
                          if (
                            !InitialValueData[DEG.id].includes(
                              fields.dataElement
                            )
                          ) {
                            InitialValueData[DEG.id].push(fields.dataElement);
                          }
                        }
                      }
                    });
                  });
                  InitialValueData[fields.dataElement] =
                    fields.value == "false"
                      ? false
                      : fields.value == "true"
                      ? true
                      : fields.value;
                }
              }
            });
          }

          // InitialValueData[fields.dataElement] = fields.value
        });
      });

      setStageImageValue(ObjecteHolder);
      if (promises.length == 0) {
        const activeCaseFormData = {
          data: {
            formFormat: InitialValueData, //valueForFormInput,
            dhisFormat: null, //
          },
        };

        OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData);
        setActiveCaseFormData(activeCaseFormData);
      } else {
        Promise.all(promises).then((responses) => {
          responses.map((response) => {
            InitialValueData[response.dataElement] = [
              new File([""], response.value.displayName, {
                size: response.value.contentLength,
                type: response.value.contentType,
                webkitRelativePath: "",
              }),
            ];
          });
          const activeCaseFormData = {
            data: {
              formFormat: InitialValueData, //valueForFormInput,
              dhisFormat: null, //
            },
          };

          OfflineDb.setDataIntoPouchDB(
            "activeCaseFormData",
            activeCaseFormData
          );
          setActiveCaseFormData(activeCaseFormData);
        });
      }
    };

    const setimageDataUrl = (eventid, dataelementid) => {
      apiServices
        .getBlobAPI(
          "events/files?eventUid=" +
            eventid +
            "&dataElementUid=" +
            dataelementid
        )
        .then((res) => {
          console.log(res);
          var blob = new Blob([res.data]);
          const imageObjectURL = URL.createObjectURL(blob);
          setImageResponse(imageObjectURL);
        });
    };

    return (
      <Form
        onSubmit={onStageSubmit}
        initialValues={initialValues}
        // initialValues={newItem} //
        render={({ handleSubmit, form, submitting, pristine, values }) => (
          <form
            className="fullWidth"
            onSubmit={handleSubmit}
            encrypt="multipart/form-data"
          >
            <div className="nameuicinfoholder">
              <Grid container spacing={0} xs={12} lg={12}>
                <Grid container spacing={0} xs={6} lg={3}>
                  <Grid item>
                    <span className="fl-left">{t("Name")}</span>:{" "}
                    {initialValues
                      ? initialValues[patientNameId]
                        ? initialValues[patientNameId] : userData && userData.firstName 
                        ? userData.firstName
                         : t("N/A") : ""}
                  </Grid>
                </Grid>
                <Grid container spacing={0} xs={6} lg={3}>
                  <Grid item>
                    <span className="fl-left">{t("Age")}</span>:{" "}
                    {initialValues
                      ? initialValues[ageUID]
                        ? initialValues[ageUID] + ageGender
                        : t("N/A")
                      : ""}
                  </Grid>
                </Grid>
                <Grid container spacing={0} xs={6} lg={3}>
                  <Grid item>
                    <span className="fl-left">{t("UIC")}</span>:{" "}
                    {initialValues
                      ? initialValues[uicId]
                        ? initialValues[uicId]
                        : t("N/A")
                      : ""}
                  </Grid>
                </Grid>
                {/* <Grid container spacing={0} xs={6} lg={3}>
                                <Grid item>
                                <span className='fl-left'>{t("Client Type")}</span>: {initialValues ? initialValues[clientTypeID] ? t(initialValues[clientTypeID]) : t("N/A") : ''}
                                </Grid>
                            </Grid> */}
              </Grid>
            </div>
            <div className="innertabdivreg subclass6 pt-0">
              <>
                {" "}
                {dataElementGroup.map((DataElementGroup) => {
                  if (values != undefined) {
                    if (values[DataElementGroup.id] != undefined) {
                      DataElementGroup.dataElements.map((elements) => {
                        // delete values[elements.id]
                        //if(values[elements.id] != undefined)
                        values[elements.id] = false;
                      });
                      if (
                        values[DataElementGroup.id].length > 0 &&
                        Array.isArray(values[DataElementGroup.id])
                      ) {
                        values[DataElementGroup.id].map((value) => {
                          values[value] = true;
                        });
                      }
                    }
                  }
                })}{" "}
              </>

              <Grid container spacing={3} className="calender-theme">
                <Grid container className="custom-block">
                  {stage.attributeValues && stage.attributeValues.length > 0
                    ? stage.attributeValues.map((val) => {
                        if (
                          val.attribute.displayName === "showFullCalender" &&
                          fullCalendarEvents != null
                        ) {
                          return renderFullCalender(
                            stage,
                            stage.programStageDataElements
                          );
                        }
                        if (val.attribute.displayName === "Task List") {
                          return (
                            <TaskList
                              programData={programData}
                              stagedetails={stage}
                              userdetails={userData}
                              trackentityInstanceDetails={
                                trackentityInstanceDetails
                              }
                            />
                          );
                        }
                        if (
                          val.attribute.displayName === "Regimen" &&
                          val.value == "true"
                        ) {
                          setregimenStageId(stage.id);
                        }
                      })
                    : null}
                </Grid>

                {stage.programStageSections &&
                stage.programStageSections.length > 0
                  ? renderStageBySection(
                      stage,
                      values ? values : {},
                      form,
                      stage.programStageDataElements
                    )
                  : //console.log('renderSection')
                    stage.programStageDataElements.map((fields) => {
                      return renderStageField(
                        fields,
                        values ? values : {},
                        form,
                        stage.programStageDataElements,
                        stage
                      );
                    })}
              </Grid>
              {/* code for Regimen custom module */}

              {stage.attributeValues &&
              stage.attributeValues.length > 0 &&
              radioValue
                ? stage.attributeValues.map((val) => {
                    if (
                      val.attribute.displayName === "Regimen" &&
                      val.value == "true"
                    ) {
                      return (
                        <Grid
                          container
                          spacing={3}
                          style={{ marginTop: "10px" }}
                        >
                          {setRegimenStageDEIds(stage)}
                          <div className="addbuttonholder">
                            <button
                              className="regformsubmitbtn"
                              type="button"
                              onClick={() => addRegimen(stage, values)}
                            >
                              {t("Add")}
                            </button>
                          </div>

                          <TableContainer
                            component={Paper}
                            className="ml-10px mr-10px mb-20px"
                          >
                            <Table
                              className={classes.table}
                              aria-label="simple table"
                            >
                              <TableHead>
                                <TableRow>
                                  <TableCell>Treatment regimen</TableCell>
                                  <TableCell align="right">
                                    Medicine Name
                                  </TableCell>
                                  <TableCell align="right">
                                    Start date
                                  </TableCell>
                                  <TableCell align="right">End date</TableCell>
                                  <TableCell align="right">Dosage</TableCell>
                                </TableRow>
                              </TableHead>
                              <TableBody>
                                {medicineTable.map((row, index) => {
                                  return (
                                    <TableRow
                                      key={row[treatmentRegimenId] + index}
                                    >
                                      <TableCell component="th" scope="row">
                                        {row[treatmentRegimenId]}
                                      </TableCell>
                                      <TableCell align="right">
                                        {row.medicine.displayName}
                                      </TableCell>
                                      <TableCell align="right">
                                        {row[treatmentStartDateId]}
                                      </TableCell>
                                      <TableCell align="right">
                                        {row[treatmentEndDateId]}
                                      </TableCell>
                                      <TableCell align="right">
                                        {row[treatmentDoseId]}
                                      </TableCell>
                                    </TableRow>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Grid>
                      );
                    }
                    // else if (val.attribute.displayName === "showFullCalender" && radioValue && medicineTable) {

                    //     return stage && stage.id == adherenceTBStageId ? <Grid container spacing={3} style={{ marginTop: '10px', marginBottom: '10px' }}>
                    //         {medicineTable.map(med => {
                    //             return <Grid container spacing={3} className="ml-10px mr-10px mt-10px mb-10px bg-lightgrey" component={Paper}>
                    //                 <Grid item xs={6} lg={4} className={localStorage.getItem('fontSize') ? "align-items-center FS"+localStorage.getItem('fontSize') : 'align-items-center'}>
                    //                     <span>{med.medicine.displayName}</span>{/*JSON.stringify(med)*/}
                    //                 </Grid>
                    //                 <Grid item xs={6} lg={2} className={localStorage.getItem('fontSize') ? "formradioholder FS"+localStorage.getItem('fontSize') : 'formradioholder'}>
                    //                     {/* <Formradio></Formradio> */}

                    //                     <FormControl component="fieldset">
                    //                         <RadioGroup aria-label="gender" name={med.medicine.code} value={radioValue[med.medicine.code] ? radioValue[med.medicine.code] : 'yes'} onChange={(env) => handleMedicineRadioChange(env, value, med.medicine.code)}>
                    //                             <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                    //                             <FormControlLabel value="no" control={<Radio />} label="No" />
                    //                         </RadioGroup>
                    //                     </FormControl>
                    //                 </Grid>

                    //             </Grid>
                    //         })}
                    //     </Grid>
                    //     :
                    //     // medicineTakenBO && medicineTakenoptions ?
                    //     // <FormControl component="fieldset">
                    //     //         <div>&nbsp;</div>
                    //     //         <label class="MuiFormLabel-root">{getTranslatedDataElementLabels(medicineTakenBO)}</label>
                    //     //         <RadioGroup
                    //     //         aria-label="gender"
                    //     //         name="select-form"
                    //     //         value={radioValue && !_.isEmpty(radioValue) ? radioValue : 'yes'}
                    //     //         //onChange={handleMedicineRadioChange}
                    //     //         onChange={(env) => handleMedicineRadioChange(env, value)}
                    //     //         >
                    //     //         {medicineTakenoptions.map(
                    //     //             (opt, index) => {
                    //     //             return (
                    //     //                 <FormControlLabel
                    //     //                 //disabled={disabledVal}
                    //     //                 style={{ textAlign: "left" }}
                    //     //                 value={(opt.code).toLowerCase()}
                    //     //                 control={<Radio />}
                    //     //                 label={getTranslatedDataElementLabels(opt)}
                    //     //                 />
                    //     //             );
                    //     //             }
                    //     //         )}
                    //     //         </RadioGroup>
                    //     //     </FormControl>
                    //     //     :
                    //     <></>

                    // }
                    else if (
                      val.attribute.displayName === "SpecimenTable" &&
                      val.value == "true"
                    ) {
                      return (
                        <Grid
                          container
                          spacing={0}
                          style={{ marginTop: "10px" }}
                        >
                          <Grid item xs={12} md={12}>
                            <div className="addbuttonholder">
                              <button
                                className="regformsubmitbtn"
                                type="button"
                                onClick={() => addSpecimen(stage, values)}
                              >
                                {t("Add")}
                              </button>
                            </div>
                          </Grid>
                          {/* <Grid item xs={12} md={12}> */}
                          <Grid
                            container
                            spacing={3}
                            style={{ marginTop: "10px" }}
                          >
                            <TableContainer
                              component={Paper}
                              className="ml-10px mr-10px mb-20px sputumtable"
                            >
                              <Table
                                className={classes.table}
                                aria-label="simple table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Specimen ID</TableCell>
                                    <TableCell align="right">
                                      Date of sample collection
                                    </TableCell>
                                    <TableCell align="right">
                                      Specimen type
                                    </TableCell>
                                    <TableCell align="right">
                                      Collection Interval
                                    </TableCell>
                                    <TableCell align="right">QR Code</TableCell>
                                    <TableCell align="right">Remove</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {sputumTable.map((row, index) => {
                                    return (
                                      <TableRow key={row[specimenid] + index}>
                                        <TableCell component="th" scope="row">
                                          {row[specimenid]}
                                        </TableCell>
                                        <TableCell align="right">
                                          {moment(
                                            row[dateOfSampleCollection]
                                          ).format("MM/DD/YYYY")}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row[specimenType]}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row[noOfSputumCollected]}
                                        </TableCell>
                                        <TableCell align="right">
                                          {row[sputumQRCode] ? (
                                            <AttachFileIcon />
                                          ) : null}
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          onClick={() =>
                                            removeFromTable(sputumTable, index)
                                          }
                                        >
                                          {row["action"] ? null : (
                                            <DeleteIcon />
                                          )}
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Grid>
                        </Grid>
                      );
                    } else if(val.attribute.displayName === "ShowSummaryTab" &&
                    val.value == "true") {
                      return createSummaryPage();
                    }
                  })
                : null}


              <div className="buttons" style={{ paddingBottom: "10px" }}>
                {programData.programs[0].programStages != null && !workFlow ? (currentStage.id == summaryStageId) ? "" : (
                  <button
                    className={
                      `regformsubmitbtn newservicebtn1 ` +
                      (checkNewServiceStatus(currentStage)
                        ? checkNewServiceVisibility(currentStage)
                          ? "hide"
                          : ""
                        : "hide")
                    }
                    style={{ float: "left" }}
                    type="button"
                    onClick={() => starttoNewService(currentStage)}
                  >
                    {/* <AddIcon></AddIcon> */}
                    {t("New Visit")}
                  </button>
                )  : (
                  ""
                )}
                
                {programData.programs[0].programStages != null && !workFlow ? (currentStage.id == summaryStageId) ? (<Button 
                        className="modalactionbtn"
                        style={{ float: "right", right: "35px" }}
                        onClick={() => {
                          localStorage.setItem("form", document.getElementById('form'));
                          downloadSurveyPDF()}} >
                          Download Summary
                      </Button>) : (
                        <button
                          className="regformsubmitbtn"
                          type="submit"
                          disabled={submitting}
                          style={{ float: "right" }}
                        >
                          {/* {value == props.stageList.length ? 'Submit' : 'Next'} */}
                          {t("Submit")}
                        </button>
                    )  : (
                      ""
                    )}

                {/* {programData.programs[0].programStages != null && workFlow ?
                                <button
                                    className={`regformsubmitbtn ` + (getMultiserviceArray() ? '' : 'hide')}
                                    style={{ float: 'right' }}
                                    type="button"
                                    onClick={() => gotoNewService()}
                                >{t('New Service')}
                                </button>
                                : ""

                            } */}
                {/* new service for individual stage  */}

                {/* <button
                                    className="regformresetbtn hide"
                                    type="button"
                                    //onClick={() => this.resetForm(form, values)}
                                    disabled={submitting || pristine}
                                >
                                    Reset
                              </button> */}
              </div>
              {
              //navigator.onLine &&
              currentStage &&
              currentStage.attributeValues &&
              currentStage.attributeValues.length > 0
                ? currentStage.attributeValues.map((attr) => {
                    if (
                      attr.attribute.displayName == "ShowServiceTab" &&
                      attr.value && ((navigator.onLine && checkNewServiceStatus(currentStage)) || (!navigator.onLine && multiServicesOfflineData.length > 0))
                    ) {
                        let allEvents = trackentityInstanceDetails
                        if(!navigator.onLine){
                            allEvents = multiServicesOfflineData
                        }
                        setEventsData(allEvents);
                      return (
                        <>
                          <RecordHistory
                            programData={programData}
                            currentStage={currentStage}
                            trackentityInstanceDetails={
                                allEvents //trackentityInstanceDetails
                            }
                          />
                          {/* <TableContainer component={Paper} className={`ml-10px mr-10px mb-20px ShowServiceTab-tabel ` + (checkNewServiceStatus(currentStage) ? checkNewServiceVisibility(currentStage) ? 'hide' : '': 'hide')}>
                                                <Table className={classes.table} aria-label="simple table">
                                                    <TableHead>
                                                        <TableRow>
                                                            {renderCellValues(currentStage)}
                                                            <TableCell>{t("Edit")}</TableCell>
														</TableRow>
                                                    </TableHead>
                                                    <TableBody>
                                                        {renderCellDataValues(currentStage)}
                                                    </TableBody>
                                                </Table>
                                            </TableContainer> */}
                          {/* <SeeIndividualRecordAccordian currentStage={currentStage}/> */}
                        </>
                      );
                      // return <SeeIndividualRecordAccordian currentStage={currentStage}/>
                    }
                  })
                : null}
              {/* <pre>{JSON.stringify(values, 0, 2)}</pre> */}
            </div>
          </form>
        )}
      />
    );
  }

  function postSearchSubmit() {
    if (searchEnabled) {
      /*const activeCaseFormData = {
            'formFormat': null, //valueForFormInput, { ["dddXq4Ddh6Z"]: Configuration.ltbiLinkVariables.presumptivetb }
            'dhisFormat': null //
        }
        OfflineDb.setDataIntoPouchDB('activeCaseFormData', activeCaseFormData)*/
      /*setActiveCaseDetails({
            'data': {}
        })*/
      /*const activeCaseDetails = {
        }
        OfflineDb.setDataIntoPouchDB('activeCaseDetails', activeCaseDetails)*/
      setSearchResponse(null);
      setValue(1);
    } else {
      const orgUnit = userData.organisationUnits[0].id;
      const trackedEntityType = programData.programs[0].trackedEntityType.id;
      let registrationFields =
        programData.programs[0].programTrackedEntityAttributes;
      let valuesToSave = formValuePostDeDup.valuesToSave;
      let valueForFormInput = formValuePostDeDup.valueForFormInput;
      let saveCaseInput = {
        trackedEntityType: trackedEntityType,
        orgUnit: orgUnit,
        attributes: valuesToSave,
        enrollments: [
          {
            //"trackedEntityInstance": trackedEntityInstance,
            program: programData.programs[0].id,
            //"status": "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          },
        ],
        geometry: {
          type: "Point",
          coordinates: [currentGeolocation.lng, currentGeolocation.lat],
        },
      };
      setGlobalSpinner(true);
      apiServices
        .postAPI("trackedEntityInstances", saveCaseInput)
        .then((response) => {
          const trackedEntityInstance =
            response.data.response.importSummaries[0].reference;
          const programId = programData.programs[0].id;
          const enrollmentInputJson = {
            trackedEntityInstance: trackedEntityInstance,
            program: programId,
            status: "ACTIVE",
            orgUnit: orgUnit,
            enrollmentDate: moment().format("YYYY-MM-DD"),
            incidentDate: moment().format("YYYY-MM-DD"),
          };
          setGlobalSpinner(false);
          //apiServices.postAPI('enrollments', enrollmentInputJson)
          //.then(enrollmentResponse => {
          const enroll = ""; //enrollmentResponse.data.response.importSummaries[0].reference
          if (
            programData.programs[0].useFirstStageDuringRegistration == false &&
            relationShipId != "" &&
            Configuration.registrationForm.linkContactInAlert
          ) {
            swal({
              title: t("Individual Registered"),
              text: t("Do you want to initiate the individual registration?"),
              icon: "success",
              buttons: [t("No"), t("Yes")],
            }).then((AlertRes) => {
              if (AlertRes) {
                //save data
                const activeCaseDetails = {
                  trackedEntityInstance: trackedEntityInstance,
                  enrollmentId: enroll,
                };
                const linkContact = {
                  enabled: true,
                  linkTrackedEntityInstance: trackedEntityInstance,
                };
                const activeCaseFormData = {
                  formFormat: null, //valueForFormInput,
                  dhisFormat: null, //
                };
                // setActiveCaseDetails({
                //     'data': {

                //         'trackedEntityInstance': trackedEntityInstance,
                //         'enrollmentId': enroll,

                //     }
                // })

                OfflineDb.setDataIntoPouchDB(
                  "activeCaseDetails",
                  activeCaseDetails
                );
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                setActiveCaseFormData({
                  data: {
                    formFormat: null, //valueForFormInput,
                    dhisFormat: null, //
                  },
                });
                setValue(0);

                //empty form
              } else {
                //save data
                const activeCaseDetails = {
                  trackedEntityInstance: trackedEntityInstance,
                  enrollmentId: enroll,
                };
                // setActiveCaseDetails({
                //     'data': {

                //         'trackedEntityInstance': trackedEntityInstance,
                //         'enrollmentId': enroll,

                //     }
                // })
                const activeCaseFormData = {
                  formFormat: valueForFormInput,
                  dhisFormat: valuesToSave,
                };
                const linkContact = {
                  enabled: false,
                  linkTrackedEntityInstance: trackedEntityInstance,
                };
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseDetails",
                  activeCaseDetails
                );
                OfflineDb.setDataIntoPouchDB(
                  "activeCaseFormData",
                  activeCaseFormData
                );
                OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);

                //load next active tabs
                const nextTab = activeTabs[0];
                if (nextTab) {
                  const indexOfNextTab =
                    programData.programs[0].programStages.findIndex(
                      (obj) => obj.id == nextTab
                    );
                  setValue(indexOfNextTab + stepIncrement);
                } else {
                  setValue(value);
                }
              }
            });
          } else {
            const activeCaseDetails = {
              trackedEntityInstance: trackedEntityInstance,
              enrollmentId: enroll,
            };
            setActiveCaseDetails({
              data: {
                trackedEntityInstance: trackedEntityInstance,
                enrollmentId: enroll,
              },
            });
            const activeCaseFormData = {
              formFormat: valueForFormInput,
              dhisFormat: valuesToSave,
            };
            const linkContact = {
              enabled: false,
              linkTrackedEntityInstance: trackedEntityInstance,
            };
            OfflineDb.setDataIntoPouchDB(
              "activeCaseDetails",
              activeCaseDetails
            );
            OfflineDb.setDataIntoPouchDB(
              "activeCaseFormData",
              activeCaseFormData
            );
            OfflineDb.setDataIntoPouchDB("linkContactFlag", linkContact);
            swal({
              title: t("Success"),
              text: t("Individual Registered"),
              icon: "success",
              button: t("Close"),
            });
            //save data

            //laod next active tab
            const nextTab = activeTabs[0];
            if (nextTab) {
              const indexOfNextTab =
                programData.programs[0].programStages.findIndex(
                  (obj) => obj.id == nextTab
                );
              setValue(indexOfNextTab + stepIncrement);
            } else {
              setValue(value);
            }
          }
          //})
          setGlobalSpinner(false);
        })
        .catch((err) => {
          swal({
            title: t("Error"),
            text: "",
            icon: "error",
            button: t("Close"),
          });
          setGlobalSpinner(false);
        });

      setSearchHeader(null);
      setSearchResponse(null);
    }
  }

  function processImage(imgeUrl) {
    let InitialValueData = {};
    let subscriptionKey = "a53cd4ec9db94138a74c6e4730dfa9e4"; // a53cd4ec9db94138a74c6e4730dfa9e4
    let endpoint = "https://duretech.cognitiveservices.azure.com"; // https://duretech.cognitiveservices.azure.com/
    let uriBase = endpoint + "/vision/v3.1/read/analyze";

    let sourceImageUrl = imgeUrl; //'https://res.cloudinary.com/dh5r8k5vs/image/upload/v1623038963/AppUploads/uubxdg8bi2knbihss9uy.jpg'

    setGlobalSpinner(true);
    axios({
      method: "post",
      url: uriBase,
      headers: {
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": subscriptionKey,
        "Content-Security-Policy": "self",
        "X-Content-Type-Options": "nosniff",
        "X-XSS-Protection": "1; mode=block",
      },
      data: JSON.stringify({ url: sourceImageUrl }),
    }).then((response) => {
      setGlobalSpinner(false);

      let operationLocation = response.headers["operation-location"];
      setGlobalSpinner(true);
      setTimeout(function () {
        axios({
          method: "GET",
          url: operationLocation,
          headers: {
            "Content-Type": "application/json",
            "Ocp-Apim-Subscription-Key": subscriptionKey,
            "Content-Security-Policy": "self",
            "X-Content-Type-Options": "nosniff",
            "X-XSS-Protection": "1; mode=block",
          },
        }).then((secondRes) => {
          setGlobalSpinner(false);
          setCameraStatus(false);
          var result = secondRes.data.analyzeResult.readResults[0].lines;

          SetShowOCRDataPopUp(secondRes.data.analyzeResult.readResults);
        });
      }, 10000);
    });
  }

  function imageUploadSuccessCallback(r) {
    //if (r && r.secure_url) {
      //processImage(r.secure_url);
      //console.log("r.secure_url ",r.secure_url);
      console.log("rdata123 ",r);
      if(window.cordova && r && r.secure_url){
        setProfileimageDataUrl(r.secure_url);
      }else{
        setProfileimageDataUrl([r]);
      }
      setGlobalSpinner(false);
      setCameraStatus(false)
      swal({
        title: t("Success"),
        text: t("Photo saved successfully"),
        icon: "success",
        button: t("Close"),
      })
    //}
  }

  function dataURLtoFile(dataurl, filename) {
    return new Promise((resolve, reject) => {
      try{
      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[arr.length - 1]), 
          n = bstr.length, 
          u8arr = new Uint8Array(n);
      while(n--){
          u8arr[n] = bstr.charCodeAt(n);
      }
      resolve(new File([u8arr], filename, {type:mime}))
    }catch(e){
      resolve(dataurl)
    }
  })
}

function dataURLtoBlob(capturedImageURI){
  return new Promise((resolve, reject) => {
  console.log("capturedImageURI ",capturedImageURI)
  window.resolveLocalFileSystemURL(capturedImageURI, function(fileEntry) {
    console.log("capturedImageURI ",capturedImageURI)
    fileEntry.file(function(file) {
      console.log("capturedImageURI ",capturedImageURI)
        var reader = new FileReader();
        reader.onloadend = function() {
          console.log("capturedImageURI ",capturedImageURI)
            var imageBinaryData = reader.result;
            console.log("capturedImageURI ",capturedImageURI,new Blob([imageBinaryData], { type: file.type }));
            resolve(new Blob([imageBinaryData], { type: file.type }))
            // var formData = new FormData();
            // formData.append('file', new Blob([imageBinaryData], { type: file.type }), 'captured_image.jpg');
            // promises.push(
            //   apiServices.postAPI("fileResources", formData).then((res) => {
            //     if (res.data) {
            //       return {
            //         attribute: objectKey,
            //         value: res.data.response.fileResource.id,
            //       };
            //     }
            //   }).catch((err) => {
            //     return {
            //       attribute: objectKey,
            //       value: imageValue,
            //     };
            //   })
            // );
        };
        reader.readAsArrayBuffer(file);
    });
}, function(error) {
  resolve(capturedImageURI)
    ///alert('Error accessing the captured image: ' + error.code);
});
});
}
async function handleTakePhoto(dataUri) {
    console.log("dataUri123 ",dataUri);
    setGlobalSpinner(true);
    if(window.cordova){
      setDataUri(dataUri);
      let imgurl = dataUri[0].fullPath
      if(window.cordova && window.cordova.platformId == 'ios'){
        imgurl = "file://"+dataUri[0].fullPath
      }
      console.log("imgurl ",imgurl)
      var blob = await dataURLtoBlob(imgurl)
      console.log("blob ",blob)
      imageUploadSuccessCallback(blob)
    }else{
      var file = await dataURLtoFile(dataUri,'profile.png')
      imageUploadSuccessCallback(file)
    }
  }

  function handleTakePhotoAnimationDone(dataUri) {
    // Do stuff with the photo...
    setDataUri(dataUri);
  }

  function handleCameraError(error) {
    console.log("camera error",error);
    setGlobalSpinner(false)
    setCameraStatus(false)
  }

  function handleCameraStart(stream) {
    console.log("camera start");
    setGlobalSpinner(false)
    document.body.classList.add("cameraon");
  }

  function handleCameraStop() {
    document.body.classList.remove("cameraon");
  }

  function updateOCRData(data) {
    const intialValueData = data;

    if (
      activeCaseFormData &&
      activeCaseFormData.data &&
      activeCaseFormData.data.formFormat
    ) {
      Object.keys(activeCaseFormData.data.formFormat).map((key) => {
        intialValueData[key] = activeCaseFormData.data.formFormat[key];
      });
    }

    const activeCaseFormData1 = {
      data: {
        formFormat: intialValueData, //valueForFormInput,
        dhisFormat: null, //
      },
    };

    OfflineDb.setDataIntoPouchDB("activeCaseFormData", activeCaseFormData1);
    setActiveCaseFormData(activeCaseFormData1);
    handleCameraStop();
    setCameraStatus(false);
  }

  function customStageForIndex(stageId) {
    let flag = false;
    if (
      stageId == riskAssementStageId ||
      stageId == referralServiceStageId ||
      stageId == tbTretmentInitiationStageId ||
      stageId == adherenceTBStageId
    ) {
      flag = true;
    }
    return flag;
  }

  const handleChangeIndex = (index) => {
    setValue(index);
  };

  const updateInput = (input) => {
    try {
      const findIndexOfName =
        indexClientOriginalList &&
        indexClientOriginalList.headers &&
        indexClientOriginalList.headers.findIndex(
          (obj) => obj.name == firstNameId
        );
      setSearchInput(input);
      let filteredList = [];
      setGlobalSpinner(true);
      if (input && input.length >= 3) {
        indexClientOriginalList.rows.map(function (objectKey, index) {
          objectKey.map(function (data, j) {
            if (
              findIndexOfName == j &&
              data.toLowerCase().indexOf(input.toLowerCase()) > -1
            ) {
              filteredList.push(objectKey);
            }
          });
        });
        let headerEle = indexClientOriginalList.headers;
        let filterSearchArray = {
          headers: [],
          rows: [],
        };
        filterSearchArray.headers = headerEle;
        filterSearchArray.rows = filteredList;
        setIndexClientList(filterSearchArray);
        setGlobalSpinner(false);
      } else {
        if (input.length == 0) {
          let headerEle = indexClientOriginalList.headers;
          let filterSearchArray = {
            headers: [],
            rows: [],
          };
          filterSearchArray.headers = headerEle;
          filterSearchArray.rows = indexClientOriginalList.rows;
          setIndexClientList(filterSearchArray);
          setGlobalSpinner(false);
        } else {
          setGlobalSpinner(false);
        }
      }
    } catch (e) {
      setGlobalSpinner(false);
    }
  };

  const onEventSubmit = async (values) => {
    console.log("values ", values);
  };

  function resetEventDetails() {
    setCalendarEventPopup(null);
    setEventRecordedon(null);
    setDoseEventStatus(null);
    setReasonForMissedDose(null);
    setDoseTakenMedicines(null);
    setMissedDoseMedicines(null);
  }

  const customStageAccessFunc = (stage, initialvalues) => {
    if (!showCasesInRegistration) {
      if (stage.id !== historyscreeningStageId) {
        return false;
      }
    }

    if (stage.id == tbTestingStageId) {
      return false;
    }

    if (stage.id == tptIntiationStageId) {
      return false;
    }

    if (stage.id == transferInStageId) {
      return false;
    }

    // refertonextlevelsecondarytertiarycarecentregeneralcancers
    // refertonextlevelsecondarytertiarycarecentrechildhoodcancer
    // refertonextlevelsecondarytertiarycarecentrebreastcancer
    // referforfurtherinvestigationscervicalcancer
    // referforfurtherinvestigationsortreatment
    // referforfurtherinvestigationsdiabetes
    // referforfurtherinvestigationshypertensioncardiovasculardiseases

    // referraltohospitalstertiarycentersStageId

    // treatmentadherenceStageId
    // treatmentinitiationformStageId
    // diagnosisStageId
    // advancedinvestigationsStageId

    if (initialvalues) {
      if (
        initialvalues[
          refertonextlevelsecondarytertiarycarecentrebreastcancer
        ] == "Yes" ||
        initialvalues[
          refertonextlevelsecondarytertiarycarecentrechildhoodcancer
        ] == "Yes" ||
        initialvalues[
          refertonextlevelsecondarytertiarycarecentregeneralcancers
        ] == "Yes"
      ) {
        if (stage.id == referraltohospitalstertiarycentersStageId) {
          return true;
        }
        if (
          stage.id == treatmentadherenceStageId ||
          stage.id == treatmentinitiationformStageId ||
          stage.id == diagnosisStageId ||
          stage.id == advancedinvestigationsStageId
        ) {
          return false;
        }
      }

      if (
        initialvalues[
          referforfurtherinvestigationshypertensioncardiovasculardiseases
        ] == "Yes" ||
        initialvalues[referforfurtherinvestigationsdiabetes] == "Yes" ||
        initialvalues[referforfurtherinvestigationsortreatment] == "Yes" ||
        initialvalues[referforfurtherinvestigationscervicalcancer] == "Yes"
      ) {
        if (stage.id == referraltohospitalstertiarycentersStageId) {
          return false;
        }
        if (
          stage.id == treatmentadherenceStageId ||
          stage.id == treatmentinitiationformStageId ||
          stage.id == diagnosisStageId ||
          stage.id == advancedinvestigationsStageId
        ) {
          return true;
        }
      }
    }

    if (stage.id == referraltohospitalstertiarycentersStageId) {
      return false;
    }
    if (stage.id == treatmentadherenceStageId) {
      return false;
    }
    if (stage.id == treatmentinitiationformStageId) {
      return false;
    }
    if (stage.id == diagnosisStageId) {
      return false;
    }
    if (stage.id == advancedinvestigationsStageId) {
      return false;
    }

    if (stage.id == followupStageId) {
      return false;
    }

    return true;
  };

  return (
    <div className={classes.root}>
      {activeCaseDetails != null &&
      activeCaseFormData != null &&
      linkContactFlag != null &&
      trackentityInstanceDetails != null &&
      Configuration != null ? (
        <>
          {showOCRDataPopUp.length > 0 ? (
            <ImageDatahandle
              programData={programData}
              imageResult={showOCRDataPopUp}
              updateOCRData={updateOCRData}
            />
          ) : (
            <> </>
          )}
          <AppBar position="static" className="headersection">
            <Tabs
              value={value}
              onChange={handleChange}
              aria-label="simple tabs example"
              variant="scrollable"
              scrollButtons="auto"
            >
              {searchEnabled && navigator.onLine ? (
                Configuration.registrationForm.defaultTabOnSearchEnable.map(
                  (defaultTabs, index) => {
                    return (
                      <Tab
                        className={
                          props.stageInstanceID ||
                          (userrolename && userrolename == patientRole)
                            ? "hideTabs"
                            : ""
                        }
                        label={t(defaultTabs)}
                        {...a11yProps(index)}
                      />
                    );
                  }
                )
              ) : (
                <Tab
                  className={
                    props.stageInstanceID ||
                    (userrolename && userrolename == patientRole)
                      ? "hideTabs"
                      : ""
                  }
                  label={t("Registration")}
                  {...a11yProps(0)}
                />
              )}

              {programData.programs[0].programStages.map((stages, index) => {
                let checkAccess = stageAccessCheck(stages);
                let checkTabVisibility = checkTabs(stages);
                let initialValues = activeCaseFormData.data
                  ? activeCaseFormData.data.formFormat != null
                    ? activeCaseFormData.data.formFormat
                    : {}
                  : {};

                //let customStageAccess = customStageAccessFunc(stages, initialValues)

                if (
                  initialValues &&
                  initialValues[PresentlyOnAntiTBMedicationId] &&
                  initialValues[PresentlyOnAntiTBMedicationId] == "YES"
                ) {
                  checkAccess = true;
                }
                // Hide follow up stage from normal flow
                // if (stages.id == followupStageId) {
                //   checkAccess = false;
                // }
                /*code fore transfer module service*/
                if (props.stageInstanceID) {
                  checkAccess = false;
                  if (props.stageTabValue == index + stepIncrement) {
                    checkAccess = true;
                  }
                }

                if (addContactFlag) {
                  checkTabVisibility = false;
                }
                if (stages.id == "oTbaZad1ZvJ" || stages.id == "DDFbxxHkywS") {
                  if (
                    initialValues &&
                    initialValues[PresentlyOnAntiTBMedicationId] &&
                    initialValues[PresentlyOnAntiTBMedicationId] == "YES"
                  ) {
                    checkTabVisibility = true;
                  }
                }

                if (userrolename == patientRole) {
                  if (stages.id == adherenceStageId && !showStagesIds) {
                    checkTabVisibility = true;
                    checkAccess = true;
                  }

                  if (showStagesIds && showStagesIds.length > 0) {
                    showStagesIds.map((stageEle) => {
                      if (stages.id == stageEle) {
                        checkTabVisibility = true;
                        checkAccess = true;
                      }
                    });
                  }
                }

                //index case validation for stages
                if (programBoDetails && programBoDetails.isReferralWorkflow) {
                  // if(initialValues && initialValues[clientTypeID] == Configuration.ltbiLinkVariables.index){
                  //     checkTabVisibility = customStageForIndex(stages.id)
                  // }
                  // if(initialValues && initialValues[selectReferralServiceId] && initialValues[selectReferralServiceId] == tbTretmentInitiationStageId){
                  //     if(stages.id == tptIntiationStageId || stages.id == adherenceTPTStageId || stages.id == tptOutcometageId){
                  //         checkTabVisibility = false
                  //     }
                  // }
                }

                let showtab = false;
                if (checkAccess) {
                  showtab = true;
                  updatedStages.push(stages.id);
                }
                //for followup redirect
                if (showStagesIds && showStagesIds.length > 0) {
                  showStagesIds.map((ele) => {
                    if (ele == stages.id) {
                      showtab = true;
                    }
                  });

                  if (historyscreeningStageId == stages.id) {
                    showtab = false;
                  }
                }

                return (
                  <Tab
                    className={showtab ? "" : "hideTabs"}
                    label={getTranslatedLabels(stages)}
                    {...a11yProps(index + stepIncrement)}
                    disabled={
                      activeCaseDetails.data
                        ? checkTabVisibility
                          ? false
                          : true
                        : true
                    }
                  />
                );
              })}

              {/* <Tab
                className={props.stageInstanceID ? "" : ""}
                label={t("Summary")}
                {...a11yProps(
                  programData.programs[0].programStages.length + stepIncrement
                )}
                disabled={activeCaseDetails.data ? false : true}
              /> */}
              {/* <Tab className={(props.stageInstanceID || (activeCaseDetails && activeCaseDetails.data && activeCaseDetails.data.caseType) || (activeCaseFormData.data && activeCaseFormData.data.formFormat && activeCaseFormData.data.formFormat[clientTypeID]) && (activeCaseFormData.data.formFormat[clientTypeID] != Configuration.ltbiLinkVariables.contact && activeCaseFormData.data.formFormat[clientTypeID] != Configuration.ltbiLinkVariables.index)) ? 'hideTabs' : ''} label={t('Link')} {...a11yProps(programData.programs[0].programStages.length + stepIncrement)} disabled={activeCaseDetails.data ? false : true} /> */}
            </Tabs>
          </AppBar>
          {/* <> <Button className="regSearchCancelButton" onClick={() => setCameraStatus(true)}>{t('OCR')}</Button> </> */}
          {searchEnabled && navigator.onLine ? (
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              onChangeIndex={handleChangeIndex}
              disabled={
                activeCaseDetails &&
                activeCaseDetails.data &&
                userrolename &&
                userrolename != patientRole
                  ? false
                  : true
              }
            >
              <TabPanel value={value} index={0} dir={theme.direction}>
                {createSearchForm(programData)}
              </TabPanel>
              <TabPanel value={value} index={1} dir={theme.direction}>
                <div className="under-swipeable">
                  {createRegistrationForm(
                    programData,
                    programRules,
                    programRulesVariables
                  )}
                </div>
              </TabPanel>
              {programData.programs[0].programStages.map((stages, index) => {
                return (
                  <TabPanel
                    value={value}
                    index={index + stepIncrement}
                    dir={theme.direction}
                  >
                    {createStageForms(stages, index + stepIncrement)}
                  </TabPanel>
                );
              })}
            </SwipeableViews>
          ) : (
            // <>
            //     <TabPanel value={value} index={0} dir={theme.direction}>
            //         {createSearchForm(programData)}
            //     </TabPanel>
            //     <TabPanel value={value} index={1} dir={theme.direction}>
            //         {createRegistrationForm(programData, programRules, programRulesVariables)}
            //     </TabPanel>
            //     {programData.programs[0].programStages.map((stages, index) => {
            //         return <TabPanel value={value} index={index + stepIncrement} dir={theme.direction}>
            //             {createStageForms(stages, index + stepIncrement)}
            //         </TabPanel>
            //     })}
            // </>
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              onChangeIndex={handleChangeIndex}
              disabled={
                activeCaseDetails &&
                activeCaseDetails.data &&
                userrolename &&
                userrolename != patientRole
                  ? false
                  : true
              }
              //enableMouseEvents={true}
              //nestedScrollEnabled={true}
              //ignoreNativeScroll={true}
            >
              <TabPanel value={value} index={0} dir={theme.direction}>
                {createRegistrationForm(
                  programData,
                  programRules,
                  programRulesVariables
                )}
              </TabPanel>
              {programData.programs[0].programStages.map((stages, index) => {
                return (
                  <TabPanel
                    value={value}
                    index={index + stepIncrement}
                    dir={theme.direction}
                  >
                    {createStageForms(stages, index + stepIncrement)}
                  </TabPanel>
                );
              })}
            </SwipeableViews>
          )}
          {/* <TabPanel
            value={value}
            index={programData.programs[0].programStages.length + stepIncrement}
            dir={theme.direction}
          >
            {createSummaryPage()}
          </TabPanel> */}
        </>
      ) : (
        <> </>
      )}

      {searchResponse != null ? (
        <div className="modaloverlay">
          <div className="modalcardholder">
            <Card className="modalcard">
              <CardHeader
                className="modalheader"
                action={
                  <IconButton aria-label="close">
                    <CloseIcon onClick={() => setSearchResponse(null)} />
                  </IconButton>
                }
                title={
                  searchResponse.length > 0 ? "Match found" : "No Match found"
                }
              />
              <CardContent className="modalbodycontent">
                <Grid container spacing={3}>
                  {searchResponse != null ? (
                    searchResponse.map((row) => {
                      return (
                        <CustomeCaseCard
                          row={row}
                          searchHeader={searchHeader}
                          viewType={"card"}
                          parentPage={"registration"}
                          hideOptions={"false"}
                        ></CustomeCaseCard>
                      );
                    })
                  ) : (
                    <> </>
                  )}
                </Grid>
                <Typography className="modaltext modalinfo" gutterBottom>
                  {t("Click Continue to register New client")}
                </Typography>
              </CardContent>

              <CardActions className="modalfooter">
                <Button
                  className="regSearchCancelButton"
                  onClick={() => setSearchResponse(null)}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  className="modalactionbtn"
                  onClick={() => postSearchSubmit()}
                >
                  {t("Continue")}
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      ) : (
        <> </>
      )}

      {/* {openCamera && dataUri == "" ? (
        <Camera
          onTakePhoto={(dataUri) => {
            handleTakePhoto(dataUri);
          }}
          onTakePhotoAnimationDone={(dataUri) => {
            handleTakePhotoAnimationDone(dataUri);
          }}
          onCameraError={(error) => {
            handleCameraError(error);
          }}
          idealFacingMode={FACING_MODES.ENVIRONMENT}
          idealResolution={{ width: 100, height: 100 }}
          imageType={IMAGE_TYPES.JPG}
          imageCompression={0.97}
          isMaxResolution={true}
          isImageMirror={false}
          isSilentMode={false}
          isDisplayStartCameraError={true}
          isFullscreen={false}
          sizeFactor={1}
          onCameraStart={(stream) => {
            handleCameraStart(stream);
          }}
          onCameraStop={() => {
            handleCameraStop();
          }}
        />
      ) : (
        <> </>
      )} */}
      {openCamera && dataUri == "" ? (
        window.cordova ? 
        (
          // navigator.camera.getPicture(handleTakePhoto, handleCameraError, {
          //   quality: 60,
          //   correctOrientation: true,
          //   destinationType: navigator.camera.DestinationType.DATA_URL,
          // })
          navigator.device.capture.captureImage(handleTakePhoto, handleCameraError, { limit: 1 })
        ) : (
          <Camera
            onTakePhoto={(dataUri) => {
              handleTakePhoto(dataUri);
            }}
            onTakePhotoAnimationDone={(dataUri) => {
              handleTakePhotoAnimationDone(dataUri);
            }}
            onCameraError={(error) => {
              handleCameraError(error);
            }}
            idealFacingMode={FACING_MODES.ENVIRONMENT}
            idealResolution={{ width: 100, height: 100 }}
            imageType={IMAGE_TYPES.JPG}
            imageCompression={0.97}
            isMaxResolution={true}
            isImageMirror={false}
            isSilentMode={false}
            isDisplayStartCameraError={true}
            isFullscreen={false}
            sizeFactor={1}
            onCameraStart={(stream) => {
              handleCameraStart(stream);
            }}
            onCameraStop={() => {
              handleCameraStop();
            }}
          />
        )
      ) : (
        <> </>
      )}

      {imageResponse != null ? (
        <>
          <div className="modaloverlay">
            <div className="modalcardholder">
              <Card className="modalcard">
                <CardHeader
                  className="modalheader"
                  action={
                    <IconButton aria-label="close">
                      <CloseIcon onClick={() => setImageResponse(null)} />
                    </IconButton>
                  }
                  title={"Image"}
                />
                <CardContent className="modalbodycontent">
                  <Grid container spacing={3}>
                    <img
                      style={{ width: "inherit" }}
                      className="blob-to-image"
                      src={imageResponse}
                    ></img>
                  </Grid>
                </CardContent>
              </Card>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      {indexClientList ? (
        <div className="modaloverlay">
          <div className="modalcardholder">
            <Card className="modalcard">
              <CardHeader
                className="modalheader"
                action={
                  <IconButton aria-label="close">
                    <CloseIcon onClick={() => setIndexClientList(null)} />
                  </IconButton>
                }
                title={t("Attach Index")}
              />
              <CardContent className="modalbodycontent">
                <Grid container spacing={3}>
                  <SearchBar input={searchInput} setKeyword={updateInput} />
                </Grid>
                <Grid container spacing={3}>
                  {renderIndexClientList()}
                </Grid>
              </CardContent>

              <CardActions className="modalfooter">
                <Button
                  className="regSearchCancelButton"
                  onClick={() => setIndexClientList(null)}
                >
                  {t("Cancel")}
                </Button>
                <Button
                  className="modalactionbtn"
                  onClick={() => attachIndexSubmit()}
                >
                  {t("Submit")}
                </Button>
              </CardActions>
            </Card>
          </div>
        </div>
      ) : (
        <></>
      )}

      {calendarEventPopup != null ? (
        <>
          <div className="modaloverlay">
            <div className="modalcardholder">
              <Card className="modalcard">
                <CardHeader
                  className="modalheader"
                  action={
                    <IconButton aria-label="close">
                      <CloseIcon onClick={() => resetEventDetails()} />
                    </IconButton>
                  }
                  title={"Event Details"}
                />
                <CardContent className="modalbodycontent">
                  <Grid container spacing={3}>
                    <Grid item xs={12}>
                      <b>{t("Event")}</b> :{" "}
                      {doseEventStatus ? t(doseEventStatus) : ""}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={
                        doseEventStatus &&
                        doseEventStatus == "Partially dose taken" &&
                        doseTakenMedicines &&
                        doseTakenMedicines
                          ? ""
                          : "hide"
                      }
                    >
                      <b>{t("Dose Taken Medicines")}</b> :{" "}
                      {doseTakenMedicines ? t(doseTakenMedicines) : ""}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={
                        doseEventStatus &&
                        doseEventStatus == "Partially dose taken" &&
                        missedDoseMedicines &&
                        missedDoseMedicines
                          ? ""
                          : "hide"
                      }
                    >
                      <b>{t("Missed Dose Medicines")}</b> :{" "}
                      {missedDoseMedicines ? t(missedDoseMedicines) : ""}
                    </Grid>
                    <Grid item xs={12}>
                      <b>{t("Event recorded on")}</b> :{" "}
                      {eventRecordedon ? eventRecordedon : ""}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      className={
                        reasonForMissedDose && reasonForMissedDoseID
                          ? ""
                          : "hide"
                      }
                    >
                      <b>{t("Reason for missed dose")}</b> :{" "}
                      {reasonForMissedDose ? t(reasonForMissedDose) : ""}
                    </Grid>
                  </Grid>
                </CardContent>
              </Card>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}

      {openEventPopup != null ? (
        <>
          <div className="modaloverlay eventpopup">
            <div className="modalcardholder">
              <Card className="modalcard">
                <CardHeader
                  className="modalheader"
                  action={
                    <IconButton aria-label="close">
                      <CloseIcon onClick={() => setOpenEventPopup(null)} />
                    </IconButton>
                  }
                  title={t("Medication Adherence")}
                />
                <Form
                  onSubmit={onEventSubmit}
                  //initialValues={{ stooge: 'larry', employed: false }}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <CardContent className="modalbodycontent">
                        <Grid
                          container
                          spacing={3}
                          className=""
                          style={{ padding: "10px" }}
                        >
                          <Grid xs={12} md={12}>
                            <label class="MuiFormLabel-root">
                              {medicineTakenDateBO
                                ? getTranslatedDataElementLabels(
                                    medicineTakenDateBO
                                  )
                                : t("Selected Date")}
                            </label>
                            <TextField
                              hiddenLabel
                              name={"medicine-date"}
                              id="medicine-date"
                              defaultValue={
                                CalendarSelectedDate ? CalendarSelectedDate : ""
                              }
                              value={
                                CalendarSelectedDate ? CalendarSelectedDate : ""
                              }
                              //variant="filled"
                              size="small"
                              disabled
                            />
                          </Grid>
                          <Grid container xs={12} md={12}>
                            <Grid
                              xs={6}
                              md={4}
                              className={
                                MedicineTakenRadioValue &&
                                MedicineTakenRadioValue.toLowerCase() == "yes"
                                  ? "medicine-event-btn select-Yes"
                                  : "medicine-event-btn"
                              }
                            >
                              <Button
                                className="green"
                                onClick={() => setMedicineTakenValue("Yes")}
                              >
                                {t("Dose Taken")}
                              </Button>
                            </Grid>
                            <Grid
                              xs={6}
                              md={4}
                              className={
                                MedicineTakenRadioValue &&
                                MedicineTakenRadioValue.toLowerCase() == "no"
                                  ? "medicine-event-btn select-No"
                                  : "medicine-event-btn"
                              }
                            >
                              <Button
                                className="red"
                                onClick={() => setMedicineTakenValue("No")}
                              >
                                {t("Missed Dose")}
                              </Button>
                            </Grid>
                          </Grid>
                          <Grid
                            xs={12}
                            md={12}
                            className={
                              MedicineTakenRadioValue &&
                              MedicineTakenRadioValue.toLowerCase() == "no"
                                ? ""
                                : "hide"
                            }
                          >
                            {programData && programData.programs ? (
                              programData.programs[0].programStages.find(
                                (obj) => obj.id == adherenceStageId
                              ) ? (
                                //renderStageBySection(programData.programs[0].programStages.find(obj => obj.id == adherenceStageId),{},{},{},{})
                                programData.programs[0].programStages
                                  .find((obj) => obj.id == adherenceStageId)
                                  .programStageDataElements.map((fields) => {
                                    if (
                                      fields.dataElement &&
                                      fields.dataElement.id !=
                                        reasonForMissedDoseID
                                    ) {
                                      return;
                                    } else {
                                      return renderStageField(
                                        fields,
                                        {},
                                        {},
                                        programData.programs[0].programStages.find(
                                          (obj) => obj.id == adherenceStageId
                                        ).programStageDataElements,
                                        programData.programs[0].programStages.find(
                                          (obj) => obj.id == adherenceStageId
                                        )
                                      );
                                    }
                                  })
                              ) : (
                                <></>
                              )
                            ) : (
                              <></>
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                      <CardActions className="modalfooter">
                        <Button
                          className="regSearchCancelButton"
                          onClick={() => setOpenEventPopup(null)}
                        >
                          {t("Cancel")}
                        </Button>
                        <Button
                          className="modalactionbtn"
                          onClick={() => submitMedicineStatusEvent(values)}
                        >
                          {t("Add")}
                        </Button>
                      </CardActions>
                    </form>
                  )}
                />
              </Card>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
      {openMedicineListEventPopup != null ? (
        <>
          <div className="modaloverlay eventpopup">
            <div className="modalcardholder">
              <Card className="modalcard">
                <CardHeader
                  className="modalheader"
                  action={
                    <IconButton aria-label="close">
                      <CloseIcon
                        onClick={() => setOpenMedicineListEventPopup(null)}
                      />
                    </IconButton>
                  }
                  title={t("Medication Adherence")}
                />
                <Form
                  onSubmit={onEventSubmit}
                  //initialValues={{ stooge: 'larry', employed: false }}
                  render={({
                    handleSubmit,
                    form,
                    submitting,
                    pristine,
                    values,
                  }) => (
                    <form onSubmit={handleSubmit}>
                      <CardContent className="modalbodycontent">
                        <Grid
                          container
                          spacing={3}
                          className=""
                          style={{ padding: "10px" }}
                        >
                          <Grid xs={12} md={12}>
                            <label class="MuiFormLabel-root">
                              {medicineTakenDateBO
                                ? getTranslatedDataElementLabels(
                                    medicineTakenDateBO
                                  )
                                : t("Selected Date")}
                            </label>
                            <TextField
                              hiddenLabel
                              name={"medicine-date"}
                              id="medicine-date"
                              defaultValue={
                                CalendarSelectedDate ? CalendarSelectedDate : ""
                              }
                              value={
                                CalendarSelectedDate ? CalendarSelectedDate : ""
                              }
                              //variant="filled"
                              size="small"
                              disabled
                            />
                          </Grid>

                          <Grid
                            container
                            spacing={3}
                            style={{ marginTop: "10px", marginBottom: "10px" }}
                          >
                            {medicineTable &&
                              medicineTable.length > 0 &&
                              medicineTable.map((med) => {
                                return (
                                  <Grid
                                    container
                                    spacing={3}
                                    className="ml-10px mr-10px mt-10px mb-10px bg-lightgrey"
                                    component={Paper}
                                  >
                                    <Grid
                                      item
                                      xs={6}
                                      lg={6}
                                      className={
                                        localStorage.getItem("fontSize")
                                          ? "align-items-center FS" +
                                            localStorage.getItem("fontSize")
                                          : "align-items-center"
                                      }
                                    >
                                      <span>{med.medicine.displayName}</span>
                                      {/*JSON.stringify(med)*/}
                                    </Grid>
                                    <Grid
                                      item
                                      xs={6}
                                      lg={6}
                                      className={
                                        localStorage.getItem("fontSize")
                                          ? "formradioholder FS" +
                                            localStorage.getItem("fontSize")
                                          : "formradioholder"
                                      }
                                    >
                                      {/* <Formradio></Formradio> */}

                                      <FormControl component="fieldset">
                                        <RadioGroup
                                          row
                                          aria-label="gender"
                                          name={med.medicine.code}
                                          value={
                                            radioValue &&
                                            radioValue[med.medicine.code]
                                              ? radioValue[med.medicine.code]
                                              : "yes"
                                          }
                                          onChange={(env) =>
                                            handleMedicineTakenRadioChange(
                                              env,
                                              value,
                                              med.medicine.code
                                            )
                                          }
                                        >
                                          <FormControlLabel
                                            value="yes"
                                            control={<Radio />}
                                            label={t("Yes")}
                                          />
                                          <FormControlLabel
                                            value="no"
                                            control={<Radio />}
                                            label={t("No")}
                                          />
                                        </RadioGroup>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                );
                              })}
                          </Grid>
                          <Grid
                            xs={12}
                            md={12}
                            className={
                              radioValue &&
                              _.isObject(radioValue) &&
                              _.values(radioValue) &&
                              _.values(radioValue).includes("no")
                                ? ""
                                : "hide"
                            }
                          >
                            {programData && programData.programs ? (
                              programData.programs[0].programStages.find(
                                (obj) => obj.id == adherenceStageId
                              ) ? (
                                //renderStageBySection(programData.programs[0].programStages.find(obj => obj.id == adherenceStageId),{},{},{},{})
                                programData.programs[0].programStages
                                  .find((obj) => obj.id == adherenceStageId)
                                  .programStageDataElements.map((fields) => {
                                    if (
                                      fields.dataElement &&
                                      fields.dataElement.id !=
                                        reasonForMissedDoseID
                                    ) {
                                      return;
                                    } else {
                                      return renderStageField(
                                        fields,
                                        values,
                                        {},
                                        programData.programs[0].programStages.find(
                                          (obj) => obj.id == adherenceStageId
                                        ).programStageDataElements,
                                        programData.programs[0].programStages.find(
                                          (obj) => obj.id == adherenceStageId
                                        )
                                      );
                                    }
                                  })
                              ) : (
                                <></>
                              )
                            ) : (
                              <></>
                            )}
                          </Grid>
                        </Grid>
                      </CardContent>
                      <CardActions className="modalfooter">
                        <Button
                          className="regSearchCancelButton"
                          onClick={() => setOpenMedicineListEventPopup(null)}
                        >
                          {t("Cancel")}
                        </Button>
                        <Button
                          className="modalactionbtn"
                          onClick={() => submitMedicineListEventPopup(values)}
                        >
                          {t("Add")}
                        </Button>
                      </CardActions>
                    </form>
                  )}
                />
              </Card>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}

//export default SimpleTabs
function mapStateToProps(state) {
  const { storeState } = state;
  return {
    selectTrackedEnityInstanceId: storeState.selectTrackedEnityInstanceId,
  };
}

export default connect(mapStateToProps, {})(SimpleTabs);
